// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "Keni harruar fjalëkalimin?",
   "forgot-password-description":
      "Vendosni email-in tuaj më poshtë për të marrë një kod verifikimi dhe për të rikuperuar fjalëkalimin tuaj",
   email: "Email",
   cancel: "Anulo",
   submit: "Dërgo",
   "menu-section-stakeholders": "Palët e interesuara",
   "menu-section-setup": "Konfigurimi",
   "menu-section-implementation": "Zbatimi",
   "menu-section-support": "Mbështetja",
   "menu-item-experts": "Ekspertët",
   "menu-item-approvers": "Aprovuesit",
   "menu-item-organizations": "Organizatat",
   "menu-item-requests": "Kërkesat",
   "menu-item-assessments": "Vlerësimet",
   "menu-item-modules": "Modulet",
   "menu-item-targets": "Objektivat",
   "menu-item-workspaces": "Hapësirat e punës",
   "menu-item-tickets": "Tiketat",
   "menu-section-organization-management": "Menaxhimi i organizatës",
   "menu-section-my-account": "Llogaria ime",
   "menu-item-profile": "Profili",
   "menu-item-team": "Ekipi",
   "menu-item-help-desk": "Ndihma",

   name: "Emri",
   country: "Shteti",
   "phone-number": "Numri i telefonit",
   expertise: "Ekspertiza",
   "disabled-reason": "Arsyeja e çaktivizimit",
   "not-applicable": "N/A",
   export: "Eksporto",
   "status-pending": "Në pritje",
   "status-rejected": "Refuzuar",
   "status-active": "Aktiv",
   "status-disabled": "Çaktivizuar",

   "experts-management-title": "Ekspertët",
   "experts-request-tab": "Kërkesa për ekspert",
   "experts-approved-tab": "Ekspertë të aprovuar",
   "experts-deleted-button": "Ekspertë të fshirë",
   "experts-status-deactivated": "Çaktivizuar",

   "filter-search-label": "Çfarë po kërkoni?",
   "search-placeholder": "Kërko",
   "search-by-name-placeholder": "Kërko sipas emrit",
   "search-task-by-name-placeholder": "Kërko një detyrë sipas emrit të saj",
   "search-module-by-name-placeholder": "Kërko një modul sipas emrit të tij",
   "search-workspace-by-name-placeholder": "Kërko një hapësirë pune sipas emrit të saj",
   "search-assessment-by-name-placeholder": "Kërko një vlerësim sipas emrit të tij",
   "search-expert-by-name-placeholder": "Kërko një ekspert sipas emrit të tij",
   "search-request-by-name-placeholder": "Kërko një kërkesë sipas emrit të organizatës kërkuese",
   "search-request-by-email-placeholder": "Kërko një kërkesë sipas email-it të organizatës kërkuese",
   "search-request-by-name-or-email-placeholder": "Kërko sipas emrit ose email-it",
   "search-invoice-by-name-placeholder": "Kërko një faturë sipas emrit të saj",
   "search-organization-by-name-placeholder": "Kërko një organizatë sipas emrit të saj",
   "filter-by-type-placeholder": "Filtro sipas llojit",
   "filter-by-start-date-placeholder": "Filtro sipas datës së fillimit",
   "filter-by-end-date-placeholder": "Filtro sipas datës së përfundimit",
   "filter-by-year-placeholder": "Filtro sipas vitit",
   "filter-tasks-by-assigned-member-placeholder": "Filtro detyrat sipas anëtarit të caktuar",
   "filter-tasks-by-status-placeholder": "Filtro detyrat sipas statusit",
   "filter-workspace-request-by-status-placeholder": "Filtro kërkesën për hapësirë pune sipas statusit",
   "filter-workspace-by-country-placeholder": "Filtro hapësirat e punës sipas shtetit",
   "filter-experts-by-country-placeholder": "Filtro ekspertët sipas shtetit",
   "filter-by-submission-date-placeholder": "Filtro sipas datës së dorëzimit",
   "filter-by-assessments-placeholder": "Filtro sipas vlerësimeve",
   "filter-by-assessment-placeholder": "Filtro sipas vlerësimit",
   "filter-by-workspace-placeholder": "Filtro sipas hapësirës së punës",
   "filter-by-score-placeholder": "Filtro sipas rezultatit",
   "filter-by-country-placeholder": "Filtro sipas shtetit",
   "filter-by-operating-countries-placeholder": "Filtro sipas shteteve ku operon",
   "filter-by-sectors-placeholder": "Filtro sipas sektorëve",
   "export-organizations-button": "Eksporto organizatat",
   "filter-by-module-placeholder": "Filtro sipas modulit",
   "filter-by-round-placeholder": "Filtro sipas raundit",
   "filter-by-section-placeholder": "Filtro sipas seksionit",
   "filter-by-owner-placeholder": "Filtro sipas pronarit",
   "search-by-its-name-placeholder": "Kërko sipas emrit",
   "guided-assessment": "Vlerësim i Udhëhequr",
   "self-assessment": "Vetëvlerësim",
   "clear-all-button": "Pastro të gjitha",
   "filters-button": "Filtrat",
   workspace: "Hapësira e punës",
   assessment: "Vlerësimi",
   score: "Rezultati",
   city: "Qyteti",
   "operating-countries": "Shtetet ku operon",
   sectors: "Sektorët",
   type: "Lloji",
   organizations: "Organizatat",
   "select-workspace-placeholder": "Zgjidhni hapësirën e punës",
   "select-assessment-placeholder": "Zgjidhni vlerësimin",
   "select-score-range-placeholder": "Zgjidhni intervalin e rezultatit",
   "select-country-placeholder": "Zgjidhni shtetin",
   "select-base-city-placeholder": "Zgjidhni qytetin tuaj bazë",
   "select-sectors-placeholder": "Zgjidhni sektorët",
   "select-type-placeholder": "Zgjidhni llojin",

   "toast-oops-title": "Oops! Ndodhi një problem!",
   "toast-request-accepted-success-title": "Kërkesa u pranua me sukses!",
   "toast-request-accepted-success-description":
      "Kjo kërkesë u pranua me sukses, përgjigja do t'i njoftohet përdoruesit kërkues.",
   "toast-request-accept-error-description":
      "Patëm një problem gjatë pranimit të kësaj kërkese, ju lutemi provoni përsëri.",
   "toast-request-rejected-success-title": "Kërkesa u refuzua me sukses!",
   "toast-request-rejected-success-description":
      "Kjo kërkesë u refuzua me sukses, përgjigja do t'i njoftohet përdoruesit kërkues.",
   "toast-request-reject-error-description":
      "Patëm një problem gjatë refuzimit të kësaj kërkese, ju lutemi provoni përsëri.",
   "toast-requests-accepted-success-title": "Kërkesat u pranuan me sukses!",
   "toast-requests-accepted-success-description":
      "Kërkesat u pranuan me sukses, përgjigja do t'u njoftohet përdoruesve kërkues.",
   "toast-requests-accept-error-description":
      "Patëm një problem gjatë pranimit të këtyre kërkesave, ju lutemi provoni përsëri.",
   "toast-requests-rejected-success-title": "Kërkesat u refuzuan me sukses!",
   "toast-requests-rejected-success-description":
      "Kërkesat u refuzuan me sukses, përgjigja do t'u njoftohet përdoruesve kërkues.",
   "toast-requests-reject-error-description":
      "Patëm një problem gjatë refuzimit të këtyre kërkesave, ju lutemi provoni përsëri.",
   "approve-all-button": "Aprovo të gjitha",
   "reject-all-button": "Refuzo të gjitha",

   "search-target-placeholder": "Kërko një objektiv sipas emrit të vlerësimit ose modulit",
   "show-active-rounds-checkbox": "Shfaq rrethet aktive",

   "general-score-column": "Rezultati i përgjithshëm",
   "submissions-column": "Dorëzimet",
   "tasks-column": "Detyrat",
   "areas-complete-text": "fusha të përfunduara",
   "organizations-progress-summary-title": "Përmbledhja e progresit të organizatave",
   "export-progress-summary-button": "Eksporto Përmbledhjen e Progresit",
   "select-module-performance-label": "Zgjidhni modulin për të parë performancën e organizatave",
   "all-modules-placeholder": "Të gjitha modulet",

   "registration-request-tab": "Kërkesë për regjistrim",
   "workspace-request-tab": "Kërkesë për hapësirë pune",
   "assessment-request-tab": "Kërkesë për vlerësim",
   "status-approved": "Aprovuar",
   "requesting-user-column": "Përdoruesi kërkues",
   "request-date-column": "Data e kërkesës",
   "approval-date-column": "Data e aprovimit",
   "processed-by-column": "Përpunuar nga",
   "workspace-name-column": "Emri i hapësirës së punës",
   "assessment-name-column": "Emri i vlerësimit",
   "consultant-name-column": "Emri i konsulentit",
   "rejection-date-column": "Data e refuzimit",
   "accept-request-title": "Prano Kërkesën",
   "accept-request-button": "Prano kërkesën",
   "accept-request-description": "Jeni duke pranuar këtë kërkesë. Ky veprim nuk mund të zhbëhet.",
   "reject-request": "Refuzo kërkesën",
   "reject-request-description": "Jeni duke refuzuar këtë kërkesë. Ky veprim nuk mund të zhbëhet.",
   "confirm-continue-text": "Jeni i sigurt që doni të vazhdoni?",
   "reject-button": "Refuzo",
   "approve-button": "Aprovo",
   "organization-request-title": "Kërkesa e Organizatës",
   "foundation-label": "Themelimi",
   "address-label": "Adresa",
   "organization-sectors-label": "Sektorët e Organizatës",
   "organization-type-label": "Lloji i Organizatës",
   "organization-size-label": "Madhësia e Organizatës",
   "organization-name-label": "Emri i organizatës",
   "organization-description-label": "Përshkrimi i organizatës",

   "organization-deleted-success-title": "Organizata u fshi me sukses!",
   "organization-deleted-success-description": "Kjo organizatë u fshi me sukses.",
   "organization-delete-error-description":
      "Patëm një problem gjatë fshirjes së kësaj organizate, ju lutemi provoni përsëri.",
   "organization-restored-success-title": "Organizata u rikthye me sukses!",
   "organization-restored-success-description": "Kjo organizatë u rikthye me sukses.",
   "organization-restore-error-description":
      "Patëm një problem gjatë çaktivizimit të kësaj organizate, ju lutemi provoni përsëri.",
   "organization-restore-failed-error-description":
      "Kishim një problem në rikthimin e kësaj organizate, ju lutemi provoni përsëri.",
   "organization-disabled-success-title": "Organizata u çaktivizua me sukses!",
   "organization-disabled-success-description": "Kjo organizatë u çaktivizua me sukses.",
   "disable-organization-title": "Çaktivizo organizatën",
   "disable-organization-description-text":
      "Jeni gati të çaktivizoni këtë organizatë. Ajo do të kalojë në listën e organizatave të çaktivizuara derisa të rikthehet.",
   "reason-for-disabling-label": "Arsyeja e çaktivizimit",
   "disable-organization-reason-placeholder":
      "Ju lutemi shkruani arsyen e çaktivizimit të kësaj organizate",
   "disable-button": "Çaktivizo",
   "restore-organization-title": "Rikthe organizatën",
   "registration-date-column": "Data e regjistrimit",
   "organization-list-title": "Lista e organizatave",
   "enroll-organizations-button": "Regjistro në një hapësirë tjetër pune",
   "registered-organizations-label": "Organizata të regjistruara",
   "average-score-label": "Rezultati mesatar",
   "registered-as-of-text": "Regjistruar më",
   "social-networks-title": "Rrjetet Sociale",
   "offices-title": "Zyrat",
   "ongoing-projects-label": "Projektet në vazhdim",
   "members-label": "Anëtarët",
   "representative-label": "Përfaqësuesi",
   "representative-name-label": "Emri i përfaqësuesit",
   "representative-title-label": "Titulli i përfaqësuesit",
   "representative-location-label": "Vendndodhja e përfaqësuesit",
   "representative-phone-label": "Telefoni i përfaqësuesit",
   "representative-skype-label": "Skype i përfaqësuesit",
   "representative-email-label": "Email i përfaqësuesit",

   "workspace-required-validation": "Hapësira e punës është e detyrueshme",
   "organizations-enrolled-success-title": "Organizatat u regjistruan me sukses!",
   "organizations-enrolled-success-description":
      "Këto organizata u regjistruan me sukses në hapësirën e punës që zgjodhët.",
   "organizations-enroll-error-description":
      "Patëm një problem gjatë regjistrimit të këtyre organizatave, ju lutemi provoni përsëri.",
   "enroll-organization-modal-title": "Regjistro organizatën në një hapësirë tjetër pune",
   "select-workspace-to-enroll-label": "Zgjidhni hapësirën e punës për të regjistruar organizatat",
   "confirm-button": "Konfirmo",
   "delete-button": "Fshi",
   "delete-organization-title": "Fshi organizatën",
   "delete-organization-description":
      "Jeni duke fshirë këtë organizatë. Ky veprim nuk mund të zhbëhet.",

   "update-successful-message": "Përditësimi ishte i suksesshëm",
   "max-50-symbols-validation": "Maksimumi 50 simbole",
   "min-3-symbols-validation": "Minimumi 3 simbole",
   "invalid-email-validation": "Email i pavlefshëm",
   "required-validation": "E detyrueshme",
   "edit-organization-details-title": "Modifiko detajet e organizatës",
   "project-number-title": "Numri i projektit",
   "ongoing-project-number-label": "Numri i projekteve në vazhdim",
   "social-label": "Rrjetet Sociale",
   "website-label": "Faqja e internetit",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "Kthehu",
   "update-button": "Përditëso",

   "representative-removed-success-title": "Detajet e përfaqësuesit u hoqën me sukses!",
   "representative-removed-success-description": "Informacioni i detajeve të përfaqësuesit tuaj u hoq.",
   "representative-remove-error-description":
      "Patëm një problem gjatë heqjes së informacionit të detajeve të përfaqësuesit, ju lutemi provoni përsëri.",
   "profile-status-changed-title": "Statusi i profilit tuaj u ndryshua!",
   "profile-status-changed-description": "Statusi i profilit tuaj u ndryshua me sukses.",
   "profile-status-change-error-description":
      "Patëm një problem gjatë ndryshimit të statusit të profilit, ju lutemi provoni përsëri.",
   "go-back-to-organizations-link": "Kthehu te organizatat",
   "print-profile-button": "Printo profilin",
   "make-profile-public-button": "Bëje profilin publik",
   "make-profile-private-button": "Bëje profilin privat",
   "complete-profile-reminder-title": "Mos harroni të plotësoni profilin tuaj!",
   "complete-profile-reminder-description":
      "Maksimizoni dukshmërinë tuaj brenda komunitetit përmes një profili të plotë dhe duke e bërë atë publik.",
   "complete-profile-now-button": "Plotëso profilin tani",
   "profile-status-label": "Statusi i profilit",
   "private-status": "Privat",
   "public-status": "Publik",
   "organization-email-label": "Email i organizatës",
   "base-country-label": "Shteti bazë",
   "zip-code-label": "Kodi postar",
   "about-label": "Rreth",
   "foundation-date-label": "Data e themelimit",
   "organizations-size-label": "Madhësia e organizatave",
   "countries-where-operate-label": "Shtetet ku operon organizata",
   "sector-that-works-label": "Sektori në të cilin punon organizata",
   "representative-details-title": "Detajet e përfaqësuesit",
   "delete-all-representative-info-button": "Fshi të gjithë informacionin e përfaqësuesit",
   "add-representative-details-button": "Shto detajet e përfaqësuesit",
   "no-information-available-text": "Nuk ka informacion të disponueshëm",
   "location-label": "Vendndodhja",
   "edit-representative-details-button": "Modifiko detajet e përfaqësuesit",
   "assessments-scores-title": "Rezultatet e vlerësimeve",
   "assessments-scores-description": "Shikoni rezultatet e kësaj organizate në vlerësimet e përfunduara.",
   "select-self-assessment-placeholder": "Zgjidhni vetëvlerësimin",
   "no-self-assessment-yet-title": "Ende nuk ka vetëvlerësim",
   "no-self-assessment-yet-description": "Kjo organizatë nuk ka përfunduar ende një vetëvlerësim",
   "select-guided-assessment-placeholder": "Zgjidhni vlerësimin e udhëhequr",
   "no-guided-assessment-yet-title": "Ende nuk ka vlerësim të udhëhequr",
   "no-guided-assessment-yet-description":
      "Kjo organizatë nuk ka përfunduar ende një vlerësim të udhëhequr",
   "team-member-list-title": "Lista e anëtarëve të ekipit",
   "team-member-list-description":
      "Shtoni anëtarët e ekipit tuaj dhe bashkëpunoni për të forcuar organizatën tuaj. Ky seksion është i dukshëm vetëm për ju. Edhe nëse profili juaj është publik, askush tjetër nuk do të mund t'i shohë anëtarët që shtoni.",
   "latest-round-label": "Raundi i fundit",
   "size-label": "Madhësia",
   "select-number-placeholder": "Zgjidhni numrin",
   "select-date-placeholder": "Zgjidhni një datë",

   "profile-updated-success-title": "Profili u përditësua me sukses!",
   "profile-updated-success-description": "Informacioni i profilit tuaj u përditësua saktë.",
   "profile-update-error-description":
      "Patëm një problem gjatë përditësimit të informacionit të profilit tuaj, ju lutemi provoni përsëri.",
   "international-name-required-validation": "Emri ndërkombëtar është i detyrueshëm",
   "date-of-establishment-required-validation": "Data e themelimit është e detyrueshme",
   "address-required-validation": "Adresa është e detyrueshme",
   "zip-code-required-validation": "Kodi postar është i detyrueshëm",
   "email-required-validation": "Email-i është i detyrueshëm",
   "invalid-phone-number-validation": "Numër telefoni i pavlefshëm",
   "phone-number-required-validation": "Numri i telefonit është i detyrueshëm",
   "at-least-one-sector-required-validation": "Kërkohet të paktën një sektor",
   "organization-size-required-validation": "Madhësia e organizatës është e detyrueshme",
   "at-least-one-country-required-validation": "Kërkohet të paktën një shtet",
   "base-country-required-validation": "Shteti bazë është i detyrueshëm",
   "city-required-validation": "Qyteti është i detyrueshëm",
   "edit-profile-title": "Modifiko Profilin",
   "organization-details-tab": "Detajet e Organizatës",
   "international-name-placeholder": "Emri ndërkombëtar",
   "description-placeholder": "Përshkrimi",
   "foundation-year-label": "Viti i themelimit",
   "select-organization-size-placeholder": "Zgjidhni madhësinë e organizatës",
   "countries-where-operates-label": "Shtetet ku operon organizata",
   "select-operating-countries-placeholder": "Zgjidhni shtetet ku operon",
   "working-sector-label": "Sektori i punës",
   "select-sectors-alt-placeholder": "Zgjidhni Sektorët",
   "contact-information-tab": "Informacioni i Kontaktit",
   "organizations-email-label": "Email i organizatës",
   "select-base-country-placeholder": "Zgjidhni shtetin bazë",
   "select-a-city-placeholder": "Zgjidhni një qytet",
   "save-changes-button": "Ruaj ndryshimet",

   // Profile information page (account profile edit forms)
   "name-label": "Emri",
   "city-label": "Qyteti",
   "birthdate-label": "Data e lindjes",
   "select-your-prefix": "Zgjidhni",
   "area-of-expertise-colon-label": "Fusha e ekspertizës:",
   "years-suffix-label": "vjet",
   "professional-details-title": "Detajet profesionale",
   "enter-current-password-placeholder": "Shkruani fjalëkalimin tuaj aktual",
   "enter-new-password-placeholder": "Shkruani fjalëkalimin tuaj të ri",
   "enter-new-password-again-placeholder": "Shkruani përsëri fjalëkalimin tuaj të ri",
   "enter-your-email-placeholder": "Shkruani email-in tuaj",

   // Login information page (LoginInfo.js)
   "account-information-label": "Informacioni i llogarisë",
   "email-label": "Email",
   "current-password-label": "Fjalëkalimi aktual",
   "new-password-label": "Fjalëkalimi i ri",
   "password-hint-intro-text":
      "Për të mbrojtur llogarinë tuaj, fjalëkalimi juaj duhet të përmbajë të paktën:",
   "password-hint-length": "8 karaktere",
   "password-hint-uppercase": "Një shkronjë të madhe",
   "password-hint-lowercase": "Një shkronjë të vogël",
   "password-hint-number": "Një numër",
   "password-hint-special": "Një karakter special",
   "change-password-here-text": "Mund ta ndryshoni fjalëkalimin tuaj këtu",
   "email-changed-success-title": "Email-i u ndryshua me sukses!",
   "email-changed-success-description": "Email-i juaj u përditësua saktë.",
   "email-update-error-description":
      "Kishim një problem gjatë ndryshimit të email-it tuaj, ju lutemi provoni përsëri.",
   "password-changed-success-title": "Fjalëkalimi u ndryshua me sukses!",
   "password-changed-success-description": "Fjalëkalimi juaj u përditësua saktë.",
   "password-update-error-description":
      "Kishim një problem gjatë ndryshimit të fjalëkalimit tuaj, ju lutemi provoni përsëri.",
   "current-password-required-validation": "Fjalëkalimi aktual është i detyrueshëm",
   "new-password-required-validation": "Fjalëkalimi i ri është i detyrueshëm",
   "confirm-new-password-required-validation": "Konfirmimi i fjalëkalimit të ri është i detyrueshëm",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "Menaxhimi i llogarisë",
   "deactivate-account-title": "Çaktivizo llogarinë",
   "deactivate-account-description":
      "Mund ta çaktivizoni llogarinë tuaj këtu. Kjo do ta bëjë llogarinë tuaj përkohësisht të papërdorshme. Megjithatë, ky veprim është plotësisht i kthyeshëm, dhe",
   "deactivate-account-explanation":
      "mund ta riaktivizoni llogarinë tuaj në çdo kohë thjesht duke u kyçur përsëri.",
   "delete-account-title": "Fshi llogarinë",
   "delete-account-description":
      "Fshirja e llogarisë suaj do t'i heqë përgjithmonë të gjitha të dhënat tuaja nga sistemi ynë.",
   "delete-account-explanation":
      "Ky veprim është i pakthyeshëm, që do të thotë se pasi llogaria juaj të fshihet, nuk do të mund të rikuperoni asnjë nga informacionet ose përmbajtja juaj.",
   "delete-account-explanation-2": "Nëse jeni i sigurt që doni të vazhdoni,",
   "delete-account-explanation-3":
      "ju lutemi kini parasysh se do të humbisni aksesin në të gjitha shërbimet dhe të dhënat e lidhura me llogarinë tuaj.",
   "delete-account-modal-title": "Fshini llogarinë tuaj",
   "deactivate-account-modal-title": "Çaktivizoni llogarinë tuaj",
   "delete-account-modal-description": "Na vjen keq që po largoheni, por respektojmë vendimin tuaj!",
   "deactivate-account-modal-description":
      "Po mendoni për një pushim? Çaktivizimi i llogarisë suaj është gjithmonë një mundësi.",
   "confirm-account-deletion-title": "Konfirmo fshirjen e llogarisë",
   "confirm-account-deactivation-title": "Konfirmo çaktivizimin e llogarisë",
   "confirm-delete-account-description":
      "Jeni gati të fshini përgjithmonë llogarinë dhe të dhënat tuaja.",
   "confirm-deactivate-account-description": "Jeni gati të çaktivizoni llogarinë tuaj.",
   "confirm-action-other-desc": "Jeni i sigurt që doni të vazhdoni?",
   "delete-reason-1": "Nuk kam më nevojë për shërbimin.",
   "delete-reason-2": "Gjeta një shërbim tjetër që i përshtatet më mirë nevojave të mia.",
   "delete-reason-3": "Pata një përvojë të keqe.",
   "delete-reason-4": "Jam i shqetësuar për privatësinë e të dhënave të mia.",
   "deactivate-reason-1": "Kam nevojë për një pushim të shkurtër.",
   "deactivate-reason-2": "Aktualisht jam shumë i zënë për të përdorur platformën.",
   "deactivate-reason-3": "Po merrem me çështje personale.",
   "deactivate-reason-4": "Dua të fokusohem në prioritete të tjera për momentin.",
   "other-please-specify-label": "Tjetër (ju lutemi specifikoni)",
   "enter-your-answer-placeholder": "Shkruani përgjigjen tuaj këtu",
   "delete-account-feedback-prompt":
      "Do të donim të dëgjonim mendimin tuaj. A mund të ndani pse po mendoni të fshini llogarinë tuaj?",
   "deactivate-account-feedback-prompt":
      "Do të donim të dëgjonim mendimin tuaj. A mund të ndani pse po mendoni të çaktivizoni llogarinë tuaj?",
   "delete-account-followup-question":
      "Faleminderit që ishit me ne. A ka diçka që mund të kishim bërë për ta përmirësuar përvojën tuaj?",
   "deactivate-account-followup-question":
      "Gjithmonë kërkojmë të përmirësohemi. Nëse keni sugjerime apo komente, do të donim t'i dëgjonim",
   "delete-account-error-description":
      "Kishim një problem gjatë fshirjes së llogarisë suaj, ju lutemi provoni përsëri.",
   "deactivate-account-error-description":
      "Kishim një problem gjatë çaktivizimit të llogarisë suaj, ju lutemi provoni përsëri.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "Zgjidhni planin perfekt për ju",
   "billed-annually-text": "Faturohet vjetorisht",
   "workspaces-suffix-label": "hapësira pune",
   "members-suffix-label": "anëtarë",
   "data-storage-limit-suffix-label": "kufiri i hapësirës ruajtëse",
   "see-all-plan-details-link": "Shiko të gjitha detajet e planit",
   "plan-selected-label": "Plani u zgjodh",
   "select-this-plan-button": "Zgjidh këtë plan",
   "view-billing-portal-button": "Shiko portalin e faturimit",
   "checkout-button": "Përfundo pagesën",
   "active-subscription-error-description":
      "Përdoruesi ka tashmë një abonim aktiv. Ju lutemi zgjidhni një plan tjetër.",
   "payment-billing-error-description":
      "Kishim një problem gjatë faturimit të kësaj pagese, ju lutemi provoni përsëri.",
   "purchase-successful-title": "Blerja u krye me sukses!",
   "payment-processed-success-text": "Pagesa juaj u përpunua me sukses.",
   "thank-you-for-purchase-text": "Faleminderit për blerjen tuaj!",
   "go-back-to-payment-info-text": "Kthehu te informacioni i pagesës",
   "purchase-failed-title": "Blerja dështoi",
   "purchase-failed-description":
      "Fatkeqësisht, tentativa juaj e fundit e blerjes nuk ishte e suksesshme. Mund të ketë pasur një problem me përpunimin e pagesës ose me informacionin e dhënë. Ju lutemi kontrolloni detajet e pagesës suaj dhe provoni përsëri.",
   "apologize-inconvenience-text": "Kërkojmë ndjesë për shqetësimin dhe vlerësojmë durimin tuaj.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "Minimumi 3 karaktere",
   "max-50-symbols-validation": "Maksimumi 50 karaktere",
   "invalid-organization-email-validation": "Email i pavlefshëm i organizatës",
   "organization-address-required-validation": "Adresa e organizatës është e detyrueshme",
   "operating-countries-required-validation": "Vendet operuese janë të detyrueshme",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "veprim në llogari",
   "account-deactivated-notice-text": "Llogaria juaj u çaktivizua me sukses sipas kërkesës suaj.",
   "account-deleted-notice-text": "Llogaria juaj u fshi me sukses sipas kërkesës suaj.",
   "positive-experience-farewell-text":
      "Besojmë se keni pasur një përvojë pozitive me ne, dhe duam që ta dini se do të mirëpriteni gjithmonë sërish sa herë që zgjidhni të ktheheni.",
   "kaporg-best-regards-text": "Me respekt, ekipi i KAPorg.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "Modifiko foton e profilit",
   "change-profile-picture-button": "Ndrysho foton e profilit",
   "delete-profile-picture-button": "Fshi foton e profilit",
   "profile-picture-updated-success-title": "Fotoja e profilit u përditësua me sukses!",
   "profile-picture-updated-success-description": "Fotoja juaj e profilit u përditësua saktë.",
   "profile-picture-update-error-description":
      "Kishim një problem gjatë përditësimit të fotos suaj të profilit, ju lutemi provoni përsëri.",
   "profile-picture-deleted-success-title": "Fotoja e profilit u fshi me sukses!",
   "profile-picture-deleted-success-description": "Fotoja juaj e profilit është fshirë.",
   "profile-picture-delete-error-description":
      "Kishim një problem gjatë fshirjes së fotos suaj të profilit, ju lutemi provoni përsëri.",

   "name-required-validation": "Emri është i detyrueshëm",
   "gender-required-validation": "Gjinia është e detyrueshme",
   "role-required-validation": "Roli është i detyrueshëm",
   "team-member-added-success-title": "Anëtari i ekipit u shtua me sukses!",
   "team-member-added-success-description":
      "Ky anëtar u shtua me sukses në bazën e të dhënave të ekipit tuaj.",
   "team-member-add-error-description":
      "Patëm një problem gjatë shtimit të këtij anëtari në bazën e të dhënave të ekipit tuaj, ju lutemi provoni përsëri.",
   "add-new-member-title": "Shto anëtar të ri",
   "gender-label": "Gjinia",
   "select-gender-placeholder": "Zgjidhni gjininë",
   "role-label": "Roli",
   "select-role-placeholder": "Zgjidhni rolin",
   "make-my-profile-public-button": "Bëje profilin tim publik",
   "make-my-profile-private-button": "Bëje profilin tim privat",
   "make-profile-public-title": "Bëje profilin publik",
   "make-profile-private-title": "Bëje profilin privat",
   "profile-visibility-notice-public":
      "Duke e bërë publike organizatën tuaj kombëtare, donatorët dhe ekspertët do të mund të shohin informacionin dhe rezultatet tuaja. Prandaj, rekomandojmë të siguroheni që të gjitha informacionet tuaja janë të plota përpara se ta bëni publike.",
   "profile-visibility-notice-private":
      "Duke e bërë private organizatën tuaj kombëtare, donatorët dhe ekspertët do të mund të shohin informacionin dhe rezultatet tuaja. Prandaj, rekomandojmë të siguroheni që të gjitha informacionet tuaja janë të plota përpara se ta bëni private.",
   "delete-member-title": "Fshi anëtarin",
   "delete-member-description": "Jeni duke fshirë këtë anëtar. Ky veprim nuk mund të zhbëhet.",
   "delete-all-representative-details-title": "Fshi të gjitha detajet e përfaqësuesit",
   "delete-representative-info-description-1":
      "Jeni duke fshirë të gjithë informacionin e përfaqësuesit tuaj.",
   "delete-representative-info-description-2": "Mund ta shtoni përsëri më vonë nëse dëshironi.",
   "delete-representative-info-description-3":
      "Mos harroni, të kesh një profil të plotë është thelbësore për dukshmëri më të mirë dhe mundësi kontakti brenda komunitetit.",
   "organizations-management-title": "Menaxhimi i organizatave",

   "representative-updated-success-title": "Detajet e përfaqësuesit u përditësuan me sukses!",
   "representative-updated-success-description":
      "Informacioni i detajeve të përfaqësuesit tuaj u përditësua saktë.",
   "representative-update-error-description":
      "Patëm një problem gjatë përditësimit të informacionit të detajeve të përfaqësuesit, ju lutemi provoni përsëri.",
   "edit-representative-detail-title": "Modifiko detajin e përfaqësuesit",
   "full-name-label": "Emri i plotë",
   "phone-label": "Telefoni",
   "edit-representative-button": "Modifiko përfaqësuesin",
   "representative-added-success-title": "Detajet e përfaqësuesit u shtuan me sukses!",
   "representative-added-success-description":
      "Informacioni i detajeve të përfaqësuesit tuaj u shtua saktë.",
   "representative-add-error-description":
      "Patëm një problem gjatë shtimit të informacionit të detajeve të përfaqësuesit, ju lutemi provoni përsëri.",
   "create-representative-detail-title": "Krijo një detaj të ri të përfaqësuesit",

   "team-member-removed-success-title": "Anëtari i ekipit u hoq me sukses!",
   "team-member-removed-success-description":
      "Ky anëtar u hoq me sukses nga baza e të dhënave të ekipit tuaj.",
   "team-member-remove-error-description":
      "Patëm një problem gjatë heqjes së këtij anëtari nga baza e të dhënave të ekipit tuaj, ju lutemi provoni përsëri.",
   "fullname-column": "Emri i plotë",
   "member-search-label": "Cilin anëtar po kërkoni?",
   "search-member-by-name-placeholder": "Kërko një anëtar sipas emrit të tij",
   "add-member-button": "Shto anëtar",
   "new-member-button": "Anëtar i ri",
   "birthdate-label": "Data e lindjes",
   "email-field-label": "Email",
   "name": "Emri",
   "email": "Email",
   "cancel": "Anulo",
   "no-assessments-listed-text": "Nuk ka vlerësime të listuara",
   "remaining-months-days-text": "{months} muaj, {days} ditë",
   "more-actions-label": "Më shumë veprime",
   "sort-ascending-alt": "Rendit në rritje",
   "sort-descending-alt": "Rendit në zbritje",
   "error-unauthorized-text": "Na vjen keq, nuk jeni i autorizuar të hyni në këtë faqe.",
   "error-page-not-found-text": "Na vjen keq, faqja që vizituat nuk ekziston.",
   "error-oops-title": "Hopa...",
   "back-home-button": "Kthehu në faqen kryesore",
   "error-something-wrong-text": "Duket se diçka shkoi keq. Po punojmë për ta rregulluar",

   "requests-management-title": "Menaxhimi i kërkesave",
   "archived-assessments-link": "Vlerësimet e arkivuara",
   "deleted-assessments-link": "Vlerësimet e fshira",
   "add-new-assessment-button": "Vlerësim i ri",
   "assessment-list-title": "Vlerësimet",
   "archive-button": "Arkivo",
   "archive-assessment-title": "Arkivo vlerësimin",
   "delete-assessment-title": "Fshi vlerësimin",
   "archive-assessment-description": "Jeni duke arkivuar këtë vlerësim.",
   "delete-assessment-description": "Jeni duke fshirë këtë vlerësim.",

   "start-date-after-previous-end-validation":
      "Data e fillimit duhet të jetë më e madhe se data e mbarimit të mëparshëm",
   "end-date-after-start-validation": "Data e mbarimit duhet të jetë më e madhe se data e fillimit",
   "assessment-name-empty-validation": "Emri i vlerësimit nuk mund të jetë bosh",
   "submission-round-label-empty-validation": "Etiketa e raundit të dorëzimit nuk mund të jetë bosh",
   "date-fields-required-validation": "Fushat e datës janë të detyrueshme",
   "start-date-required-validation": "Data e fillimit është e detyrueshme",
   "end-date-required-validation": "Data e mbarimit është e detyrueshme",
   "assessment-created-success-title": "Vlerësimi u krijua me sukses!",
   "assessment-created-success-description":
      "Një vlerësim i ri u krijua dhe u shtua në bazën tuaj të të dhënave.",
   "assessment-create-error-description":
      "Patëm një problem gjatë krijimit të këtij vlerësimi, ju lutemi provoni përsëri.",
   "assessment-details-title": "Detajet e vlerësimit",
   "assessment-name-label": "Emri i vlerësimit",
   "enter-assessment-name-placeholder": "Vendosni emrin e vlerësimit",
   "assessment-type-label": "Lloji i vlerësimit",
   "submission-round-label-field": "Etiketa e raundit të dorëzimit",
   "enter-submission-round-placeholder": "Vendosni raundin e dorëzimit",
   "start-date-label": "Data e fillimit",
   "end-date-label": "Data e mbarimit",
   "add-new-submission-round-button": "Shto raund të ri dorëzimi",
   "dynamic-range-label": "Intervali dinamik",
   "select-score-range-description":
      "Zgjidhni intervalin për variablat e rezultatit të vlerësimit tuaj (deri në 5)",
   "score-variables-label": "variabla rezultati",
   "from-label": "Nga",
   "to-label": "deri",
   "score-label-field": "Etiketa e rezultatit",
   "score-description-field": "Përshkrimi i rezultatit",
   "enter-label-description-placeholder": "Vendosni një përshkrim për etiketën",
   "add-assessment-button": "Shto vlerësim",
   "assessment-assigned-success-title": "Vlerësimi u caktua me sukses!",
   "assessment-assigned-success-description":
      "Ky vlerësim iu caktua me sukses anëtarëve të ekipit tuaj. Ata do të njoftohen për këtë veprim.",
   "assessment-assign-error-description":
      "Patëm një problem gjatë caktimit të këtij vlerësimi te anëtarët e ekipit tuaj, ju lutemi provoni përsëri.",
   "assign-assessment-to-team-title": "Cakto vlerësimin te ekipi",
   "project-management-label": "Menaxhimi i projektit",

   "assessment-updated-success-title": "Vlerësimi u përditësua me sukses!",
   "assessment-updated-success-description": "Ky vlerësim u përditësua saktë.",
   "assessment-update-error-description":
      "Patëm një problem gjatë përditësimit të këtij vlerësimi, ju lutemi provoni përsëri.",
   "edit-assessment-title": "Modifiko vlerësimin",
   "edit-assessment-of-team-title": "Modifiko vlerësimin e këtij ekipi",
   "select-project-management-placeholder": "Zgjidhni menaxhimin e projektit",
   "module-assigned-success-title": "Moduli u caktua me sukses!",
   "module-assigned-success-description":
      "Ky modul iu caktua me sukses anëtarëve të stafit tuaj. Ata do të njoftohen për këtë veprim.",
   "module-unassigned-success-title": "Anulimi i caktimit të modulit u krye me sukses!",
   "module-unassigned-success-description":
      "Caktimi i këtij moduli u anulua me sukses nga anëtari i stafit.",
   "module-assign-error-description":
      "Patëm një problem gjatë caktimit të këtij moduli te anëtarët e stafit tuaj, ju lutemi provoni përsëri.",
   "assign-module-to-members-title": "Cakto modulin te anëtarët",
   "module-name-label": "Emri i modulit",
   "members-to-assign-label": "Anëtarët të cilëve do t'u caktohet ky modul",
   "unassign-button": "Anulo caktimin",
   "assign-module-button": "Cakto modulin",
   "member-required-validation": "Anëtari është i detyrueshëm",

   "comparison-created-success-title": "Versioni i ri i krahasimit u krijua!",
   "comparison-created-success-description":
      "Versioni i ri i krahasimit u krijua me sukses dhe është gati për shqyrtim.",
   "comparison-create-error-description":
      "Patëm një problem gjatë krijimit të këtij versioni krahasimi, ju lutemi provoni përsëri.",
   "duplicate-for-comparison-title": "Dyfishimi për krahasim",
   "duplicate-comparison-description-1":
      "Kjo do të krijojë një kopje të vlerësimit dhe do të lidhë të dy versionet për krahasimin e rezultateve.",
   "duplicate-comparison-description-2":
      "Pas dyfishimit, vlerësimet dhe çdo modul i lidhur nuk mund të modifikohen.",
   "current-assessment-label": "Vlerësimi aktual",
   "new-comparison-version-label": "Versioni i ri i krahasimit",
   "comparison-suffix-label": "Krahasim",
   "duplicate-comparison-note":
      "Shënim: Nëse është e nevojshme, mund ta hiqni lidhjen më vonë për t'i modifikuar në mënyrë të pavarur, por krahasimi nuk do të jetë më i disponueshëm.",
   "duplicate-button": "Dyfisho",
   "assessments-unlinked-success-title": "Vlerësimet u shkëputën!",
   "assessments-unlinked-success-description":
      "Vlerësimet u shkëputën me sukses dhe tani mund të modifikohen në mënyrë të pavarur.",
   "assessments-unlink-error-description":
      "Patëm një problem gjatë shkëputjes së vlerësimeve, ju lutemi provoni përsëri.",
   "unlink-assessments-title": "T'i shkëputim këto vlerësime?",
   "unlink-assessments-description":
      "Ato nuk do të jenë më të lidhura për krahasim dhe pamja e krahasimit nuk do të jetë më e disponueshme.",
   "original-assessment-label": "Vlerësimi origjinal",
   "duplicated-assessment-label": "Vlerësimi i dyfishuar",
   "unlink-assessments-note": "Shënim: Pas shkëputjes, çdo vlerësim mund të modifikohet në mënyrë të pavarur.",
   "unlink-button": "Shkëput",
   "expert-name-column": "Emri i ekspertit",
   "years-of-experience-column": "Vite eksperiencë",
   "expert-cv-column": "CV e ekspertit",
   "cv-link-text": "Lidhja e CV-së",
   "no-cv-available-text": "Nuk ka CV të disponueshme",
   "areas-of-expertise-column": "Fushat e ekspertizës",
   "select-expert-request-access-title": "Zgjidhni një ekspert dhe kërkoni akses",
   "first-choose-expert-subtitle": "Së pari zgjidhni një ekspert",
   "choose-expert-guide-hint": "Zgjidhni një ekspert për të udhëhequr vlerësimin tuaj",
   "request-access-button": "Kërko akses",
   "go-back-experts-list-link": "Kthehu te lista e ekspertëve",
   "no-description-available-text": "Nuk ka përshkrim të disponueshëm",
   "no-expertise-listed-text": "Nuk ka ekspertizë të listuar",
   "nationality-label": "Kombësia",
   "no-nationality-listed-text": "Nuk ka kombësi të listuar",
   "country-of-residence-label": "Shteti i banimit",
   "no-country-of-residence-text": "Nuk ka shtet banimi",
   "no-operating-countries-listed-text": "Nuk ka shtete operimi të listuara",
   "linkedin-profile-label": "Profili në LinkedIn",
   "no-linkedin-profile-text": "Nuk është dhënë profil LinkedIn",
   "no-phone-number-listed-text": "Nuk ka numër telefoni të listuar",
   "highest-degree-label": "Grada më e lartë e arritur",
   "no-highest-degree-listed-text": "Nuk është listuar grada më e lartë e arritur",
   "fields-of-study-label": "Fushat e studimit",
   "no-study-fields-listed-text": "Nuk ka fusha studimi të listuara",
   "educational-institution-label": "Institucioni arsimor",
   "no-educational-institution-listed-text": "Nuk është listuar institucion arsimor",
   "languages-label": "Gjuhët",
   "no-languages-listed-text": "Nuk ka gjuhë të listuara",
   "cv-label": "CV",
   "no-cv-listed-text": "Nuk ka CV të listuar",
   "certification-training-label": "Certifikim ose trajnim i veçantë",
   "no-certification-listed-text": "Nuk është listuar certifikim ose trajnim i veçantë",

   "archived-assessments-list-title": "Lista e vlerësimeve të arkivuara",
   "deleted-assessments-title": "Vlerësimet e fshira",
   "delete-permanently-button": "Fshi përgjithmonë",
   "unarchive-assessments-button": "Anulo arkivimin e vlerësimeve",
   "restore-assessments-button": "Rikthe vlerësimet",
   "deleted-assessments-description":
      "Këtu mund të shikoni dhe rikthoni vlerësimet e fshira. Çdo vlerësim që nuk është rikthyer brenda 60 ditësh do të fshihet përgjithmonë.",
   "delete-assessment-permanently-title": "Fshi vlerësimin përgjithmonë",
   "delete-assessments-permanently-title": "Fshi vlerësimet përgjithmonë",
   "delete-selected-assessment-permanently-description":
      "Jeni duke fshirë përgjithmonë vlerësimin e zgjedhur.",
   "delete-selected-assessments-permanently-description":
      "Jeni duke fshirë përgjithmonë vlerësimet e zgjedhura.",
   "action-cannot-be-undone-confirm-text":
      "Ky veprim nuk mund të zhbëhet. Jeni i sigurt që doni të vazhdoni?",

   "request-sent-success-title": "Kërkesa u dërgua me sukses!",
   "request-sent-success-description":
      "Kërkesa juaj iu dërgua administratorit. Sapo kërkesa të përgjigjet, do të merrni një email me përgjigjen.",
   "request-send-error-description":
      "Kishim një problem në dërgimin e kërkesës suaj, ju lutemi provoni përsëri.",
   "request-rejected-title": "Oh jo! Duket se kërkesa juaj u refuzua",
   "request-rejected-description-line1":
      "Për momentin nuk mund të keni qasje në këtë vlerësim sepse kërkesa juaj u refuzua.",
   "request-rejected-description-line2": "Por mos u shqetësoni! Mund të kërkoni qasje përsëri.",
   "request-pending-title": "Ju tashmë keni kërkuar qasje për këtë vlerësim!",
   "request-pending-description-line1":
      "Kërkesa juaj iu dërgua administratorit të këtij vlerësimi. Sapo kërkesa të përgjigjet, do të merrni një email me përgjigjen.",
   "request-pending-description-line2": "Do të kontaktojmë me ju sa më shpejt të jetë e mundur.",
   "request-access-title": "Kërkoni qasje për këtë vlerësim",
   "request-access-description-part1": "Zhbllokoni këtë vlerësim të udhëhequr në mënyrë që",
   "request-access-description-part2": "ne të mund të caktojmë ekspertët tanë",
   "request-access-description-part3": "nga fusha juaj e punës për t'ju",
   "request-access-description-part4": "mbështetur drejtpërdrejt gjatë procesit të vlerësimit",
   "request-access-description-part5":
      "dhe t'ju ndihmojmë të eksploroni mënyra për të ndërtuar partneritete më të mira dhe për të siguruar financim për programet e ardhshme.",

   "guided-assessments-title": "Vlerësime të udhëhequra",
   "assessments-list-title": "Lista e vlerësimeve",
   "organizations-name-column": "Emri i organizatës",
   "assessment-column": "Vlerësimi",
   "status-column": "Statusi",
   "not-started-status": "Nuk ka filluar",
   "in-progress-status": "Në progres",
   "completed-status": "Përfunduar",

   "success-title": "Sukses",
   "module-submitted-success-description": "Moduli u dërgua me sukses",
   "no-submission-rounds-text": "Nuk ka raunde dorëzimi",
   "submission-rounds-title": "Raundet e dorëzimit",
   "round-target-label": "Objektivi",
   "module-submitted-modal-title": "E dërguat me sukses këtë modul!",
   "next-round-active-description":
      "Ju lutemi kthehuni në këtë vlerësim kur raundi i ardhshëm i dorëzimit të jetë aktiv.",
   "remaining-time-current-round-label": "Koha e mbetur e raundit aktual",
   "start-label": "Fillimi",
   "end-label": "Fundi",
   "linked-modules-title": "Modulet e lidhura",
   "no-linked-modules-text": "Nuk ka module të lidhura",
   "finished-status": "Përfunduar",
   "completed-text": "përfunduar",

   "assigned-to-label": "Caktuar te",
   "assign-member-button": "Cakto anëtar",
   "submitted-at-label": "Dërguar më",
   "edit-assignment-button": "Ndrysho caktimin",
   "assign-to-team-button": "Cakto te ekipi",
   "assessment-assigned-to-label": "Vlerësimi është caktuar te:",
   "expert-modules-description":
      "Këto janë modulet të cilave eksperti që zgjodhët do t'u përgjigjet. Sapo eksperti t'i dorëzojë modulet, do të mund të shihni rezultatet dhe përgjigjet në seksionin Rezultatet.",

   "no-self-assessments-yet-title":
      "Duket sikur ky hapësirë pune nuk ka ende asnjë vetëvlerësim!",
   "no-guided-assessments-yet-title":
      "Duket sikur ky hapësirë pune nuk ka ende asnjë vlerësim të udhëhequr!",
   "work-on-guided-assessments-instead-description":
      "Por mos u shqetësoni, mund të punoni në vlerësimet e udhëhequra në vend të kësaj.",
   "work-on-self-assessments-instead-description":
      "Por mos u shqetësoni, mund të punoni në vetëvlerësimet në vend të kësaj.",

   "name-column": "Emri",
   "type-column": "Lloji",
   "created-by-column": "Krijuar nga",
   "created-date-column": "Data e krijimit",
   "edit-action": "Ndrysho",
   "founded-label": "Themeluar",
   "areas-label": "fusha",
   "staff-label": "staf",
   "contact-label": "Kontakti",
   "online-label": "Online",
   "unlink-assessment-action": "Shkëput vlerësimin",
   "edit-assessment-alt": "Ndrysho vlerësimin",
   "archive-assessment-alt": "Arkivo vlerësimin",
   "delete-assessment-alt": "Fshi vlerësimin",
   "unlink-assessment-alt": "Shkëput vlerësimin",

   "assessment-deleted-success-title": "Vlerësimi u fshi me sukses!",
   "assessment-deleted-success-description":
      "Ky vlerësim u fshi me sukses nga baza juaj e të dhënave.",
   "assessment-delete-error-description":
      "Kishim një problem në fshirjen e këtij vlerësimi, ju lutemi provoni përsëri.",
   "assessments-deleted-success-title": "Vlerësimet u fshinë me sukses!",
   "assessments-deleted-success-description":
      "Këto vlerësime u fshinë me sukses nga baza juaj e të dhënave.",
   "assessments-delete-error-description":
      "Kishim një problem në fshirjen e këtyre vlerësimeve, ju lutemi provoni përsëri.",
   "assessment-restored-success-title": "Vlerësimi u rikthye me sukses!",
   "assessment-restored-success-description": "Ky vlerësim u rikthye me sukses.",
   "assessment-unarchive-error-description":
      "Kishim një problem në heqjen nga arkivi të këtij vlerësimi, ju lutemi provoni përsëri.",
   "assessments-unarchived-success-title": "Vlerësimet u hoqën nga arkivi me sukses!",
   "assessments-unarchived-success-description": "Këto vlerësime u hoqën me sukses nga arkivi.",
   "assessments-unarchive-error-description":
      "Kishim një problem në heqjen nga arkivi të këtyre vlerësimeve, ju lutemi provoni përsëri.",
   "assessment-archived-success-title": "Vlerësimi u arkivua me sukses!",
   "assessment-archived-success-description": "Ky vlerësim u arkivua me sukses.",
   "assessment-archive-error-description":
      "Kishim një problem në shtimin e këtij vlerësimi në arkiv, ju lutemi provoni përsëri.",
   "assessment-trashed-success-title": "Vlerësimi u shtua me sukses në kosh!",
   "assessment-trashed-success-description": "Ky vlerësim u shtua me sukses në kosh.",
   "assessment-trash-error-description":
      "Kishim një problem në shtimin e këtij vlerësimi në kosh, ju lutemi provoni përsëri.",

   "assessment-modules-title": "Modulet e Vlerësimit",
   "module-name-column": "Emri i Modulit",
   "go-to-module-button": "Shko te Moduli",

   "consultant-organization-list-title": "Lista e Organizatave Konsulente",
   "country-column": "Shteti",
   "progress-column": "Progresi",
   "submitted-status": "Dërguar",
   "go-to-assessment-button": "Shko te vlerësimi",

   "module-submitted-toast": "Moduli u dërgua me sukses.",
   "no-permission-submit-module-warning": "Nuk keni leje për të dërguar një modul!",
   "submit-button": "Dërgo",
   "module-submitted-text": "Ky modul është dërguar.",

   "choose-consultant-guide-title": "Zgjidhni një konsulent për të udhëhequr vlerësimin tuaj",
   "consultant-profile-title": "Profili i Konsulentit",
   "consultant-label": "Konsulent",
   "experience-title": "Përvoja",
   "education-title": "Arsimimi",
   "school-label": "Shkolla",
   "skills-title": "Aftësitë",
   "select-this-consultant-button": "Zgjidh këtë Konsulent",
   "enrolled-guided-assessment-success-title":
      "U regjistruat me sukses në vlerësimin e udhëhequr!",
   "consultant-contact-soon-description-part1": "Konsulenti",
   "consultant-contact-soon-description-part2":
      "do t'ju kontaktojë së shpejti për të filluar vlerësimet tuaja.",
   "go-to-assessments-button": "Shko te vlerësimet",

   "improve-score-help-title":
      "Nëse dëshironi të përmirësoni rezultatin tuaj dhe të rritni më tej organizatën tuaj, ekipi i KAPorg është këtu për t'ju ndihmuar!",
   "request-guided-assessment-description-part1":
      "Kërkoni tani një vlerësim të udhëhequr në mënyrë që të mund t'ju caktojmë ekspertët tanë nga fusha juaj e punës për t'ju mbështetur drejtpërdrejt gjatë procesit të vlerësimit dhe t'ju ndihmojmë të eksploroni mënyra për të ndërtuar partneritete më të mira dhe për të siguruar financim për programet e ardhshme.",
   "request-guided-assessment-description-part2":
      "Kërkojeni tani dhe ne do t'ju kontaktojmë sa më shpejt të jetë e mundur.",
   "request-assessment-code-button": "Kërko një kod vlerësimi",
   "have-assessment-code-button": "Kam një kod vlerësimi",
   "assessment-code-title": "Kodi i vlerësimit",
   "enter-assessment-code-description":
      "Për të hyrë në vlerësimin tuaj, ju lutemi shkruani kodin e vlerësimit më poshtë",
   "enter-code-here-label": "Shkruani kodin tuaj këtu",
   "please-enter-code-error": "Ju lutemi shkruani kodin",
   "assessment-list-label": "Lista e vlerësimeve",
   "select-an-assessment-placeholder": "-Zgjidhni një vlerësim-",
   "select-assessment-error": "Duhet të zgjidhni një vlerësim",
   "submit-request-button": "Dërgo kërkesën",
   "request-assessment-code-title": "Kërko Kod Vlerësimi",
   "request-assessment-code-description":
      "Ju lutemi kërkoni vlerësimin tuaj dhe ne do t'ju kontaktojmë. Sapo kërkesa të pranohet, do të merrni një email me kodin.",
   "select-assessment-from-list-description": "Zgjidhni një vlerësim nga lista më poshtë",
   "code-valid-select-consultant-toast": "Kodi juaj ishte i vlefshëm dhe tani mund të zgjidhni konsulentin",

   "my-modules-tab": "Modulet e mia",
   "template-library-tab": "Biblioteka e shabllonave",

   "module-deleted-success-title": "Moduli u fshi me sukses!",
   "module-deleted-success-description": "Ky modul u fshi me sukses nga baza juaj e të dhënave.",
   "module-delete-error-description":
      "Kishim një problem në fshirjen e këtij moduli, ju lutemi provoni përsëri.",
   "module-cannot-be-deleted-error": "Moduli nuk mund të fshihet",
   "preview-action": "Shiko",
   "download-action": "Shkarko",
   "turn-into-template-action": "Kthe në shabllon",
   "preview-template-alt": "Shiko shabllonin",
   "edit-module-alt": "Ndrysho modulin",
   "download-module-alt": "Shkarko modulin",
   "turn-into-template-alt": "Kthe në shabllon",
   "delete-module-alt": "Fshi modulin",
   "title-column": "Titulli",
   "deleted-modules-button": "Modulet e fshira",
   "add-module-button": "Modul i ri",
   "add-module-modal-button": "Shto modulin",
   "add-new-module-title": "Shto modul të ri",
   "add-new-assessment-title": "Shto vlerësim të ri",
   "survey-status-editing": "Në redaktim",
   "survey-status-archived": "Arkivuar",
   "survey-status-deployed": "Publikuar",
   "survey-status-locked": "Kyçur",

   "how-start-title": "Si dëshironi të filloni?",
   "create-form-title": "Krijo formularin",
   "create-form-description":
      "Filloni me një strukturë bosh, duke shtuar seksione dhe pyetje ndërkohë që përparoni.",
   "import-form-title": "Importo formularin",
   "import-form-description": "Ngarko një skedar me seksione dhe pyetje të paracaktuara.",
   "use-template-title": "Përdor një shabllon",
   "use-template-description":
      "Filloni me një formular tashmë të ruajtur në sistem dhe përshtateni lehtësisht sipas nevojave tuaja.",
   "continue-button": "Vazhdo",

   "module-details-title": "Detajet e modulit",
   "enter-module-name-placeholder": "Shkruani emrin e modulit",
   "enter-module-description-placeholder": "Shkruani përshkrimin e modulit",
   "default-language-label": "Gjuha e paracaktuar",
   "select-default-language-module-placeholder": "Zgjidhni gjuhën e paracaktuar të modulit",
   "select-assessment-label": "Zgjidh Vlerësimin",
   "select-assessment-module-placeholder": "Zgjidhni vlerësimin e modulit",

   "delete-module-title": "Fshi modulin",
   "delete-template-title": "Fshi shabllonin",
   "delete-module-confirm-description":
      "Jeni duke fshirë këtë modul. Ky veprim nuk mund të zhbëhet.",
   "delete-template-confirm-description":
      "Jeni duke fshirë këtë shabllon. Ky veprim nuk mund të zhbëhet.",

   "module-restored-success-title": "Moduli u rikthye me sukses!",
   "module-restored-success-description": "Ky modul u rikthye me sukses.",
   "module-restore-error-description":
      "Kishim një problem në rikthimin e këtij moduli, ju lutemi provoni përsëri.",
   "deleted-modules-list-title": "Lista e moduleve të fshira",
   "restore-modules-button": "Rikthe modulet",
   "deleted-modules-description":
      "Këtu mund të shikoni dhe rikthoni modulet e fshira. Çdo modul që nuk është rikthyer brenda 60 ditësh do të fshihet përgjithmonë.",

   "module-name-required-validation": "Emri i modulit është i detyrueshëm",
   "upload-module-file-label": "Ngarko skedarin e modulit",
   "drag-drop-file-text": "Tërhiqni dhe lëshoni skedarin këtu, ose",
   "click-to-select-file-text": "klikoni për të zgjedhur skedarin",
   "max-file-size-text": "Madhësia maksimale e skedarit: 20MB",

   "module-create-error-description":
      "Kishim një problem në krijimin e këtij moduli, ju lutemi provoni përsëri.",
   "make-module-template-label": "Bëje këtë modul një shabllon",

   "not-a-xlsx-file-error": "nuk është skedar xlsx",
   "upload-valid-xlsx-error": "Ju lutemi ngarkoni një skedar të vlefshëm xlsx përpara se të dërgoni.",
   "error-title": "Gabim",
   "survey-imported-success-description": "Moduli u importua me sukses",
   "survey-import-failed-error": "Importimi i modulit dështoi.",
   "copy-file-name-tooltip": "Kopjo emrin e skedarit",
   "copied-tooltip": "U kopjua!",
   "module-must-have-right-format-text":
      "Moduli juaj duhet të ketë formatin e duhur për t'u importuar saktë.",
   "download-format-link": "Shkarko formatin",
   "enter-description-placeholder": "Shkruani përshkrimin",

   "min-3-characters-validation": "Minimumi 3 karaktere",
   "language-required-validation": "Gjuha është e detyrueshme",
   "assessment-required-validation": "Vlerësimi është i detyrueshëm",
   "new-module-suffix": "Modul i ri",

   "edit-module-title": "Ndrysho modulin",
   "module-description-label": "Përshkrimi i modulit",

   "template-deleted-success-title": "Shablloni u fshi me sukses!",
   "template-deleted-success-description":
      "Ky shabllon u fshi me sukses nga baza juaj e të dhënave.",
   "template-delete-error-description":
      "Kishim një problem në fshirjen e këtij shablloni, ju lutemi provoni përsëri.",
   "edit-template-alt": "Ndrysho shabllonin",
   "download-template-alt": "Shkarko shabllonin",
   "duplicate-template-alt": "Dyfisho shabllonin",
   "delete-template-alt": "Fshi shabllonin",
   "copy-action": "Kopjo",
   "module-title-column": "Titulli i modulit",
   "created-on-column": "Krijuar më",
   "last-updated-column": "Përditësuar së fundmi",

   "copy-suffix-label": "Kopje",
   "template-duplicated-success-title": "Shablloni u dyfishua me sukses!",
   "template-duplicated-success-description":
      "Shablloni juaj u dyfishua me sukses. Tani mund të ndryshoni dhe personalizoni kopjen e re.",
   "template-duplicate-error-description":
      "Kishim një problem në dyfishimin e këtij shablloni, ju lutemi provoni përsëri.",
   "copy-template-title": "Kopjo shabllonin",
   "copy-template-description":
      "Jeni duke krijuar një shabllon të ripërdorshëm bazuar në strukturën e këtij moduli. Do të mund ta përdorni këtë shabllon për të krijuar shpejt module të reja.",
   "template-name-label": "Emri i shabllonit",
   "template-name-required-validation": "Emri i shabllonit është i detyrueshëm",
   "enter-template-name-placeholder": "Shkruani emrin e shabllonit",
   "description-optional-label": "(opsionale)",
   "template-description-hint-placeholder":
      "Një shënim i shkurtër për t'i ndihmuar ekipin tuaj të kuptojë kur ta përdorë këtë shabllon",

   "no-templates-found-title": "Nuk u gjetën shabllone",
   "no-templates-found-description":
      "Nuk ka shabllone të disponueshme për momentin. Provoni përsëri më vonë ose krijoni një të ri!",
   "sections-label": "Seksionet:",
   "use-template-button": "Përdor shabllonin",

   "template-created-success-title": "Shablloni u krijua me sukses!",
   "template-created-success-description":
      "Shablloni juaj i ri u krijua nga struktura e këtij moduli. Tani mund ta ndryshoni ose ta përdorni për të krijuar shpejt module të reja.",
   "template-create-error-description":
      "Kishim një problem në krijimin e këtij shablloni, ju lutemi provoni përsëri.",
   "convert-module-to-template-title": "Kthe modulin në shabllon",
   "module-label": "Moduli",
   "structure-logic-copied-note":
      "Shënim: Vetëm struktura dhe logjika do të kopjohen, përgjigjet nuk do të përfshihen.",
   "create-template-button": "Krijo shabllonin",

   "fetch-drafts-error": "Marrja e skicave dështoi",
   "module-saved-draft-success": "Moduli u ruajt si skicë me sukses",
   "save-draft-error": "Ruajtja e skicës dështoi",
   "reject-module-error": "Refuzimi i modulit dështoi",
   "submit-module-error": "Dërgimi i modulit dështoi",
   "preview-other-modules-text": "Shiko modulet e tjera në këtë vlerësim",
   "my-saved-drafts-button": "Skicat e mia të ruajtura",
   "save-as-draft-button": "Ruaj si skicë",
   "processing-text": "Duke procesuar...",
   "submit-module-button": "Dërgo modulin",
   "reject-module-button": "Refuzo modulin",
   "approve-module-button": "Mirato modulin",

   "change-status-button": "Ndrysho statusin",
   "change-module-status-editing-title": "Ndrysho statusin e modulit në Në redaktim",
   "change-module-status-editing-confirm-description":
      "Jeni duke ndryshuar statusin e modulit në Në redaktim.",

   "language-label": "Gjuha",
   "select-language-placeholder": "Zgjidhni gjuhën",
   "print-module-button": "Printo Modulin",

   "save-as-draft-title": "Ruaj si skicë",
   "save-draft-description":
      "Për të ruajtur një skicë të këtij moduli, jepini një emër që ta rishikoni më vonë. Skicat që ruani ruhen në bazën tonë të të dhënave.",
   "save-draft-button": "Ruaj Skicën",

   "start-new-draft-button": "Fillo një skicë të re",
   "my-saved-draft-title": "Skica ime e ruajtur",
   "unsubmitted-drafts-description": "Keni skica të padërguara për këtë modul.",
   "continue-draft-or-new-question": "Dëshironi të vazhdoni me një skicë apo të filloni një të re?",
   "my-draft-label": "Skica ime",
   "no-drafts-found-text": "Nuk u gjetën skica. Filloni një skicë të re.",

   "submit-module-confirm-description-part1":
      "Jeni gati të dërgoni këtë modul. Sapo të vazhdoni, përgjigjet tuaja do t'i dërgohen menaxherit të projektit për shqyrtim dhe miratim.",
   "submit-module-confirm-description-part2":
      "Ju lutemi sigurohuni që të gjitha përgjigjet tuaja janë të sakta, pasi nuk do të mund të bëni ndryshime pasi të dërgohen.",

   "approve-request-confirm-description":
      "Jeni gati të miratoni këtë kërkesë. Ky veprim nuk mund të zhbëhet.",
   "feedback-required-validation": "Komenti është i detyrueshëm",
   "reject-module-description-part1":
      "Ju lutemi jepni komente të detajuara për arsyen pse ky modul po refuzohet.",
   "reject-module-description-part2":
      "Kjo do të shërbejë si udhëzues për anëtarin përgjegjës të ekipit për të bërë korrigjimet e nevojshme.",
   "why-rejecting-module-label": "Pse po e refuzoni këtë modul?",
   "enter-rejection-reason-placeholder": "Ju lutemi shkruani arsyen e refuzimit",

   "module-status-label": "Statusi i modulit:",
   "survey-status-published": "Publikuar",
   "edit-module-details-tooltip": "Ndrysho Detajet e Modulit",
   "page-preparing-text": "Faqja po përgatitet...",

   "add-section-to-module-tooltip": "Shto seksion në modul",
   "add-inner-section-tooltip": "Shto seksion të brendshëm",

   "question-type-section": "Seksioni",
   "question-type-select-one": "Zgjidh një",
   "question-type-text": "Tekst",
   "question-type-file-upload": "Ngarko skedar",
   "question-type-date": "Data",
   "question-type-phone-number": "Numri i telefonit",
   "question-type-rating": "Vlerësim",
   "question-type-ranking": "Renditje",
   "question-type-select-multiple": "Zgjidh disa",
   "question-type-note": "Shënim",
   "question-type-date-time": "Data dhe ora",
   "question-type-time": "Ora",
   "question-type-number": "Numër",
   "question-type-acknowledge": "Konfirmim",
   "question-type-matrix": "Matricë",
   "type-section-label-placeholder": "Ju lutemi shkruani etiketën e seksionit",
   "type-question-label-placeholder": "Ju lutemi shkruani etiketën e pyetjes",

   "option-placeholder": "Opsioni",
   "enter-note-text-above": "Ju lutemi shkruani tekstin e shënimit më sipër.",
   "calculate-question-coming-soon": "Pyetja e llogaritjes - së shpejti...",
   "file-upload-caps-label": "NGARKO SKEDAR",
   "items-to-be-ranked-label": "Artikujt për t'u renditur",
   "text-question-type-label": "Lloji i pyetjes: Tekst",
   "question-displayed-as-table-text": "Kjo pyetje do të shfaqet si tabelë",
   "row-questions-title": "Pyetjet e rreshtave",
   "columns-questions-title": "Pyetjet e kolonave",
   "allow-numbers-range-only-text": "Lejo vetëm numra nga një interval",
   "gps-question-coming-soon": "Pyetja GPS - së shpejti...",
   "type-label-optional-placeholder": "Shkruani një etiketë (opsionale)",
   "optional-placeholder": "Opsionale",
   "reverse-answers-order-button": "Përmbys renditjen e përgjigjeve",
   "type-answer-choice-placeholder": "Shkruani një zgjedhje përgjigjeje",
   "label-text": "Etiketa",
   "select-an-option-placeholder": "Zgjidh një opsion",
   "select-a-scale-placeholder": "Zgjidh një shkallë",
   "enter-bulk-action-placeholder": "Shkruani veprimin në masë",
   "to-divider-label": "Deri",
   "collect-date-info-text": "Mbledh informacionin e datës",
   "collect-time-info-text": "Mbledh informacionin e orës",
   "collect-phone-number-info-text": "Mbledh informacionin e numrit të telefonit",
   "type-a-question-placeholder": "Shkruani një pyetje",
   "min-label": "min:",
   "max-label": "maks:",
   "max-options-chosen-text": "Numri maksimal i opsioneve që mund të zgjidhen",
   "all-options-label": "Të gjitha",
   "answer-genius-label": "Gjeniu i përgjigjeve",
   "add-choices-button": "Shto Zgjedhjet",
   "bulk-actions-label": "Veprime në Masë",
   "enter-each-answer-choice-line-text": "Shkruani çdo zgjedhje përgjigjeje në një rresht të veçantë.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "Përgjigje e detyrueshme",
   "delete-question-confirm-title": "Jeni i sigurt që dëshironi të fshini këtë pyetje?",
   "delete-section-confirm-title": "Jeni i sigurt që dëshironi të fshini këtë seksion?",
   "this-action-cannot-be-undone-text": "Ky veprim nuk mund të zhbëhet",
   "yes-confirm-button": "Po",
   "no-confirm-button": "Jo",
   "add-new-question-button": "Shto pyetje të re",
   "add-new-inner-section-button": "Shto nën-seksion të ri",
   "add-new-section-button": "Shto seksion të ri",

   // Skip logic (admin/survey v2)
   "show-logic-button": "Shfaq Logjikën",
   "display-condition-prefix-text": "Shfaq",
   "question-word-label": "Pyetja",
   "when-following-conditions-apply-text": "kur plotësohen kushtet e mëposhtme:",
   "add-another-condition-button": "Shto Kusht Tjetër",
   "should-match-all-the-criteria-placeholder-text": "duhet të përputhet me të gjitha kriteret",
   "should-match-all-of-these-criteria-text": "duhet të përputhet me të gjitha këto kritere",
   "should-match-any-of-these-criteria-text": "duhet të përputhet me çdo kriter nga këto",
   "operator-was-not-answered-label": "Nuk u përgjigj",
   "operator-was-answered-label": "U përgjigj",
   "operator-equals-label": "Barazohet me (=)",
   "operator-not-equals-label": "Nuk barazohet me (!=)",
   "operator-greater-than-label": "Më e madhe se (>)",
   "operator-less-than-label": "Më e vogël se (<)",
   "operator-greater-than-or-equal-label": "Më e madhe ose e barabartë me (>=)",
   "operator-less-than-or-equal-label": "Më e vogël ose e barabartë me (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "Ky fushë është e detyrueshme",
   "type-your-answer-here-placeholder": "Shkruani përgjigjen tuaj këtu",
   "you-must-select-text": "Duhet të zgjidhni",
   "you-must-enter-date-and-time-text": "Duhet të vendosni një datë dhe orë",
   "you-must-enter-a-number-text": "Duhet të vendosni një numër",
   "drag-drop-files-text": "Tërhiqni dhe lëshoni skedarët këtu, ose klikoni për të zgjedhur skedarë",
   "uploaded-file-label": "Skedari i ngarkuar:",
   "you-must-upload-file-text": "Duhet të ngarkoni një skedar",
   "all-rankings-must-be-selected-text": "Të gjitha renditjet duhet të zgjidhen",
   "please-specify-placeholder": "Ju lutemi specifikoni",
   "you-can-select-up-to-text": "Mund të zgjidhni deri në",
   "choices-suffix-text": "zgjedhje.",
   "you-must-select-at-least-one-text": "Duhet të zgjidhni të paktën një",
   "you-must-select-one-text": "Duhet të zgjidhni një",
   "you-must-select-a-time-text": "Duhet të zgjidhni një orë",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "Ende nuk është bërë asnjë dorëzim për këtë modul.",
   "approval-successful-title": "I suksesshëm",
   "submission-approved-successfully-text": "Dorëzimi u aprovua me sukses",
   "fetch-submission-answers-error": "Dështoi marrja e përgjigjeve të dorëzimit",
   "approve-without-review-button": "Miratoje pa rishikim",
   "send-for-approval-button": "Dërgo për miratim",
   "approve-module-pending-approver-description":
      "Jeni gati të miratoni këtë modul. Pasi të vazhdoni, ai do t'i dërgohet aprovuesit për një rishikim final para se statusi i tij të shënohet si",
   "approve-module-final-description-part1":
      "Jeni gati të jepni miratimin final për këtë modul. Pasi të vazhdoni, statusi i tij do të shënohet si",
   "approve-module-final-description-part2":
      "dhe rezultatet e tij do të jenë të disponueshme për analizë. Ky veprim nuk mund të zhbëhet. Jeni i sigurt që dëshironi të vazhdoni?",
   "send-to-approver-for-review-label": "Dërgo tek aprovuesi për rishikim final",
   "approver-review-recommended-hint": "E rekomanduar - anashkalimi i kësaj e finalizon menjëherë modulin.",
   "skipping-approver-review-warning-text":
      "Ju po anashkaloni rishikimin e aprovuesit. Ky modul do të përfundojë pa një kontroll të dytë.",
   "enter-detailed-feedback-placeholder": "Ju lutemi shkruani komentin tuaj të detajuar këtu",

   // Approver management (admin/approver)
   "department-team-label": "Departamenti/Ekipi",
   "enter-approver-name-placeholder": "Shkruani emrin e aprovuesit",
   "enter-approver-email-placeholder": "Shkruani email-in e aprovuesit",
   "enter-approver-department-placeholder": "Shkruani departamentin e aprovuesit",
   "approver-added-success-title": "Aprovuesi u shtua me sukses!",
   "approver-added-success-description": "Ky aprovues tani mund t'i caktohet vlerësimeve.",
   "approver-updated-success-title": "Aprovuesi u përditësua me sukses!",
   "approver-updated-success-description": "Detajet e këtij aprovuesi janë përditësuar.",
   "approver-add-error-description":
      "Kishim një problem në shtimin e këtij aprovuesi, ju lutemi provoni përsëri.",
   "approver-update-error-description":
      "Kishim një problem në përditësimin e këtij aprovuesi, ju lutemi provoni përsëri.",
   "approver-delete-error-description":
      "Kishim një problem në fshirjen e këtij aprovuesi, ju lutemi provoni përsëri.",
   "approver-deleted-success-title": "Aprovuesi u fshi me sukses!",
   "approver-deleted-success-description": "Ky aprovues është hequr.",
   "delete-approver-title": "Fshi aprovuesin",
   "delete-approver-confirm-text": "Jeni gati të fshini këtë aprovues.",
   "add-approver-title": "Shto Aprovues",
   "edit-approver-title": "Ndrysho Aprovuesin",
   "add-approver-button": "Shto aprovues",
   "approvers-title": "Aprovuesit",
   "search-approver-by-name-placeholder": "Kërko një aprovues me emrin e tij",
   "filter-approvers-by-department-placeholder": "Filtro aprovuesët sipas departamentit",

   // Approver submissions (approver-facing pages)
   "no-data-text": "Nuk ka të dhëna",
   "submitted-by-column": "Dorëzuar nga",
   "pending-modules-title": "Module në pritje",
   "approved-modules-title": "Module të miratuara",
   "rejected-modules-title": "Module të refuzuara",
   "filter-tasks-by-submission-date-placeholder": "Filtro detyrat sipas datës së dorëzimit",
   "module-approvals-title": "Miratimet e moduleve",
   "pending-modules-review-description":
      "Kjo është lista e moduleve në pritje të rishikimit tuaj. Për të vazhduar, klikoni në secilin modul ku do të mund ta pranoni ose ta refuzoni.",
   "the-approver-label": "aprovuesi",
   "approver-label": "Aprovuesi",
   "select-an-approver-placeholder": "Zgjidhni një aprovues",
   "go-to-revise-module-button": "Shko për të rishikuar modulin",
   "rejected-module-information-title": "Informacioni i modulit të refuzuar",
   "feedback-from-label-prefix": "Komenti nga",
   "the-project-manager-label": "menaxheri i projektit",
   "awaiting-approver-status": "Në pritje të aprovuesit",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "Titulli i modulit",
   "enter-module-title-placeholder": "Shkruani titullin e modulit",
   "module-description-label": "Përshkrimi i Modulit",
   "assigned-assessment-label": "Vlerësimi i Caktuar",
   "survey-updated-success-title": "Sondazhi u përditësua me sukses!",
   "module-updated-success-description": "Ky modul u përditësua saktë.",
   "edit-module-error-description":
      "Kishim një problem në modifikimin e këtij moduli, ju lutemi provoni përsëri.",
   "form-builder-tab-label": "Ndërtuesi i Formularit",
   "logic-builder-tab-label": "Ndërtuesi i Logjikës",
   "translate-questions-tab-label": "Përkthe Pyetjet",
   "score-questions-tab-label": "Vlerëso Pyetjet",
   "stay-here-button": "Qëndro këtu",
   "change-tab-button": "Ndrysho skedën",
   "unsaved-progress-title": "Progres i paruajtur",
   "unsaved-changes-tab-text": "Keni ndryshime të paruajtura në këtë skedë.",
   "confirm-proceed-without-saving-part1": "Jeni i sigurt që dëshironi të vazhdoni",
   "confirm-proceed-without-saving-part2": "pa ruajtur progresin?",
   "module-status-changed-success-title": "Statusi i modulit u ndryshua me sukses!",
   "module-status-changed-success-description": "Statusi i këtij moduli është ndryshuar saktë.",
   "problem-occurred-title": "Ndodhi një problem!",
   "change-status-error-description":
      "Kishim një problem në ndryshimin e statusit të këtij moduli, ju lutemi provoni përsëri.",
   "publish-module-button": "Publiko Modulin",
   "change-status-to-editing-button": "Ndrysho statusin në Redaktim",
   "changes-saved-success-description": "Ndryshimet u ruajtën me sukses",
   "save-progress-button": "Ruaj Progresin",
   "skip-logic-saved-success-description": "Logjikat e kalimit u shtuan me sukses",
   "score-points-saved-success-description": "Pikët e vlerësimit u shtuan me sukses",
   "total-module-score-label": "Pikët totale të Modulit:",
   "points-suffix": "pikë",
   "answers-column-label": "Përgjigjet",
   "score-column-label": "Rezultati",
   "input-score-placeholder": "Vendos rezultatin",
   "max-score-label": "Rezultati Maksimal:",
   "date-answer-label": "Përgjigja e datës",
   "time-answer-label": "Përgjigja e orës",
   "answer-keywords-label": "Fjalët kyçe të përgjigjes",
   "section-score-label": "Rezultati i seksionit:",
   "number-range-hint-prefix": "Diapazoni për këtë pyetje është",
   "number-range-hint-value": "1 deri në 50",
   "number-range-hint-suffix":
      ". Ju lutemi zgjidhni zgjedhjet e sakta të përgjigjeve për vlerësim:",
   "select-right-answer-choices-placeholder": "Zgjidhni zgjedhjet e sakta të përgjigjeve",
   "single-number-option-label": "Numër i vetëm",
   "range-option-label": "Diapazon",
   "enter-range-correct-answers-label": "Vendosni diapazonin e përgjigjeve të sakta",
   "to-connector-label": "deri",
   "enter-correct-number-label": "Vendosni numrin e saktë",
   "input-number-placeholder": "Vendos numrin",
   "ranking-score-instructions-text":
      "Ju lutemi organizoni opsionet në rendin e saktë, më pas jepni një rezultat për secilën",
   "input-phone-number-placeholder": "Vendos numrin e telefonit",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "Moduli Kryesor",
   "main-module-description-text": "Këto janë pyetjet nga moduli juaj kryesor",
   "default-language-placeholder": "Gjuha e Parazgjedhur",
   "translate-module-title": "Përkthe Modulin",
   "write-translation-here-text": "Shkruani përkthimin e secilës pyetje këtu",
   "translate-to-label": "Përkthe Në",
   "select-a-language-placeholder": "--Zgjidhni një Gjuhë--",
   "select-language-first-error": "Ju lutemi zgjidhni një gjuhë së pari",
   "translation-saved-success-description": "Përkthimi u ruajt me sukses",
   "save-translation-button": "Ruaj përkthimin",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "Moduli është i detyrueshëm",
   "at-least-one-section-required-validation": "Të paktën një seksion është i detyrueshëm",
   "resource-type-required-validation": "Lloji i burimit është i detyrueshëm",
   "at-least-one-attachment-required-validation": "Të paktën një bashkëngjitje është e detyrueshme",
   "description-required-validation": "Përshkrimi është i detyrueshëm",
   "tagged-topics-required-validation": "Temat e etiketuara janë të detyrueshme",
   "invalid-url-format-validation": "Format URL i pavlefshëm",
   "link-url-required-validation": "URL-ja e lidhjes është e detyrueshme",
   "agree-to-terms-required-validation": "Duhet të pranoni kushtet",
   "section-required-validation": "Seksioni është i detyrueshëm",
   "resources-added-success-title": "Burimet u shtuan me sukses!",
   "resources-added-success-description":
      "Këto burime janë krijuar dhe shtuar në bazën tuaj të të dhënave.",
   "upload-resource-matching-type-error":
      "Ju lutemi ngarkoni një burim që përputhet me llojin e zgjedhur.",
   "resources-updated-success-title": "Burimet u përditësuan me sukses!",
   "resources-updated-success-description": "Këto burime janë përditësuar me sukses.",
   "add-new-resource-title": "Burim i ri",
   "edit-resource-title": "Ndrysho burimin",
   "resource-upload-shared-repository-notice":
      "Çdo burim që ngarkoni në platformë do të publikohet në depozitën e përbashkët të KAPorg, duke e bërë të disponueshëm për përdoruesët e tjerë për ta shkarkuar dhe ndarë, duke nxitur mbështetjen e komunitetit.",
   "select-module-link-resource-label": "Zgjidhni modulin me të cilin dëshironi të lidhni këtë burim",
   "all-modules-in-assessment-placeholder": "Të gjitha modulet në këtë vlerësim",
   "select-section-link-resource-label":
      "Zgjidhni seksionin e modulit me të cilin dëshironi të lidhni këtë burim",
   "all-sections-of-module-placeholder": "Të gjitha seksionet e modulit",
   "resource-information-title": "Informacioni i burimit",
   "select-resource-type-label": "Zgjidhni llojin e burimit",
   "before-upload-select-type-hint": "Para se të ngarkoni një burim duhet të zgjidhni llojin e tij",
   "paste-link-here-label": "Ngjit lidhjen këtu",
   "enter-link-url-placeholder": "Vendosni URL-në e lidhjes",
   "upload-file-here-label": "Ngarko skedarin këtu",
   "drag-drop-file-here-prefix": "Tërhiqni dhe lëshoni skedarin këtu, ose",
   "click-to-select-file-text": "klikoni për të zgjedhur skedarin",
   "max-file-size-text": "Madhësia maksimale e skedarit: 20MB",
   "enter-resource-description-label": "Vendosni përshkrimin e burimit",
   "tagged-topics-label": "Temat e etiketuara",
   "enter-tagged-topics-placeholder": "Vendosni temat me të cilat ky burim mund të lidhet",
   "upload-rights-confirmation-text":
      "Duke ngarkuar këtë material, konfirmoj që kam të drejtat dhe lejet e nevojshme për ta bërë këtë.",
   "add-resource-button": "Shto burimin",
   "expert-name-column": "Emri i ekspertit",
   "operating-countries-column": "Vendet operuese",
   "years-of-experience-column": "Vite përvoje",
   "expert-cv-column": "CV i ekspertit",
   "areas-of-expertise-column": "Fushat e ekspertizës",
   "assign-experts-to-assessment-title": "Cakto ekspertë për këtë vlerësim",
   "select-expert-assign-assessment-text":
      "Zgjidhni ekspertin që dëshironi të caktoni për këtë vlerësim.",
   "search-resource-by-name-placeholder": "Kërko një burim me emrin e tij",
   "assign-expert-to-assessment-button": "Cakto ekspertin për këtë vlerësim",
   "expert-assigned-success-title": "Eksperti u caktua me sukses!",
   "expert-assigned-success-description":
      "Ky ekspert është caktuar dhe shtuar në bazën tuaj të planit të veprimit.",
   "assign-expert-error-description":
      "Kishim një problem në caktimin e këtij eksperti në planin tuaj të veprimit, ju lutemi provoni përsëri.",
   "expert-removed-success-title": "Eksperti u hoq me sukses!",
   "expert-removed-success-description":
      "Ky ekspert është hequr nga baza juaj e planit të veprimit.",
   "remove-expert-from-assessment-button": "Hiq ekspertin nga ky vlerësim",
   "email-label-colon": "Email:",
   "description-label-colon": "Përshkrimi:",
   "no-description-available-text": "Nuk ka përshkrim të disponueshëm",
   "no-expertise-listed-text": "Nuk ka ekspertizë të listuar",
   "field-of-study-label": "Fusha e studimit",
   "no-field-of-study-listed-text": "Nuk ka fushë studimi të listuar",
   "no-operating-countries-listed-text": "Nuk ka vende operuese të listuara",
   "languages-label": "Gjuhët",
   "no-languages-listed-text": "Nuk ka gjuhë të listuara",
   "linkedin-profile-label": "Profili në LinkedIn",
   "no-linkedin-profile-text": "Nuk është dhënë profil LinkedIn",
   "delete-collection-title": "Fshi koleksionin",
   "delete-collection-confirm-text":
      "Jeni gati të fshini këtë koleksion. Ky veprim nuk mund të zhbëhet.",
   "delete-resource-title": "Fshi burimin",
   "delete-resource-confirm-text": "Jeni gati të fshini këtë burim. Ky veprim nuk mund të zhbëhet.",
   "collection-deleted-success-title": "Koleksioni u fshi me sukses!",
   "collection-deleted-success-description":
      "Ky koleksion u hoq me sukses nga baza juaj e të dhënave.",
   "resource-deleted-success-title": "Burimi u fshi me sukses!",
   "resource-deleted-success-description": "Ky burim u hoq me sukses nga baza juaj e të dhënave.",
   "delete-resource-error-description":
      "Kishim një problem në fshirjen e këtij burimi, ju lutemi provoni përsëri.",
   "resource-preview-title": "Pamja paraprake e burimit",
   "document-type-label": "Dokument",
   "video-type-label": "Video",
   "slide-type-label": "Slajd",
   "tags-and-categories-label": "Etiketat dhe kategoritë",
   "upload-date-label": "Data e ngarkimit",
   "description-label": "Përshkrimi",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "Statusi:",
   "assign-to-label-colon": "Cakto tek:",
   "deadline-label-colon": "Afati:",
   "resources-attached-section-text": "Burimet e bashkangjitura në këtë seksion",
   "resource-link-label-colon": "Kjo është lidhja e burimit:",
   "task-title-required-validation": "Titulli i detyrës është i detyrueshëm",
   "deadline-required-validation": "Afati është i detyrueshëm",
   "create-new-task-title": "Krijo një detyrë të re",
   "edit-task-title": "Ndrysho detyrën",
   "task-title-label": "Titulli i detyrës",
   "task-title-example-placeholder": "Sa shpesh u ofroni trajnim punonjësve tuaj?",
   "enter-task-instruction-placeholder":
      "Vendosni një shënim ose udhëzim që e ndihmon personin e caktuar të kryejë detyrën",
   "assign-task-to-label": "Cakto detyrën për",
   "select-member-assign-task-placeholder": "Zgjidhni anëtarin për t'i caktuar këtë detyrë",
   "cant-find-member-assign-task-text": "Nuk e gjeni anëtarin për t'i caktuar një detyrë?",
   "add-in-organization-management-text": "Shtoje në menaxhimin e organizatës",
   "upload-files-complete-task-label": "Ngarko skedarët e nevojshëm për të përfunduar këtë detyrë",
   "can-add-up-to-3-resources-text": "Mund të shtoni deri në 3 burime",
   "deadline-label": "Afati",
   "resource-link-optional-label": "A është burimi juaj një lidhje? Ju lutemi vendoseni këtu",
   "enter-resource-link-placeholder": "Vendosni lidhjen e burimit tuaj",
   "assign-task-title": "Cakto detyrën",
   "assign-task-at-least-one-member-validation": "Cakto detyrën për të paktën një anëtar",
   "deadline-valid-date-validation": "Afati duhet të jetë një datë e vlefshme",
   "select-deadline-placeholder": "Zgjidhni afatin",
   "task-added-assigned-success-title": "Detyra u shtua dhe u caktua me sukses!",
   "task-added-assigned-success-description":
      "Kjo detyrë u caktua me sukses, anëtari që zgjodhët do të njoftohet për të.",
   "assign-task-error-description": "Kishim një problem në caktimin e kësaj detyre, ju lutemi provoni përsëri.",
   "select-status-title": "Zgjidhni statusin",
   "task-updated-success-title": "Detyra u përditësua me sukses!",
   "task-updated-success-description": "Kjo detyrë u përditësua me sukses në bazën tuaj të të dhënave.",
   "update-task-error-description": "Kishim një problem në përditësimin e kësaj detyre, ju lutemi provoni përsëri.",
   "task-deleted-success-title": "Detyra u fshi me sukses!",
   "task-deleted-success-description": "Kjo detyrë u hoq me sukses nga baza juaj e të dhënave.",
   "delete-task-error-description": "Kishim një problem në fshirjen e kësaj detyre, ju lutemi provoni përsëri.",
   "delete-task-title": "Fshi detyrën",
   "delete-task-confirm-text": "Jeni gati të fshini këtë detyrë. Ky veprim nuk mund të zhbëhet.",
   "rounds-filter-label": "Raundet",
   "managers-filter-label": "Menaxherët",
   "generate-report-button": "Gjenero raportin",
   "generate-report-title": "Gjenero Raportin",
   "choose-sections-report-text": "Zgjidhni seksionet që duhet të përfshihen në raport.",
   "include-module-breakdown-label": "Përfshi ndarjen sipas moduleve",
   "of-label": "nga",
   "sections-selected-suffix": "seksione të zgjedhura",
   "generate-button": "Gjenero",
   "report-preview-title": "Pamje paraprake e raportit",
   "edit-sections-button": "Modifiko seksionet",
   "assessment-report-eyebrow-text": "Raporti i Vlerësimit",
   "no-sections-data-selected-text": "Nuk ka seksione me të dhëna të zgjedhura.",
   "assessment-report-pdf-heading": "RAPORTI I VLERËSIMIT",
   "exported-on-label": "Eksportuar më",
   "page-word": "Faqja",
   "add-review-note-title": "Shto shënim rishikimi",
   "edit-review-note-title": "Modifiko shënimin e rishikimit",
   "note-title-required-validation": "Ju lutemi shkruani titullin e shënimit",
   "enter-note-title-placeholder": "Shkruani titullin e shënimit",
   "round-covered-label": "Raundi i mbuluar",
   "select-option-required-validation": "Ju lutemi zgjidhni një opsion",
   "note-required-validation": "Ju lutemi shkruani shënimet tuaja",
   "summarize-progress-placeholder": "Përmblidhni progresin kryesor, vendimet ose çështjet.",
   "add-note-button": "Shto shënim",
   "staff-members-fetch-error": "Kishim një problem në marrjen e stafit, ju lutemi rifreskoni faqen.",
   "task-priority-fetch-error":
      "Kishim një problem në marrjen e prioritetit të detyrës, ju lutemi rifreskoni faqen.",
   "select-section-add-task-error": "Ju lutemi zgjidhni një seksion për të shtuar këtë detyrë.",
   "add-task-error-description": "Kishim një problem në shtimin e kësaj detyre, ju lutemi provoni përsëri.",
   "add-new-task-title": "Shto detyrë të re",
   "task-name-label": "Emri i detyrës",
   "task-name-required-validation": "Ju lutemi shkruani emrin e detyrës",
   "enter-task-name-placeholder": "Shkruani emrin e detyrës",
   "linked-questions-label": "Pyetjet e lidhura",
   "select-questions-required-validation": "Ju lutemi zgjidhni pyetjet",
   "linked-questions-helper-text": "Zgjidhni pyetjet që kjo detyrë synon të përmirësojë",
   "select-questions-placeholder": "Zgjidhni pyetjet",
   "task-description-required-validation": "Ju lutemi shkruani një përshkrim",
   "enter-task-description-placeholder": "Shkruani përshkrimin e detyrës",
   "select-member-required-validation": "Ju lutemi zgjidhni një anëtar",
   "select-deadline-required-validation": "Ju lutemi zgjidhni një afat",
   "priority-label": "Prioriteti",
   "select-priority-required-validation": "Ju lutemi zgjidhni prioritetin",
   "select-priority-placeholder": "Zgjidhni prioritetin",
   "resources-label": "Burimet",
   "select-resources-placeholder": "Zgjidhni burimet e lidhura me këtë detyrë",
   "select-resources-required-validation": "Ju lutemi zgjidhni burimet",
   "search-resource-placeholder": "Kërko një burim",
   "browse-resources-library-text": "Shfleto bibliotekën e burimeve",
   "add-task-button": "Shto detyrë",
   "confirm-selection-button": "Konfirmo zgjedhjen",
   "resource-library-title": "Biblioteka e Burimeve",
   "collections-tab-label": "Koleksionet",
   "workspace-breadcrumb-label": "Hapësira e punës",
   "resources-breadcrumb-label": "Burimet",
   "results-breadcrumb-label": "Rezultatet",
   "action-plan-breadcrumb-label": "Plani i veprimit",
   "respondents-count-label": "të anketuar",
   "of-word": "nga",
   "copy-tasks-title": "Kopjo detyrat",
   "copy-tasks-description-text":
      "Të gjitha detyrat nga raundi juaj i mëparshëm do të kopjohen për të siguruar që plani i veprimit të jetë i plotë ndërsa zhvillohet me kalimin e kohës.",
   "previous-round-label": "Raundi i mëparshëm:",
   "tasks-copied-label": "Detyra të kopjuara",
   "task-statistics-fetch-error":
      "Kishim një problem në ngarkimin e statistikave të detyrave, ju lutemi provoni përsëri.",
   "delete-note-confirm-text": "Jeni gati të fshini këtë shënim rishikimi. Ky veprim nuk mund të zhbëhet.",
   "delete-view-title": "Fshi pamjen",
   "delete-view-confirm-text": "Jeni gati të fshini këtë pamje. Ky veprim nuk mund të zhbëhet.",
   "rename-view-title": "Riemërto pamjen",
   "save-button": "Ruaj",
   "select-a-resource-title": "Zgjidhni një burim",
   "set-a-reminder-title": "Vendos një kujtues",
   "reminder-description-text":
      "Zgjidhni kur dëshironi të kujtoheni për të shtuar ose përditësuar shënimet e progresit të ekipit tuaj.",
   "reminder-type-label": "Lloji i kujtuesit",
   "select-reminder-type-required-validation": "Ju lutemi zgjidhni një lloj kujtuesi",
   "select-day-required-validation": "Ju lutemi zgjidhni një ditë",
   "select-a-day-placeholder": "Zgjidhni një ditë",
   "reminder-repeat-prefix-text":
      "Kjo do të jetë data e parë e kujtuesit tuaj. Kujtuesit e ardhshëm do të përsëriten çdo",
   "repeat-interval-week": "javë",
   "repeat-interval-2-weeks": "2 javë",
   "repeat-interval-month": "muaj",
   "repeat-interval-3-months": "3 muaj",
   "repeat-interval-year": "vit",
   "reminder-repeat-suffix-text": "në të njëjtën ditë.",
   "next-reminder-date-label": "Data e kujtuesit të ardhshëm:",
   "save-reminder-button": "Ruaj kujtuesin",
   "my-workspaces-tab": "Hapësirat e mia të punës",
   "all-workspaces-tab": "Të gjitha hapësirat e punës",
   "fetch-workspaces-error-description":
      "Kishim një problem në marrjen e hapësirave të punës, ju lutemi provoni përsëri.",
   "archived-workspaces-title": "Hapësirat e punës të arkivuara",
   "deleted-workspaces-button": "Hapësirat e punës të fshira",
   "new-workspace-button": "Hapësirë e re pune",
   "remove-action": "Hiq",
   "workspace-name-label": "Emri i hapësirës së punës",
   "enter-workspace-name-placeholder": "Shkruani emrin e hapësirës suaj të punës",
   "workspace-description-label": "Përshkrimi i hapësirës së punës",
   "enter-workspace-description-placeholder": "Shkruani përshkrimin e hapësirës së punës",
   "workspace-countries-label": "Shtetet e hapësirës së punës",
   "select-a-country-placeholder": "Zgjidhni një shtet",
   "workspace-assessment-label": "Vlerësimi i hapësirës së punës",
   "select-default-assessment-survey-placeholder": "Zgjidhni vlerësimin e paracaktuar të pyetësorit",
   "select-default-assessment-module-placeholder": "Zgjidhni vlerësimin e paracaktuar të modulit",
   "workspace-duplicate-name-validation": "Kjo hapësirë pune ekziston tashmë. Ju lutemi provoni një tjetër.",
   "workspace-created-success-title": "Hapësira e punës u krijua me sukses!",
   "workspace-created-success-description":
      "Një hapësirë e re pune u krijua dhe u shtua në bazën tuaj të të dhënave",
   "create-workspace-error-description":
      "Kishim një problem në krijimin e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "add-new-workspace-title": "Shto hapësirë të re pune",
   "workspace-updated-success-title": "Hapësira e punës u përditësua me sukses!",
   "workspace-updated-success-description": "Kjo hapësirë pune u përditësua me sukses.",
   "update-workspace-error-description":
      "Kishim një problem në përditësimin e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "edit-workspace-title": "Modifiko hapësirën e punës",
   "at-least-one-assessment-required-validation": "Kërkohet të paktën një vlerësim",
   "workspace-archived-success-title": "Hapësira e punës u arkivua me sukses!",
   "workspace-archived-success-description": "Kjo hapësirë pune u arkivua me sukses.",
   "archive-workspace-error-description":
      "Kishim një problem në arkivimin e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "archive-workspace-title": "Arkivo Hapësirën e Punës",
   "archive-workspace-confirm-text": "Jeni gati të arkivoni këtë hapësirë pune.",
   "workspace-deleted-success-title": "Hapësira e punës u fshi me sukses!",
   "workspace-deleted-success-description": "Kjo hapësirë pune u hoq me sukses.",
   "delete-workspace-error-description":
      "Kishim një problem në fshirjen e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "delete-workspace-title": "Fshi Hapësirën e Punës",
   "delete-workspace-confirm-text": "Jeni gati të fshini këtë hapësirë pune.",
   "workspace-restored-success-title": "Hapësira e punës u rikthye me sukses!",
   "restore-workspace-error-description":
      "Kishim një problem në rikthimin e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "workspace-deleted-permanently-success-description":
      "Kjo hapësirë pune u fshi përfundimisht me sukses nga baza juaj e të dhënave.",
   "restore-assessment-error-description":
      "Kishim një problem në rikthimin e këtij vlerësimi, ju lutemi provoni përsëri.",
   "restore-workspaces-button": "Rikthe hapësirat e punës",
   "delete-workspace-permanently-title": "Fshi përfundimisht hapësirën e punës",
   "delete-workspace-permanently-confirm-text":
      "Jeni gati të fshini përfundimisht këtë hapësirë pune. Ky veprim nuk mund të zhbëhet.",
   "workspaces-unarchived-success-title": "Hapësirat e punës u ç'arkivuan me sukses!",
   "workspaces-unarchived-success-description":
      "Këto hapësira pune janë ç'arkivuar dhe shtuar në bazën tuaj të të dhënave.",
   "unarchive-workspace-error-description":
      "Kishim një problem në ç'arkivimin e kësaj hapësire pune, ju lutemi provoni përsëri.",
   "workspaces-deleted-success-title": "Hapësirat e punës u fshinë me sukses!",
   "workspaces-deleted-success-description": "Këto hapësira pune u fshinë nga baza juaj e të dhënave.",
   "deleted-workspaces-list-title": "Lista e hapësirave të punës të fshira",
   "deleted-workspaces-retention-text":
      "Këtu mund të shikoni dhe rikthjeni hapësirat e punës të fshira. Çdo hapësirë pune që nuk rikthehet brenda 60 ditëve do të fshihet përfundimisht.",
   "request-canceled-success-title": "Kërkesa u anulua me sukses!",
   "request-canceled-success-description": "Kërkesa juaj u anulua.",
   "cancel-request-error-description":
      "Kishim një problem në anulimin e kësaj kërkese, ju lutemi provoni përsëri.",
   "cancel-request-button": "Anulo Kërkesën",
   "send-request-success-description":
      "Kërkesa juaj u dërgua tek administratori. Sapo kërkesa të përgjigjet, do të merrni një email.",
   "send-request-error-description":
      "Kishim një problem në dërgimin e kërkesës suaj, ju lutemi provoni përsëri.",
   "no-workspaces-here-title": "Nuk ka hapësira pune këtu!",
   "request-part-workspace-description":
      "Por mos u shqetësoni, mund të kërkoni të bëheni pjesë e një hapësire pune në seksionin «Të gjitha hapësirat e punës».",
   "go-to-all-workspaces-button": "Shko te Të gjitha hapësirat e punës",
   "create-workspaces-tagline-text":
      "Krijoni hapësira pune të përshtatura për të nxitur rritjen dhe optimizimin e organizatave.",
   "export-workspaces-button": "Eksporto Hapësirat e Punës",
   "all-workspaces-consultant-heading": "Të gjitha Hapësirat e Punës",
   "assess-partners-consultant-description":
      "Filloni të vlerësoni Partnerët/OJQ-të lokale dhe siguroni atyre një raport të detajuar të performancës së tyre aktuale.",
   "access-workspace-organization-text": "Hyni në një hapësirë pune dhe filloni të aksesoni organizatën tuaj.",
   "no-workspace-created-yet-description":
      "Duket se nuk keni krijuar asnjë hapësirë pune ende. Por mos u shqetësoni, mund t'i krijoni këtu.",
   "untitled-label": "Pa titull",
   "no-section-label": "Pa seksion",
   "swot-analysis-title": "Analiza SWOT",
   "swot-analysis-subtitle-text": "Analizoni pikat e forta, dobësitë, mundësitë dhe kërcënimet",
   "related-module-label": "Moduli i lidhur",
   "select-module-placeholder": "Zgjidhni modulin",
   "enter-analysis-description-placeholder": "Shkruani përshkrimin e analizës",
   "swot-strengths-title": "Pikat e forta",
   "swot-weaknesses-title": "Dobësitë",
   "swot-opportunities-title": "Mundësitë",
   "swot-threats-title": "Kërcënimet",
   "related-sections-label": "Seksionet e lidhura",
   "select-sections-placeholder": "Zgjidhni seksionet",
   "analysis-label": "Analiza",
   "describe-strengths-placeholder": "Përshkruani pikat e forta",
   "describe-weaknesses-placeholder": "Përshkruani dobësitë",
   "describe-opportunities-placeholder": "Përshkruani mundësitë",
   "describe-threats-placeholder": "Përshkruani kërcënimet",
   "add-analysis-button": "Shto analizë",
   "scores-label": "Rezultatet",
   "guided-assessment-label": "Vlerësim i udhëhequr",
   "self-assessment-label": "Vetëvlerësim",
   "highlights-title": "Pikat kryesore",
   "highlights-subtitle-text":
      "Nxirni në pah gjetjet kryesore dhe jepni rekomandime bazuar në rezultate",
   "choose-chart-analyze-label": "Zgjidhni grafikun që dëshironi të analizoni",
   "select-chart-analyze-text": "Zgjidhni grafikun që dëshironi të analizoni",
   "change-button": "Ndrysho",
   "select-a-module-first-placeholder": "Zgjidhni fillimisht një modul",
   "add-comparison-label": "Shto krahasim",
   "insight-label": "Vlerësimi",
   "max-400-characters-validation": "Maksimumi 400 karaktere",
   "describe-key-points-placeholder":
      "Përshkruani pikat kryesore që dëshironi të veçoni nga ky grafik...",
   "select-chart-to-analyze-title": "Zgjidhni një grafik për të analizuar",
   "choose-chart-from-list-text": "Zgjidhni një nga grafikët e disponueshëm nga lista për ta analizuar.",
   "report-title": "Raporti",
   "upload-report-insights-text":
      "Ngarkoni raportin tuaj që të bëhet pjesë e njohurive për këtë vlerësim.",
   "upload-file-here-label": "Ngarkoni skedarin këtu",
   "current-file-text": "Skedari aktual",
   "remove-file-aria-label": "Hiq skedarin",
   "doc-pdf-pptx-text": "DOC, PDF ose PPTX",
   "only-doc-pdf-pptx-error": "Vetëm skedarët DOC, PDF ose PPTX janë të lejuar.",
   "file-must-be-smaller-than-prefix": "Skedari duhet të jetë më i vogël se",
   "missing-assessment-org-warning": "Mungojnë detajet e vlerësimit ose organizatës.",
   "upload-report-file-warning": "Ju lutemi ngarkoni një skedar raporti.",
   "title-required-validation": "Titulli është i detyrueshëm",
   "ticket-type-required-validation": "Lloji i tiketës është i detyrueshëm",
   "message-required-validation": "Mesazhi është i detyrueshëm",
   "ticket-added-success-title": "Tiketa u shtua me sukses!",
   "ticket-added-success-description":
      "Kjo tiketë u shtua me sukses në bazën e të dhënave të historikut të tiketave tuaja, dikush do t'ju përgjigjet së shpejti.",
   "add-ticket-error-description": "Kishim një problem në shtimin e kësaj tikete, ju lutemi provoni përsëri.",
   "upload-jpg-png-gif-webp-error": "Ju lutemi ngarkoni vetëm skedarë JPG, PNG, GIF ose WEBP.",
   "add-new-ticket-title": "Shto një tiketë të re",
   "ticket-type-label": "Lloji i tiketës",
   "select-ticket-type-placeholder": "Zgjidhni llojin e tiketës",
   "summary-label": "Përmbledhja",
   "enter-title-placeholder": "Shkruani titullin",
   "describe-problem-detail-label": "Përshkruani problemin në detaje",
   "type-something-placeholder": "Shkruani diçka këtu",
   "attach-evidence-label": "Bashkangjitni çdo dëshmi që e konsideroni të rëndësishme",
   "jpg-png-gif-webp-text": "JPG, PNG, GIF dhe WEBP",
   "add-ticket-button": "Shto tiketë",
   "tickets-deleted-success-title": "Tiketat e zgjedhura janë fshirë me sukses!",
   "tickets-deleted-success-description": "Këto tiketa të zgjedhura u fshinë me sukses nga baza e të dhënave",
   "delete-tickets-error-description":
      "Kishim një problem në fshirjen e këtyre tiketave të zgjedhura, ju lutemi provoni përsëri.",
   "delete-selected-tickets-title": "Fshi tiketat e zgjedhura",
   "delete-selected-tickets-confirm-text": "Jeni gati të fshini këto tiketa të zgjedhura.",
   "collection-updated-success-title": "Koleksioni u përditësua me sukses!",
   "collection-updated-success-description": "Ky koleksion u përditësua saktë.",
   "update-collection-error-description":
      "Kishim një problem në përditësimin e këtij koleksioni, ju lutemi provoni përsëri.",
   "collection-added-success-title": "Koleksioni u shtua me sukses!",
   "collection-added-success-description":
      "Ky koleksion u krijua dhe u shtua në bazën tuaj të të dhënave.",
   "add-collection-error-description":
      "Kishim një problem në shtimin e këtij koleksioni, ju lutemi provoni përsëri.",
   "edit-collection-title": "Modifiko koleksionin",
   "add-new-collection-title": "Shto koleksion të ri",
   "new-collection-button-label": "Koleksion i ri",
   "name-collection-label": "Emri i koleksionit",
   "enter-collection-name-placeholder": "Shkruani emrin e koleksionit",
   "enter-collection-description-placeholder": "Shkruani përshkrimin e koleksionit",
   "select-the-assessment-label": "Zgjidhni vlerësimin",
   "select-resources-collection-placeholder": "Zgjidhni burimet e lidhura me këtë koleksion",
   "see-more-text": "Shiko më shumë",
   "make-collection-public-label": "Bëje këtë koleksion publik dhe të dukshëm për të gjithë",
   "add-collection-button": "Shto koleksion",
   "global-status": "Global",
   "owner-colon-label": "Pronari:",
   "resources-colon-label": "Burimet:",
   "resource-added-collection-success-title": "Burimi u shtua në koleksion!",
   "resource-added-collection-success-description": "Ky burim u shtua me sukses në koleksion.",
   "add-resource-collection-error-description":
      "Kishim një problem në shtimin e këtij burimi në koleksion, ju lutemi provoni përsëri.",
   "add-to-collection-title": "Shto në koleksion",
   "resource-updated-success-title": "Burimi u përditësua me sukses!",
   "resource-updated-success-description": "Ky burim u përditësua saktë. Një version i ri u krijua",
   "update-resource-error-description":
      "Kishim një problem në përditësimin e këtij burimi, ju lutemi provoni përsëri.",
   "resource-added-success-title": "Burimi u shtua me sukses!",
   "resource-added-success-description": "Ky burim u krijua dhe u shtua në bazën tuaj të të dhënave.",
   "add-resource-error-description": "Kishim një problem në shtimin e këtij burimi, ju lutemi provoni përsëri.",
   "edit-resource-title": "Modifiko burimin",
   "select-resource-type-label": "Zgjidhni llojin e burimit",
   "select-resource-type-required-validation": "Ju lutemi zgjidhni llojin e burimit",
   "video-placeholder-text": "Video",
   "select-type-before-upload-text": "Para se të ngarkoni një burim duhet të zgjidhni llojin e tij",
   "enter-resource-link-label": "Ju lutemi shkruani lidhjen e burimit këtu",
   "valid-url-required-validation": "Ju lutemi vendosni një URL të vlefshme",
   "enter-resource-link-placeholder": "Shkruani lidhjen e burimit tuaj",
   "select-a-file-required-validation": "Ju lutemi zgjidhni një skedar",
   "click-to-select-files-text": "klikoni për të zgjedhur skedarë",
   "resource-version-colon-label": "Versioni i burimit:",
   "make-resource-private-label": "Bëje këtë burim privat",
   "resource-name-label": "Emri i burimit",
   "enter-resource-name-placeholder": "Shkruani emrin e burimit",
   "tags-label": "Etiketat",
   "enter-resource-tags-placeholder": "Shkruani temat me të cilat ky burim mund të lidhet",
   "select-module-label": "Zgjidhni modulin",
   "select-section-label": "Zgjidhni seksionin",
   "upload-consent-text":
      "Çdo burim që ngarkoni do të ruhet në depozitën e KAPorg sipas dukshmërisë që zgjidhni, duke e bërë të disponueshëm për audiencën e zgjedhur. Duke vazhduar, konfirmoni që keni të drejtat dhe lejet e nevojshme për të ngarkuar këtë material.",
   "add-resource-button": "Shto burim",
   "file-label": "Skedari",
   "views-suffix": "Shikime",
   "rating-suffix": "Vlerësim",
   "owner-label": "Pronari",
   "visibility-label": "Dukshmëria",
   "linked-to-label": "I lidhur me",
   "last-update-date-label": "Data e përditësimit të fundit",
   "resource-version-label": "Versioni i burimit",
   "targets-updated-success-title": "Objektivat u përditësuan me sukses!",
   "targets-updated-success-description": "Të gjitha ndryshimet u ruajtën me sukses.",
   "save-targets-error-description":
      "Kishim një problem në ruajtjen e të gjitha ndryshimeve, ju lutemi provoni përsëri.",
   "current-target-label": "Objektivi aktual:",
   "no-active-rounds-text": "Nuk ka raunde aktive",
   "no-target-set-yet-text": "Nuk është vendosur ende objektiv",
   "no-assessments-found-text": "Nuk u gjetën vlerësime",
   "no-modules-yet-title": "Ende Nuk Ka Module",
   "no-modules-assigned-description":
      "Ky vlerësim nuk ka module të caktuara. Ato do të shfaqen këtu pasi të shtohen.",
   "enter-target-placeholder": "Shkruani objektivin",
   "ticket-history-title": "Historiku i tiketave",
   "help-desk-title": "Ndihma",
   "delete-selected-rows-text": "Fshi rreshtat e zgjedhur",
   "add-new-ticket-text": "Tiketë e re",
   "subject-column": "Subjekti",
   "creation-date-column": "Data e krijimit",
   "organization-column": "Organizata",
   "last-response-column": "Përgjigja e fundit",
   "ticket-preview-title": "Pamja e tiketës",
   "ticket-status-closed": "Mbyllur",
   "ticket-summary-title": "Përmbledhja e tiketës",
   "user-email-label": "Email-i i përdoruesit",
   "ticket-subject-label": "Subjekti i tiketës",
   "mark-as-resolved-button": "Mbyll tiketën",
   "mark-ticket-resolved-title": "Të mbyllet kjo tiketë?",
   "mark-ticket-resolved-confirm-text": "Jeni i sigurt që dëshironi ta mbyllni këtë tiketë? Organizata mund të përgjigjet ende nëse ka nevojë për ndihmë të mëtejshme.",
   "ticket-resolved-success-title": "Tiketa u mbyll",
   "ticket-resolved-success-description": "Tiketa është mbyllur.",
   "resolve-ticket-error-description": "Ndodhi një gabim gjatë mbylljes së tiketës. Ju lutemi provoni përsëri.",
   "type-your-message-placeholder": "Shkruani mesazhin tuaj këtu...",
   "filter-tickets-by-type-placeholder": "Filtro sipas llojit",
   "filter-tickets-by-status-placeholder": "Filtro sipas statusit",
   "summary-results-title": "Përmbledhja e Rezultateve",
   "graphs-view-tab": "Pamja e grafikëve",
   "table-view-tab": "Pamja e tabelës",
   "expert-insights-tab": "Njohuritë e Ekspertëve",
   "no-dashboard-results-yet-title": "Ky panel nuk ka ende rezultate",
   "results-appear-here-description":
      "Kur të dhënat të jenë të disponueshme, rezultatet tuaja do të shfaqen këtu.",
   "submission-round-column": "Raundi i dorëzimit",
   "submission-label-column": "Etiketa e dorëzimit",
   "select-module-first-text": "Ju lutemi zgjidhni fillimisht një modul.",
   "select-at-least-one-submission-round-text": "Ju lutemi zgjidhni të paktën një raund dorëzimi.",
   "unable-detect-organization-text": "Nuk mund të identifikohet organizata juaj. Ju lutemi hyni përsëri.",
   "download-table-label": "Shkarko tabelën",
   "score-overview-title": "Përmbledhja e rezultateve",
   "toggle-score-overview-aria-label": "Shfaq/fshih përmbledhjen e rezultateve",
   "visualizations-title": "Vizualizimet",
   "search-a-graph-placeholder": "Kërko një grafik",
   "select-view-placeholder": "Zgjidhni pamjen",
   "save-view-button": "Ruaj pamjen",
   "save-dashboard-button": "Ruaj panelin",
   "edit-dashboard-button": "Modifiko panelin",
   "download-dashboard-label": "Shkarko panelin",
   "round-label": "Raundi",
   "manager-label": "Menaxheri",
   "select-an-organization-placeholder": "Zgjidhni një organizatë",
   "select-all-option": "Zgjidh të gjitha",
   "all-placeholder": "Të gjitha",
   "score-percent-label": "Rezultati (%)",
   "task-completion-percent-label": "Përfundimi i detyrave (%)",
   "task-status-percent-label": "Statusi i detyrave (%)",
   "value-label": "Vlera",
   "first-round-label": "Raundi i parë",
   "second-round-label": "Raundi i dytë",
   "improvement-percent-label": "Përmirësimi %",
   "result-label": "Rezultati",
   "current-label": "Aktual",
   "target-word": "Objektivi",
   "overall-score-label": "Rezultati i përgjithshëm",
   "of-tasks-completed-label": "e detyrave të përfunduara",
   "leading-label": "Në krye",
   "developing-label": "Në zhvillim",
   "lagging-label": "Prapa",
   "section-word": "Seksioni",
   "task-completion-label": "Përfundimi i detyrave",
   "indicator-word": "Indikatori",
   "progress-word": "Progresi",
   "current-round-label": "Raundi aktual:",
   "change-label": "Ndryshimi:",
   "improvement-label": "Përmirësimi",
   "task-count-label": "Numri i detyrave",
   "assessment-results-per-module-title": "Rezultatet e vlerësimit sipas modulit",
   "assessment-results-per-section-title": "Rezultatet e vlerësimit sipas seksionit",
   "performance-map-title": "Harta e performancës",
   "assessment-results-per-organization-title": "Rezultatet e vlerësimit sipas organizatës",
   "module-results-per-organization-title": "Rezultatet e modulit sipas organizatës",
   "section-results-per-organization-title": "Rezultatet e seksionit sipas organizatës",
   "assessment-targets-per-organization-title": "Objektivat e vlerësimit sipas organizatës",
   "module-targets-per-organization-title": "Objektivat e modulit sipas organizatës",
   "section-targets-per-organization-title": "Objektivat e seksionit sipas organizatës",
   "improvement-tracker-per-organization-title": "Gjurmuesi i përmirësimit sipas organizatës",
   "target-score-task-progress-per-organization-title": "Objektivi, rezultati dhe progresi i detyrave sipas organizatës",
   "assessment-results-per-round-title": "Rezultatet e vlerësimit sipas raundit",
   "module-results-per-round-title": "Rezultatet e modulit sipas raundit",
   "section-results-per-round-title": "Rezultatet e seksionit sipas raundit",
   "assessment-targets-per-round-title": "Objektivat e vlerësimit sipas raundit",
   "module-targets-per-round-title": "Objektivat e modulit sipas raundit",
   "section-targets-per-round-title": "Objektivat e seksionit sipas raundit",
   "improvement-tracker-per-assessment-title": "Gjurmuesi i përmirësimit sipas vlerësimit",
   "target-score-task-progress-per-assessment-title": "Objektivi, rezultati dhe progresi i detyrave sipas vlerësimit",
   "radar-chart-type-label": "Grafik radar",
   "tier-list-type-label": "Listë e niveleve",
   "score-progress-across-rounds-title": "Progresi i rezultatit nëpër raunde",
   "module-score-progress-across-rounds-title": "Progresi i rezultatit të moduleve nëpër raunde",
   "bar-chart-type-label": "Grafik me shtylla",
   "table-type-label": "Tabelë",
   "modules-word": "Modulet",
   "sections-word": "Seksionet",
   "task-status-per-assessment-title": "Statusi i detyrave sipas vlerësimit",
   "module-task-completion-title": "Përfundimi i detyrave të modulit",
   "section-task-completion-title": "Përfundimi i detyrave të seksionit",
   "task-completion-per-organization-title": "Përfundimi i detyrave sipas organizatës",
   "improvement-tracker-title": "Gjurmuesi i përmirësimit",
   "donut-chart-type-label": "Grafik rrethor (donut)",
   "task-updated-success-message": "Detyra u përditësua me sukses.",
   "task-added-success-message": "Detyra u shtua me sukses.",
   "export-tasks-error-message": "Kishim një problem në eksportimin e detyrave, ju lutemi provoni përsëri.",
   "tasks-copied-success-title": "Detyrat u kopjuan me sukses!",
   "tasks-copied-success-description": "Të gjitha detyrat nga raundi i mëparshëm janë kopjuar në raundin aktual.",
   "results-not-yet-approved-title": "Rezultatet nuk janë miratuar ende!",
   "results-not-yet-approved-description": "Detyrat mund të kopjohen vetëm pasi të gjitha modulet e këtij vlerësimi të kenë dorëzime të miratuara. Ju lutemi miratoni dorëzimet tuaja para se të kopjoni detyrat.",
   "tasks-already-copied-title": "Detyrat janë kopjuar tashmë për këtë raund",
   "tasks-already-copied-description": "Detyrat mund të kopjohen vetëm një herë për raund. Nëse ju mungojnë detyra, ju lutemi kontaktoni administratorin tuaj.",
   "copy-tasks-error-title": "Oops! Ndodhi një problem!",
   "copy-tasks-error-description": "Kishim një problem në kopjimin e detyrave nga raundi i mëparshëm, ju lutemi provoni përsëri.",
   "resource-label-colon": "Burimi:",
   "edit-module-alt-text": "Modifiko modulin",
   "delete-module-alt-text": "Fshi modulin",
   "task-status-updated-message": "Statusi i detyrës u përditësua.",
   "failed-update-task-status-message": "Përditësimi i statusit të detyrës dështoi.",
   "plan-summary-title": "Përmbledhja e planit",
   "select-organization-to-view-plan-text": "Zgjidhni një organizatë më sipër për të shfaqur përmbledhjen e planit të saj.",
   "select-organization-placeholder": "Zgjidhni organizatën",
   "previous-round-readonly-notice-text": "Ky është një raund i mëparshëm dhe është vetëm për lexim për të ruajtur të dhënat e tij. Ju mund të bëni ndryshime vetëm në raundin aktual.",
   "viewing-previous-round-button": "Po shikoni një raund të mëparshëm",
   "go-to-current-round-button": "Shko te raundi aktual",
   "staff-member-label": "Anëtari i stafit",
   "export-plan-button": "Eksporto planin",
   "task-column-header": "Detyra",
   "responsible-column-header": "Përgjegjësi",
   "due-date-column-header": "Afati",
   "see-less-link": "Shiko më pak",
   "see-all-link": "Shiko të gjitha",
   "no-linked-questions-text": "Nuk ka pyetje të lidhura",
   "resources-label-colon": "Burimet:",
   "no-tasks-for-staff-member-text": "Nuk u gjetën detyra për anëtarin e stafit të zgjedhur",
   "add-tasks-improve-score-text": "Shtoni detyra në këtë indikator për të përmirësuar rezultatin tuaj",
   "result-label-colon": "Rezultati:",
   "target-label-colon": "Objektivi:",
   "review-note-added-success-description": "Shënimi i vlerësimit u shtua me sukses.",
   "reminder-set-title": "Kujtesa u caktua",
   "reminder-scheduled-success-description": "Kujtesa juaj u planifikua me sukses.",
   "review-notes-title": "Shënimet e vlerësimit",
   "set-reminder-button": "Vendos kujtesë",
   "print-summary-button": "Printo përmbledhjen",
   "export-notes-button": "Eksporto shënimet",
   "note-word": "Shënim",
   "no-note-created-yet-text": "Nuk është krijuar ende asnjë shënim.",
   "no-review-notes-available-text": "Nuk ka shënime vlerësimi të disponueshme.",
   "no-score-selected-text": "Nuk është zgjedhur rezultat",
   "filters-colon-label": "Filtrat:",
   "none-word": "Asnjë",
   "graph-word": "Grafiku",
   "no-chart-content-text": "Nuk ka përmbajtje grafiku",
   "filter-colon-label": "Filtri:",
   "action-plan-word": "Plani i veprimit",
   "results-word": "Rezultatet",
   "no-charts-available-title": "Nuk ka grafikë të disponueshëm",
   "no-charts-data-export-text": "Nuk ka grafikë me të dhëna të disponueshme për eksportim.",
   "summary-action-plan-dashboard-title": "Përmbledhje e panelit të planit të veprimit",
   "summary-results-dashboard-title": "Përmbledhje e panelit të rezultateve",
   "assessment-colon-label": "Vlerësimi:",
   "assessment-word": "Vlerësimi",
   "download-svg-action": "Shkarko SVG",
   "download-png-action": "Shkarko PNG",
   "included-in-report-tooltip-text": "Përfshihet kur gjenerohet raporti",
   "no-visualization-selected-text": "Nuk është zgjedhur asnjë vizualizim",
   "drop-visualization-here-text": "Lësho vizualizimin këtu",
   "add-graph-button": "Shto grafik",
   "delete-block-tooltip-text": "Fshi blokun",
   "no-filters-selected-text": "Nuk janë zgjedhur filtra",
   "filters-word": "Filtrat",
   "untitled-graph-text": "Grafik pa titull",
   "graph-preview-unavailable-text": "Parapamja e grafikut nuk është e disponueshme",
   "filter-word": "Filtri",
   "global-suffix-label": "(global)",
   "organization-word": "Organizata",
   "staff-word": "Stafi",
   "generic-problem-occurred-title": "Oops! Ndodhi një problem",
   "view-saved-success-title": "Pamja u ruajt me sukses!",
   "view-saved-success-description": "Pamja e panelit tuaj u ruajt me sukses.",
   "problem-saving-view-description": "Kishim një problem në ruajtjen e kësaj pamjeje, ju lutemi provoni përsëri.",
   "select-view-before-rename-text": "Zgjidhni një pamje para se ta riemërtoni.",
   "select-view-before-delete-text": "Zgjidhni një pamje para se ta fshini.",
   "view-deleted-success-title": "Pamja u fshi me sukses!",
   "view-deleted-success-description": "Pamja e zgjedhur u fshi nga paneli juaj.",
   "problem-deleting-view-description": "Kishim një problem në fshirjen e kësaj pamjeje, ju lutemi provoni përsëri.",
   "view-renamed-success-title": "Pamja u riemërtua me sukses!",
   "view-renamed-success-description": "Emri i pamjes së zgjedhur u përditësua me sukses.",
   "problem-renaming-view-description": "Kishim një problem në riemërtimin e kësaj pamjeje, ju lutemi provoni përsëri.",
   "view-word": "Pamja",
   "compare-with-self-assessment-label": "Krahaso me vetëvlerësimin",
   "comparison-limited-one-org-text": "Ky krahasim kufizohet në një organizatë në të njëjtën kohë",
   "assessment-not-linked-self-text": "Ky vlerësim nuk është i lidhur me një vetëvlerësim",
   "dashboard-word": "Paneli",
   "self-assessments-menu-item": "Vetëvlerësimet",
   "guided-assessments-menu-item": "Vlerësimet e udhëhequra",
   "module-request-menu-item": "Kërkesë për modul",
   "action-plan-menu-item": "Plani i veprimit",
   "my-performance-menu-item": "Performanca ime",
   "task-management-menu-item": "Menaxhimi i detyrave",
   "resources-menu-item": "Burimet",
   "organization-management-menu-item": "Menaxhimi i organizatës",
   "quick-search-tooltip-text": "Kërkim i shpejtë",
   "notifications-tooltip-text": "Njoftimet",
   "help-desk-word": "Ndihma",
   "go-back-previous-menu-text": "Kthehu te menyja e mëparshme",
   "go-back-to-action-plan-link": "Kthehu te plani i veprimit",
   "go-back-to-module-list-link": "Kthehu te lista e moduleve",
   "go-back-to-modules-list-link": "Kthehu te lista e moduleve",
   "go-back-to-templates-list-link": "Kthehu te lista e shabllonave",
   "go-back-to-action-plan-section-link": "Kthehu te seksioni i planit të veprimit",
   "go-back-to-assessment-link": "Kthehu te vlerësimi",
   "go-back-to-assessments-link": "Kthehu te vlerësimet",
   "go-back-to-assigned-modules-list-link": "Kthehu te lista e moduleve të caktuara",
   "go-back-to-approved-modules-list-link": "Kthehu te lista e moduleve të miratuara",
   "go-back-to-pending-modules-list-link": "Kthehu te lista e moduleve në pritje",
   "go-back-to-guided-assessment-link": "Kthehu te vlerësimi i udhëhequr",
   "go-back-to-guided-assessment-list-link": "Kthehu te lista e vlerësimeve të udhëhequra",
   "go-back-to-workspaces-link": "Kthehu te hapësirat e punës",
   "profile-preview-alt-text": "Parapamja e profilit",
   "org-role-abbreviation": "Org",
   "role-super-admin-label": "Super Administrator",
   "role-consultant-label": "Konsulent",
   "role-donor-label": "Donatori",
   "role-national-organization-label": "Organizatë Kombëtare",
   "role-international-organization-label": "Organizatë Ndërkombëtare",
   "male-label": "Mashkull",
   "female-label": "Femër",
   "no-self-assessments-here-text": "Nuk ka vetëvlerësime këtu",
   "no-guided-assessments-here-text": "Nuk ka vlerësime të udhëhequra këtu",
   "self-assessment-panel-title": "Vetëvlerësim",
   "guided-assessment-panel-title": "Vlerësim i udhëhequr",
   "sort-progress-by-label": "Rendit progresin sipas:",
   "highest-to-lowest-option": "Nga më i lartë tek më i ulëti",
   "lowest-to-highest-option": "Nga më i ulëti tek më i larti",
   "modules-count-suffix": "module",
   "answer-pending-status": "Përgjigje në pritje",
   "unlock-assessment-text": "Zhblloko vlerësimin",
   "select-assessment-see-results-text": "Zgjidhni një vlerësim për të parë rezultatet e tij në detaje.",
   "linked-badge-label": "I lidhur",
   "no-assessments-available-title": "Nuk ka vlerësime të disponueshme.",
   "start-adding-view-results-text": "Filloni duke shtuar një për të parë rezultatet e mbledhura.",
   "assessment-selected-suffix": "vlerësim i zgjedhur",
   "action-plan-panel-description-text": "Këtu do të gjeni një plan veprimi bazuar në rezultatet tuaja në secilin vlerësim.",
   "select-one-see-plan-detail-text": "Zgjidhni njërin për të parë planin në detaje.",
   "search-for-assessment-placeholder": "Kërko një vlerësim",
   "areas-to-improve-label": "Modulet për të përmirësuar:",
   "no-assessments-here-text": "Nuk ka vlerësime këtu!",
   "selected-assessment-title": "Vlerësimi i zgjedhur",
   "no-assessment-selected-text": "Nuk është zgjedhur asnjë vlerësim",
   "number-of-resources-label": "Numri i burimeve:",
   "areas-in-label": "Fushat:",
   "indicators-to-improve-label": "Treguesit për të përmirësuar:",
   "no-data-available-to-display-text": "Nuk ka të dhëna të disponueshme për t'u shfaqur.",
   "self-evaluate-screen-description-text": "Ky ekran ju lejon të vlerësoni veten bazuar në pyetësorët që keni zgjidhur",
   "maximum-organizations-warning-text": "Maksimumi 5 organizata!",
   "search-organization-placeholder": "Kërko organizatë",
   "sort-order-tooltip-text": "Rendit sipas",
   "get-results-tooltip-text": "Merr rezultatet",
   "report-word": "Raporti",
   "capacity-gaps-title": "Hendeqet e Kapaciteteve",
   "capacity-gaps-description-text": "Cilat module dhe seksione janë të forta dhe cilat janë të dobëta, dhe si performojnë kundrejt objektivave të tyre.",
   "performance-overview-title": "Përmbledhja e Performancës",
   "performance-overview-description-text": "Ku qëndron grupi në këtë raund: rezultatet e organizatave, si shpërndahen nëpër kategoritë e rezultateve të vlerësimit, dhe si qëndrojnë kundrejt objektivit të raundit.",
   "progress-across-rounds-title": "Progresi Ndër Raunde",
   "progress-across-rounds-description-text": "Ku ka arritur grupi në këtë raund në nivel seksioni, dhe si është lëvizur çdo organizatë nga raundi i mëparshëm — kush është përmirësuar, kush ka rënë, dhe sa.",
   "action-plan-status-title": "Statusi i Planit të Veprimit",
   "action-plan-status-description-text": "Përfundimi i detyrave për organizatë për raundin e zgjedhur, dhe si lidhet me arritjen e objektivit.",
   "score-band-deficient": "Mangët",
   "score-band-insufficient": "I pamjaftueshëm",
   "score-band-satisfactory": "I kënaqshëm",
   "score-band-very-good": "Shumë i mirë",
   "score-band-excellent": "I shkëlqyer",
   "module-rejected-success-description": "Moduli u refuzua me sukses",
   "failed-reject-module-description": "Dështoi refuzimi i këtij moduli",
   "module-accepted-success-description": "Moduli u pranua me sukses",
   "failed-accept-module-description": "Dështoi pranimi i këtij moduli",
   "module-requests-title": "Kërkesat për module",
   "pending-modules-review-description-text": "Kjo është lista e moduleve në pritje të shqyrtimit tuaj. Për të vazhduar, klikoni mbi secilin modul ku do të mund ta pranoni ose refuzoni atë.",

   // Login / Registration pages
   "welcome-back-title": "Mirë se u ktheve!",
   "login-into-account-subtitle": "Hyni në llogarinë tuaj",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "Fjalëkalimi",
   "toggle-password-visibility-label": "Shfaq/fshih fjalëkalimin",
   "remember-me-label": "Më kujto?",
   "log-in-button": "Hyr",
   "no-account-yet-text": "Nuk keni ende një llogari?",
   "sign-up-link": "Regjistrohu",
   "max-16-symbols-validation": "Maksimumi 16 simbole",
   "go-back-icon-alt": "Kthehu",
   "go-back-to-login-link": "Kthehu te hyrja",
   "welcome-to-kaporg-title": "Mirë se vini në KAPorg!",
   "which-profile-title": "Cili profil ju përshkruan më së miri?",
   "profile-organization-label": "Organizatë",
   "profile-donors-label": "Donatorë",
   "profile-expert-label": "Ekspert",
   "signup-role-title": "Si do ta përdorni KAPorg?",
   "signup-role-subtitle": "Zgjidhni rolin që përputhet më mirë me përgjegjësitë tuaja.",
   "profile-donor-label": "Donator",
   "signup-role-organization-description": "Ndërtoni kapacitete të qëndrueshme organizative",
   "signup-role-donor-description": "Mbikëqyrni performancën e portofolit institucional",
   "signup-role-expert-description": "Ofroni udhëzime strategjike të pavarura",
   "signup-create-account-as-an": "Krijoni një llogari si",
   "signup-create-account-as-a": "Krijoni një llogari si",
   "showcase-login-headline": "Fuqizojmë organizatat të udhëheqin [[zhvillimin e kapaciteteve]]",
   "showcase-organization-headline": "Vlerësoni aftësitë tuaja dhe [[përforconi misionin tuaj]]",
   "showcase-donor-headline": "Mbikëqyrni performancën e portofolit dhe [[arrini rezultate të matshme]]",
   "showcase-expert-headline": "Ofroni udhëzime strategjike dhe [[ngritni kapacitetet institucionale]]",
   "signup-step-profile": "Profili",
   "signup-step-expertise": "Ekspertiza",
   "profile-details-title": "Detajet e profilit",
   "upload-photo-text": "Ngarko foto",
   "adjust-your-photo-title": "Rregulloni foton tuaj",
   "change-photo-text": "Ndrysho foton",
   "signup-step-account": "Llogaria",
   "signup-step-contact": "Kontakti",
   "enter-organization-email-placeholder": "Shkruani email-in e organizatës",
   "code-must-have-6-digits-validation": "Kodi duhet të ketë 6 shifra",
   "code-incorrect-text": "Kodi është i pasaktë",
   "confirmation-email-shortly-text": "Së shpejti do të merrni një email konfirmimi",
   "go-to-homepage-button": "Shko te faqja kryesore",
   "didnt-get-email-text": "Nuk e morët email-in? Kontrolloni dosjen e spam-it ose shkruani te",
   "language-selector-label": "Zgjidh gjuhën",
   "auth-tagline-transforming-title": "Duke transformuar ndërtimin e kapaciteteve",
   "auth-tagline-transforming-description": "Për epokën digjitale",
   "auth-tagline-elevate-title": "Përmirësoni organizatën tuaj",
   "auth-tagline-elevate-description": "me vlerësim të qëllimshëm!",
   "auth-tagline-changemakers-title": "Lidhuni me ndryshimtarët",
   "auth-tagline-changemakers-description": "që kanë më shumë nevojë për ju.",
   "auth-tagline-miss-you-title": "Do të na mungoni,",
   "auth-tagline-miss-you-description": "Shpresojmë t'ju rikthejmë së shpejti.",
   "auth-tagline-collaborations-title": "Zhytuni në një botë",
   "auth-tagline-collaborations-description": "bashkëpunimesh me ndikim!",
   "auth-tagline-expertise-title": "Ekspertiza juaj",
   "auth-tagline-expertise-description": "dhe njohuritë tuaja nxisin Progresin!",

   // National organization registration form
   "go-back-to-profile-selection-link": "Kthehu te zgjedhja e profilit",
   "create-account-title": "Krijo një llogari",
   "as-an-org-label": "si Organizatë",
   "login-details-title": "Të dhënat e hyrjes",
   "confirm-password-label": "Konfirmo fjalëkalimin",
   "type-description-placeholder": "Shkruani përshkrimin",
   "working-sectors-label": "Sektorët e punës",
   "enter-organization-name-placeholder": "Shkruani emrin e organizatës",
   "enter-organization-address-placeholder": "Shkruani adresën e organizatës",
   "enter-organization-zip-code-placeholder": "Shkruani kodin postar të organizatës",
   "terms-agreement-prefix-text": "Kam lexuar dhe pajtohem me",
   "terms-of-service-privacy-policy-link": "Kushtet e Shërbimit, Politikën e Privatësisë",
   "and-conjunction-text": "dhe",
   "cookie-policy-link": "Politikën e Cookie-ve.",
   "invalid-email-address-validation": "Email i pavlefshëm",
   "password-min-length-validation": "Fjalëkalimi duhet të ketë të paktën 8 karaktere",
   "password-complexity-validation": "Fjalëkalimi duhet të përmbajë të paktën një shkronjë të madhe, një numër dhe një nga simbolet e specifikuara !, @, #, $, %, ^, &, *",
   "password-required-validation": "Fjalëkalimi është i detyrueshëm",
   "passwords-must-match-validation": "Fjalëkalimet duhet të përputhen",
   "confirm-password-required-validation": "Konfirmimi i fjalëkalimit është i detyrueshëm",
   "organization-name-required-validation": "Emri i Organizatës Ndërkombëtare është i detyrueshëm",
   "foundation-year-required-validation": "Viti i themelimit është i detyrueshëm",
   "sectors-min-validation": "Duhet zgjedhur të paktën një sektor",
   "sectors-required-validation": "Sektorët janë të detyrueshëm",
   "organization-address-required-validation": "Adresa e organizatës është e detyrueshme",
   "invalid-organization-email-validation": "Email i organizatës i pavlefshëm",
   "organization-email-required-validation": "Email-i i organizatës është i detyrueshëm",
   "accept-terms-required-validation": "Duhet të pranoni kushtet dhe kushtet e përdorimit",

   // Donor registration form
   "as-an-international-donor-label": "si Donator Ndërkombëtar",
   "donor-organization-name-required-validation": "Emri i Organizatës është i detyrueshëm",
   "invitation-code-label": "Kodi i ftesës",
   "enter-invitation-code-placeholder": "Shkruani kodin tuaj të ftesës",
   "invitation-code-min-length-validation": "Kodi i ftesës duhet të ketë të paktën 12 karaktere",
   "invitation-code-required-validation": "Kodi i ftesës është i detyrueshëm",
   "invalid-invitation-code-format-validation": "Format i pavlefshëm i kodit të ftesës",
   "no-invitation-code-help-text": "Nëse nuk keni një kod ftese, ju lutemi na dërgoni një email këtu:",

   // Terms/Conditions modal
   "close-icon-alt": "Mbyll",
   "terms-of-service-tab-label": "Kushtet e shërbimit",
   "privacy-policy-tab-label": "Politika e privatësisë",
   "cookie-policy-tab-label": "Politika e cookie-ve",
   "got-it-button": "E kuptova!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "Llogaria u krijua me sukses.",
   "unexpected-error-description": "Ndodhi një gabim i papritur. Ju lutemi provoni përsëri.",
   "verification-code-sent-description": "Një kod verifikimi u dërgua në email-in tuaj.",
   "expert-user-created-success-description": "Përdoruesi ekspert u krijua me sukses",

   // Expert registration step one
   "as-an-expert-label": "si Ekspert",

   // Expert registration step three
   "lets-start-profile-info-title": "Le të fillojmë me informacionin e profilit tuaj",
   "enter-full-name-placeholder": "Shkruani emrin tuaj të plotë",
   "personal-statement-label": "Deklarata personale/motivimi",
   "enter-personal-statement-placeholder": "Shkruani deklaratën tuaj personale",
   "select-nationality-placeholder": "Zgjidhni kombësinë tuaj",
   "select-country-of-residence-placeholder": "Zgjidhni vendin tuaj të banimit",
   "operating-countries-label": "Vendet e operimit",
   "enter-linkedin-profile-placeholder": "Shkruani profilin tuaj në LinkedIn",
   "full-name-required-validation": "Emri i plotë është i detyrueshëm",
   "nationality-required-validation": "Kombësia është e detyrueshme",
   "country-of-residence-required-validation": "Vendi i banimit është i detyrueshëm",

   // Expert registration step four
   "now-your-professional-details-title": "Tani detajet tuaja profesionale",
   "profile-picture-label": "Foto profili",
   "education-section-title": "Arsimimi",
   "select-highest-degree-placeholder": "Zgjidhni diplomën më të lartë të marrë",
   "enter-fields-of-study-placeholder": "Shkruani fushat e studimit",
   "enter-educational-institution-placeholder": "Shkruani institucionin tuaj arsimor",
   "area-label": "Fusha",
   "enter-area-placeholder": "Shkruani fushën",
   "add-another-area-button": "Shto një fushë tjetër",
   "level-label": "Niveli",
   "select-level-placeholder": "Zgjidhni nivelin",
   "add-another-language-button": "Shto një gjuhë tjetër",
   "upload-cv-label": "Ngarko CV-në tuaj",
   "upload-certificate-label": "Ngarko një certifikatë ose trajnim special",
   "remove-button": "Hiq",
   "image-file-type-badge": "JPG ose PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "Diploma më e lartë është e detyrueshme",
   "area-required-validation": "Fusha është e detyrueshme",
   "years-of-experience-required-validation": "Vitet e përvojës janë të detyrueshme",
   "years-of-experience-number-validation": "Vitet e përvojës duhet të jenë një numër",
   "profile-picture-required-validation": "Foto e profilit është e detyrueshme",
   "invalid-image-file-type-validation": "Lloj i pavlefshëm skedari. Lejohen vetëm PNG ose JPEG.",
   "file-size-too-large-validation": "Madhësia e skedarit është shumë e madhe. Madhësia maksimale është 20MB.",
   "invalid-pdf-file-type-validation": "Lloj i pavlefshëm skedari. Lejohet vetëm PDF.",
   "level-required-validation": "Niveli është i detyrueshëm",
   "level-number-validation": "Niveli duhet të jetë një numër",
   "go-back-to-profile-details-link": "Kthehu te detajet e profilit",
   "uploaded-file-icon-alt": "Skedar",
   "add-icon-alt": "Shto",

   // Confirm-code page
   "verification-code-title": "Kodi i verifikimit",
   "verification-code-sent-to-text": "Ju lutemi shkruani kodin e verifikimit që ju dërguam në",
   "verify-code-button": "Verifiko kodin",
   "didnt-receive-code-text": "Nëse nuk keni marrë një kod verifikimi,",
   "resend-code-link": "klikoni këtu për ta ridërguar",
   "or-send-email-at-text": "ose na dërgoni një email në",
   "verification-code-required-validation": "Kodi i verifikimit është i detyrueshëm",
   "code-verified-success-description": "Kodi u verifikua me sukses",

   // Account on review page
   "account-on-review-icon-alt": "Llogaria në shqyrtim",
   "got-your-application-title": "E morëm aplikimin tuaj!",
   "application-review-description-text": "Do të merrni një email konfirmimi sapo një administrator të miratojë kërkesën tuaj.",
   "in-the-meantime-prefix-text": "Ndërkohë, vizitoni",
   "in-the-meantime-suffix-text": "për më shumë informacion.",
   "thank-you-for-interest-text": "Faleminderit për interesimin tuaj në KAPorg!",

   // Resources library
   "resources-library-tab-label": "Biblioteka e burimeve",
   "resource-type-all-label": "Të gjitha burimet",
   "resource-type-documents-label": "Dokumente",
   "resource-type-videos-label": "Video",
   "resource-type-links-label": "Lidhje",
   "resource-type-presentations-label": "Prezantime",
   "no-resources-available-text": "Nuk ka burime të disponueshme",
   "no-collections-available-text": "Nuk ka koleksione të disponueshme",
   "which-resource-looking-for-label": "Çfarë po kërkoni?",
   "search-ellipsis-placeholder": "Kërko...",
   "assessments-placeholder": "Vlerësimet",
   "modules-label": "Modulet",
   "section-label": "Seksioni",
   "sections-placeholder": "Seksionet",
   "resource-icon-alt": "Burimet",
   "copy-link-action": "Kopjo lidhjen",
   "edit-resource-icon-alt": "Redakto burimin",
   "rate-this-resource-action": "Vlerëso këtë burim",
   "delete-resource-icon-alt": "Fshi burimin",
   "more-suffix-text": "më shumë",
   "rate-this-resource-title": "Vlerëso këtë Burim",
   "resource-word": "Burim",
   "your-rating-label": "Vlerësimi juaj:",
   "save-rating-button": "Ruaj vlerësimin",
   "all-tab-label": "Të gjitha",
   "my-collections-label": "Koleksionet",
   "my-collection-toggle-label": "Koleksioni im",
   "all-collections-label": "Koleksionet",
   "edit-collection-icon-alt": "Redakto koleksionin",
   "delete-collection-icon-alt": "Fshi koleksionin",
   "preview-colon-label": "Pamja paraprake:",
   "resources-word": "Burime",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "përmbledhje e llogarisë",
   "account-summary-label": "Përmbledhje e llogarisë",
   "account-summary-upgrade-message":
      "Po i afroheni limitit të paketës suaj. Përmirësojeni për të pasur më shumë hapësirë dhe për të krijuar pa kufizime.",
   "upgrade-package-button": "Përmirëso paketën",
   "modules-available-label": "Module të disponueshme",
   "modules-created-label": "Module të krijuara",
   "assessments-available-label": "Vlerësime të disponueshme",
   "assessments-created-label": "Vlerësime të krijuara",
   "workspaces-available-label": "Hapësira pune të disponueshme",
   "workspaces-created-label": "Hapësira pune të krijuara",
   "including-humanitarian-experts-created-label": "duke përfshirë ekspertët humanitarë të krijuar",
   "amount-of-storage-label": "Sasia e hapësirës ruajtëse",
   "data-usage-label": "Përdorimi i të dhënave",
   "usage-statistics-label": "Statistikat e përdorimit",
   "available-label": "E disponueshme",
   "used-label": "E përdorur",
   "profile-info-icon-alt": "informacioni i profilit",
   "profile-information-label": "Informacioni i profilit",
   "login-info-icon-alt": "informacioni i hyrjes",
   "login-information-label": "Informacioni i hyrjes",
   "payment-info-icon-alt": "informacioni i pagesës",
   "payment-information-label": "Informacioni i pagesës",
   "log-out-icon-alt": "dil nga llogaria",
   "log-out-button": "Dil nga llogaria",
   "account-menu-toggle-alt": "Menyja e llogarisë",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "Menyja",
   "logo-alt-text": "Logo",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "Shëno të gjitha si të lexuara",
   "unread-tab-label": "Të palexuara",
   "no-notifications-title-text": "Nuk ka njoftime këtu!",
   "up-to-date-description-text": "Gjithçka është e përditësuar!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "Këto Kushte të Shërbimit u përditësuan për herë të fundit më 4 mars 2024.",
   "terms-intro-websites-prefix-text": "Këto Kushte të Shërbimit rregullojnë përdorimin tuaj të faqeve tona të internetit që ndodhen në",
   "terms-intro-websites-suffix-text": ", si dhe çdo shërbim tjetër të lidhur, ofruar nga International Advisory, Products and Systems Ltd. Duke hyrë në faqet tona të internetit, ju pranoni t'i përmbaheni këtyre Kushteve të Shërbimit dhe të respektoni të gjitha ligjet dhe rregulloret e zbatueshme. Nëse nuk jeni dakord me këto Kushte të Shërbimit, ju ndalohet të përdorni ose të hyni në ato faqe interneti apo të përdorni ndonjë shërbim tjetër të ofruar nga International Advisory, Products and Systems Ltd. Ne, International Advisory, Products and Systems Ltd, rezervojmë të drejtën të rishikojmë dhe të ndryshojmë çdo pjesë të këtyre Kushteve të Shërbimit sipas gjykimit tonë të plotë e të vetëm. Pas kësaj, ne do ta përditësojmë këtë faqe. Çdo ndryshim në këto Kushte të Shërbimit do të hyjë në fuqi menjëherë nga data e publikimit.",
   "overview-of-services-title": "Përmbledhje e Shërbimeve",
   "overview-of-services-description-text": "International Advisory, Products and Systems Ltd. (i-APS), së bashku me entitetet e saj të lidhura, duke përfshirë por pa u kufizuar në KAPsurvey, KAPorg, KAPinsights dhe KAPcourse (këtu e tutje të referuara kolektivisht si \"KAPtech Group\"), ofron shërbime këshillimi teknik, zgjidhje teknologjike inovative, si dhe mjete gjithëpërfshirëse për mbledhjen dhe analizimin e të dhënave. Ofertat e KAPtech Group synojnë të mbështesin ekzekutimin dhe menaxhimin e projekteve të ekspertizës dhe zhvillimit. Këto shërbime përdorin teknologji të avancuar dhe shfrytëzojnë ekspertizën e gjerë lokale për të ndihmuar organizatat partnere dhe komunitetet të përgjigjen në mënyrë efektive dhe të kapërcejnë sfidat në sektorët e ndihmës së ekspertizës dhe zhvillimit. Duke përdorur shërbimet e ofruara nga KAPtech Group, përfshirë hyrjen në faqet tona të internetit, ju pranoni të respektoni dhe të jeni të detyruar nga termat dhe kushtet e përcaktuara në këtë marrëveshje. Shërbimet e ofruara i nënshtrohen kushteve të përcaktuara këtu, së bashku me çdo udhëzim ose rregull shtesë të zbatueshëm për shërbime ose veçori specifike të shërbimeve.",
   "limitations-of-use-title": "Kufizimet e Përdorimit",
   "limitations-of-use-intro-text": "Duke përdorur faqet tona të internetit, ju garantoni në emër tuaj, të përdoruesve tuaj dhe të palëve të tjera që përfaqësoni, se nuk do të:",
   "limitation-modify-content-text": "modifikoni, kopjoni, përgatisni vepra derivative, dekompiloni ose bëni inxhinieri të kundërt (reverse engineering) të ndonjë materiali apo softueri që gjendet në ato faqe interneti;",
   "limitation-remove-notices-text": "hiqni ndonjë shënim të së drejtës së autorit apo ndonjë shënim tjetër pronësor nga materialet dhe softueri në ato faqe interneti;",
   "limitation-transfer-materials-text": "transferoni materialet tek një person tjetër ose t'i \"pasqyroni\" (mirror) materialet në ndonjë server tjetër;",
   "limitation-abuse-networks-text": "përdorni me dashje ose me neglizhencë ato faqe interneti apo ndonjë nga shërbimet e tyre të lidhura në një mënyrë që abuzon me ose prish rrjetet tona apo ndonjë shërbim tjetër që ofron International Advisory, Products and Systems Ltd;",
   "limitation-unlawful-material-text": "përdorni ato faqe interneti apo shërbimet e tyre të lidhura për të transmetuar ose publikuar material ngacmues, të pahijshëm, të turpshëm, mashtrues ose të paligjshëm;",
   "limitation-violate-laws-text": "përdorni ato faqe interneti apo shërbimet e tyre të lidhura në kundërshtim me ndonjë ligj apo rregullore të zbatueshme;",
   "limitation-spam-text": "përdorni ato faqe interneti në lidhje me dërgimin e reklamave të paautorizuara apo spam-it;",
   "limitation-harvest-data-text": "korrni, mblidhni apo grumbulloni të dhëna të përdoruesve pa pëlqimin e përdoruesit; ose",
   "limitation-infringe-rights-text": "përdorni ato faqe interneti apo shërbimet e tyre të lidhura në një mënyrë që mund të cenojë privatësinë, të drejtat e pronësisë intelektuale, apo të drejta të tjera të palëve të treta",
   "intellectual-property-title": "Prona Intelektuale",
   "intellectual-property-description-text": "Prona intelektuale në materialet e përfshira në ato faqe interneti i përket ose i është licencuar International Advisory, Products and Systems Ltd, dhe mbrohet nga legjislacioni i zbatueshëm mbi të drejtën e autorit dhe markat tregtare. Ne u japim përdoruesve tanë leje për të shkarkuar një kopje të materialeve për përdorim personal, jokomercial dhe të përkohshëm. Kjo përbën dhënien e një licence, jo transferimin e titullit të pronësisë. Kjo licencë do të përfundojë automatikisht nëse ju shkelni ndonjë nga këto kufizime apo Kushtet e Shërbimit, dhe mund të përfundohet nga International Advisory, Products and Systems Ltd në çdo kohë.",
   "user-generated-content-title": "Përmbajtja e Krijuar nga Përdoruesi",
   "terms-user-generated-content-description-text": "Ju ruani të drejtat tuaja të pronësisë intelektuale mbi përmbajtjen që na dërgoni për publikim në faqet tona të internetit. Ne asnjëherë nuk do të pretendojmë pronësi mbi përmbajtjen tuaj, por na duhet një licencë nga ju për ta përdorur atë. Kur ju përdorni faqet tona të internetit apo shërbimet e tyre të lidhura për të postuar, ngarkuar, ndarë apo transmetuar në ndonjë mënyrë tjetër përmbajtje të mbrojtur nga të drejtat e pronësisë intelektuale, ju na jepni një licencë joekskluzive, pa pagesë, të transferueshme, nën-licencueshme dhe në shkallë botërore për të përdorur, shpërndarë, modifikuar, ekzekutuar, kopjuar, shfaqur publikisht, përkthyer apo krijuar në ndonjë mënyrë tjetër vepra derivative nga përmbajtja juaj, në një mënyrë që përputhet me preferencat tuaja të privatësisë dhe me Politikën tonë të Privatësisë. Licenca që na jepni mund të përfundojë në çdo kohë duke fshirë përmbajtjen tuaj apo llogarinë tuaj. Sidoqoftë, në masën që ne (ose partnerët tanë) kemi përdorur përmbajtjen tuaj në lidhje me përmbajtje komerciale apo të sponsorizuar, licenca do të vazhdojë derisa reklama apo postimi përkatës të ndërpritet nga ne. Ju na jepni leje të përdorim emrin tuaj të përdoruesit dhe informacione të tjera identifikuese të lidhura me llogarinë tuaj, në një mënyrë që përputhet me preferencat tuaja të privatësisë dhe me Politikën tonë të Privatësisë.",
   "registration-and-payments-title": "Regjistrimi dhe Pagesat",
   "registration-and-payments-description-text": "Për të përdorur ndonjë nga shërbimet tona, ju duhet të krijoni një llogari. Çdo informacion i dhënë duhet të jetë i saktë dhe i përditësuar sipas nevojës. Klientët janë përgjegjës për mirëmbajtjen e llogarive të tyre dhe janë tërësisht përgjegjës për të gjitha aktivitetet që ndodhin nën llogaritë e tyre. Nëse dikush fiton qasje të paautorizuar në llogarinë tuaj, ju duhet të na njoftoni menjëherë. International Advisory, Products and Systems Ltd nuk mban përgjegjësi për ndonjë humbje apo dëm që rrjedh nga mosruajtja e konfidencialitetit të llogarisë suaj. Kur krijoni llogarinë tuaj, kërkohet të jepni informacionin tuaj financiar përkatës për metodën e pagesës së zgjedhur. Në disa raste, mund t'ju kërkohet të jepni të dhënat e kartës suaj të kreditit. Ju lutemi vini re se çdo pagesë e kryer në platformën tonë do të përpunohet nga PayPal, Stripe, Square, Google Payments, ose Apple Pay. Prandaj, ne nuk do të jemi përgjegjës për përpunimin apo ruajtjen e ndonjë prej informacioneve tuaja financiare. PayPal, Stripe, Square, Google Payments, ose Apple Pay do të trajtojnë të gjitha informacionet tuaja financiare sipas Kushteve të tyre përkatëse të Shërbimit, dhe ju pranoni të respektoni ato Kushte të Shërbimit.",
   "disclaimer-and-limitations-title": "Deklarata e Mohimit të Përgjegjësisë dhe Kufizimet e Përgjegjësisë",
   "disclaimer-websites-prefix-text": "Faqet e internetit dhe materialet e ofruara nga International Advisory, Products and Systems Ltd., duke përfshirë por pa u kufizuar në",
   "disclaimer-as-is-description-text": ", u vihen në dispozicion përdoruesve në bazën 'siç është' ('as is'). International Advisory, Products and Systems Ltd mohon çdo garanci, të shprehur apo të nënkuptuar, në masën e lejuar nga ligji. Kjo përfshin, por nuk kufizohet në, garancitë e tregtueshmërisë, përshtatshmërisë për një qëllim të caktuar, apo moscenimit të të drejtave të pronësisë intelektuale. Për më tepër, asnjë këshillë apo informacion, qoftë gojor apo me shkrim, i marrë nga ju prej International Advisory, Products and Systems Ltd apo përmes shërbimeve, nuk do të krijojë ndonjë garanci që nuk është shprehimisht e deklaruar në këto kushte. International Advisory, Products and Systems Ltd dhe furnizuesit e saj nuk do të jenë përgjegjës për ndonjë dëm të drejtpërdrejtë, të tërthortë, rastësor, të veçantë, pasues apo shembullor, duke përfshirë por pa u kufizuar në dëme për humbje fitimi, emri të mirë, përdorimi, të dhënash, apo humbje të tjera jomateriale (edhe nëse International Advisory, Products and Systems Ltd është këshilluar për mundësinë e dëmeve të tilla), që rezultojnë nga përdorimi apo pamundësia për të përdorur shërbimet apo çdo çështje tjetër që lidhet me shërbimet. Ky kufizim i përgjegjësisë zbatohet pavarësisht nëse përgjegjësia e pretenduar bazohet në kontratë, dëm jashtëkontraktor (tort), neglizhencë, përgjegjësi strikte apo ndonjë bazë tjetër, edhe nëse International Advisory, Products and Systems Ltd është këshilluar për mundësinë e një dëmi të tillë. Duke pasur parasysh natyrën e shërbimeve të ofruara nga International Advisory, Products and Systems Ltd, veçanërisht në kontekstin e sektorëve të ekspertizës dhe zhvillimit, përdoruesit pranojnë rreziqet e natyrshme që përfshin mbledhja e të dhënave dhe përdorimi i zgjidhjeve të bazuara në teknologji. Përdoruesit janë përgjegjës të vetëm për të siguruar përputhshmërinë e tyre me të gjitha ligjet dhe rregulloret e zbatueshme, duke përfshirë por pa u kufizuar në ligjet e mbrojtjes së të dhënave dhe privatësisë. Përgjegjësia për marrjen e pëlqimeve dhe lejeve të nevojshme për mbledhjen e të dhënave, veçanërisht kur përfshihen të mitur apo të dhëna të ndjeshme, i takon përdoruesit. Përgjegjësia e International Advisory, Products and Systems Ltd dhe e filialeve, drejtorëve, zyrtarëve, punonjësve, agjentëve, furnizuesve dhe licencuesve të saj kufizohet në masën maksimale të lejuar nga ligji. Nëse jeni të pakënaqur me ndonjë pjesë të shërbimeve, apo me ndonjë nga këto kushte, e vetmja dhe ekskluzive zgjidhje juaj është të ndërprisni përdorimin e shërbimeve. Disa juridiksione nuk lejojnë përjashtimin e disa garancive apo kufizimin apo përjashtimin e përgjegjësisë për dëme rastësore apo pasuese, kështu që disa nga kufizimet e mësipërme mund të mos zbatohen për ju.",
   "accuracy-of-materials-title": "Saktësia e Materialeve",
   "accuracy-of-materials-description-text": "Materialet që shfaqen në faqet tona të internetit nuk janë gjithëpërfshirëse dhe janë vetëm për qëllime informacioni të përgjithshëm. International Advisory, Products and Systems Ltd nuk garanton dhe nuk bën asnjë deklaratë lidhur me saktësinë, rezultatet e mundshme apo besueshmërinë e përdorimit të materialeve në ato faqe interneti, apo lidhur ndryshe me materiale të tilla apo me ndonjë burim të lidhur me ato faqe interneti. Nuk duhet të mbështeteni vetëm në materialet e përmendura për të marrë vendime; ju këshillojmë të konsultoni burime të tjera, më të plota informacioni. Ju jeni të vetmit përgjegjës për mbështetjen e ngushtë në materialet e postuara në faqet tona të internetit. Ne kemi të drejtë të ndryshojmë informacionin në faqet tona të internetit pa njoftim paraprak dhe përdoruesit janë përgjegjës të monitorojnë ndryshimet e tilla.",
   "additional-tools-title": "Mjete Shtesë",
   "additional-tools-description-text": "Ju lutemi vini re se faqet tona të internetit mund të përfshijnë mjete të palëve të treta që janë jashtë kontrollit tonë. Qasja në këto mjete ofrohet në bazën 'siç është' pa asnjë garanci, të shprehur apo të nënkuptuar, dhe pa asnjë mbështetje apo miratim. Ne nuk mbajmë përgjegjësi për përdorimin e mjeteve të palëve të treta të ofruara në faqet tona të internetit. Ju jeni të vetmit përgjegjës për çdo rrezik të lidhur me përdorimin e mjeteve të tilla; ju rekomandojmë të lexoni Kushtet e Shërbimit të ofruesit përkatës të palës së tretë. International Advisory, Products and Systems Ltd ka të drejtë të ofrojë mjete të reja të palëve të treta në të ardhmen",
   "links-title": "Lidhje",
   "links-description-text": "International Advisory, Products and Systems Ltd nuk i ka shqyrtuar të gjitha faqet e lidhura me faqet e saj të internetit dhe nuk mban përgjegjësi për përmbajtjen e ndonjë faqeje të tillë të lidhur. Përfshirja e ndonjë lidhjeje nuk nënkupton mbështetje, miratim apo kontroll nga ana e International Advisory, Products and Systems Ltd mbi atë faqe. Përdorimi i ndonjë faqeje të tillë të lidhur bëhet në rrezikun tuaj, dhe ne ju këshillojmë fuqimisht të bëni hetimet tuaja të veta lidhur me përshtatshmërinë e atyre faqeve.",
   "inaccuracies-and-mistakes-title": "Pasaktësi dhe Gabime",
   "inaccuracies-and-mistakes-description-text": "Ju lutemi vini re se çdo përmbajtje e disponueshme në faqet tona të internetit mund të përmbajë gabime shtypi, pasaktësi apo gabime të lidhura me përshkrimin e shërbimit, çmimin, promovimin dhe disponueshmërinë. Ne kemi të drejtë të anulojmë apo përditësojmë ndonjë shërbim ekzistues nëse ndonjë informacion i dhënë nga ne rezulton i pasaktë. Informacioni i tillë mund të ndryshohet në çdo kohë pa njoftim paraprak. Ju lutemi vini re se ne nuk kemi detyrim të sqarojmë ndonjë nga informacionet e lidhura me faqet tona të internetit dhe shërbimet, duke përfshirë informacionin mbi çmimet, përveç rasteve kur kërkohet nga ligji.",
   "indemnification-title": "Dëmshpërblimi",
   "indemnification-description-text": "Ju pranoni të na mbroni, të na dëmshpërbleni dhe të na mbani të padëmtuar, duke përfshirë filialet tona, entitetet e lidhura, dhe të gjithë zyrtarët, agjentët, partnerët dhe punonjësit tanë përkatës, nga dhe kundër çdo humbjeje, dëmi, përgjegjësie, pretendimi apo kërkese, duke përfshirë tarifat dhe shpenzimet e arsyeshme të avokatëve, të ngritura nga ndonjë palë e tretë për shkak të ose që rrjedhin nga: (1) Kontributet tuaja; (2) përdorimi i faqeve të internetit; (3) shkelja e këtyre Kushteve të Shërbimit; (4) çdo shkelje e deklaratave dhe garancive tuaja të përcaktuara në këto Kushte të Shërbimit; (5) shkelja juaj e të drejtave të një pale të tretë, duke përfshirë por pa u kufizuar në të drejtat e pronësisë intelektuale; ose (6) ndonjë veprim i hapur dëmtues ndaj ndonjë përdoruesi tjetër të faqeve të internetit me të cilin jeni lidhur përmes faqeve të internetit.",
   "indemnification-defense-text": "Pavarësisht nga sa më sipër, ne rezervojmë të drejtën, me shpenzimet tuaja, të marrim mbrojtjen dhe kontrollin ekskluziv të çdo çështjeje për të cilën ju kërkohet të na dëmshpërbleni, dhe ju pranoni të bashkëpunoni, me shpenzimet tuaja, në mbrojtjen tonë ndaj pretendimeve të tilla. Ne do të bëjmë përpjekje të arsyeshme për t'ju njoftuar për çdo pretendim, veprim apo procedim të tillë që i nënshtrohet këtij dëmshpërblimi, sapo të jemi në dijeni të tij.",
   "right-to-terminate-title": "E Drejta për Përfundim",
   "right-to-terminate-description-text": "Ne mund të pezullojmë apo përfundojmë të drejtën tuaj për të përdorur faqet tona të internetit dhe të përfundojmë këto Kushte të Shërbimit menjëherë me njoftim me shkrim drejtuar jush, për çdo shkelje të këtyre Kushteve të Shërbimit.",
   "severance-title": "Ndashmëria",
   "severance-description-text": "Çdo term i këtyre Kushteve të Shërbimit që është tërësisht apo pjesërisht i pavlefshëm apo i pazbatueshëm, ndahet (shkëputet) në masën që është i pavlefshëm apo i pazbatueshëm. Vlefshmëria e pjesës së mbetur të këtyre Kushteve të Shërbimit nuk preket.",
   "entire-agreement-title": "Marrëveshja e Plotë",
   "entire-agreement-description-text": "Këto Kushte të Shërbimit dhe çdo politikë apo rregull operativ i publikuar nga ne në faqet e internetit apo në lidhje me to, përbëjnë marrëveshjen dhe mirëkuptimin e plotë mes jush dhe nesh. Moszbatimi ose mosushtrimi ynë i ndonjë të drejte apo dispozite të këtyre Kushteve të Shërbimit nuk do të konsiderohet si heqje dorë nga ajo e drejtë apo dispozitë. Këto Kushte të Shërbimit veprojnë në masën më të plotë të lejuar nga ligji. Ne mund t'i kalojmë çdo ose të gjitha të drejtat dhe detyrimet tona të tjerëve në çdo kohë. Ne nuk do të jemi përgjegjës për ndonjë humbje, dëm, vonesë apo dështim për të vepruar, të shkaktuar nga ndonjë shkak jashtë kontrollit tonë të arsyeshëm. Nëse ndonjë dispozitë apo pjesë e një dispozite e këtyre Kushteve të Shërbimit përcaktohet të jetë e paligjshme, e pavlefshme apo e pazbatueshme, ajo dispozitë apo pjesë e dispozitës konsiderohet e ndashme nga këto Kushte të Shërbimit dhe nuk prek vlefshmërinë dhe zbatueshmërinë e dispozitave të tjera të mbetura. Nuk krijohet asnjë marrëdhënie sipërmarrjeje të përbashkët, ortakërie, punësimi apo agjencie mes jush dhe nesh si rezultat i këtyre Kushteve të Shërbimit apo përdorimit të faqeve të internetit. Ju pranoni që këto Kushte të Shërbimit nuk do të interpretohen kundër nesh për shkak se i kemi hartuar ato. Ju hiqni dorë me këtë akt nga çdo dhe të gjitha mbrojtjet që mund të keni bazuar në formën elektronike të këtyre Kushteve të Shërbimit dhe mungesën e nënshkrimit nga palët e këtyre Kushteve të Shërbimit për t'i vënë në zbatim këto Kushte të Shërbimit.",
   "governing-law-title": "Ligji i Zbatueshëm",
   "governing-law-description-text": "Këto Kushte të Shërbimit rregullohen dhe interpretohen në përputhje me ligjet e Virginia. Ju i nënshtroheni në mënyrë të parevokueshme juridiksionit ekskluziv të gjykatave në atë Shtet apo vendndodhje.",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "Këto Kushte të Shërbimit u përditësuan për herë të fundit më 4 mars 2024.",
   "cookie-intro-websites-prefix-text": "Ne përdorim cookies për të ndihmuar në përmirësimin e përvojës suaj me faqet tona të internetit në",
   "cookie-intro-websites-suffix-text": ". Kjo politikë e cookies është pjesë e politikës së privatësisë së International Advisory, Products and Systems Ltd. Ajo mbulon përdorimin e cookies ndërmjet pajisjes suaj dhe faqeve tona.",
   "cookie-third-party-services-notice-text": "Ne gjithashtu ofrojmë informacion bazë mbi shërbimet e palëve të treta që mund të përdorim, të cilat gjithashtu mund të përdorin cookies si pjesë e shërbimit të tyre. Kjo politikë nuk mbulon cookies e tyre.",
   "cookie-refuse-prefix-text": "Nëse nuk dëshironi të pranoni cookies nga ne, duhet t'i jepni udhëzime shfletuesit tuaj që të refuzojë cookies nga",
   "cookie-refuse-suffix-text": ". Në një rast të tillë, mund të mos jemi në gjendje t'ju ofrojmë disa nga përmbajtjet dhe shërbimet e dëshiruara.",
   "what-is-a-cookie-title": "Çfarë është një cookie?",
   "cookie-definition-text": "Një cookie është një pjesë e vogël e të dhënave që një faqe interneti e ruan në pajisjen tuaj kur e vizitoni. Zakonisht ajo përmban informacion rreth vetë faqes së internetit, një identifikues unik që i mundëson faqes të njohë shfletuesin tuaj kur ktheheni, të dhëna shtesë që i shërbejnë qëllimit të cookie-t, si dhe kohëzgjatjen e vetë cookie-t.",
   "cookie-usage-examples-text": "Cookies përdoren për të mundësuar veçori të caktuara (p.sh. hyrjen në llogari), për të gjurmuar përdorimin e faqes (p.sh. analitika), për të ruajtur cilësimet tuaja të përdoruesit (p.sh. zona kohore, preferencat e njoftimeve), si dhe për të personalizuar përmbajtjen tuaj (p.sh. reklamat, gjuha).",
   "first-party-cookies-definition-text": "Cookies të vendosura nga faqja e internetit që po vizitoni zakonisht quhen cookies të palës së parë. Ato zakonisht gjurmojnë vetëm aktivitetin tuaj në atë faqe të veçantë.",
   "third-party-cookies-definition-text": "Cookies të vendosura nga faqe dhe kompani të tjera (d.m.th. palë të treta) quhen cookies të palës së tretë. Ato mund të përdoren për t'ju gjurmuar në faqe të tjera interneti që përdorin të njëjtin shërbim të palës së tretë.",
   "cookie-types-title": "Llojet e cookies dhe si i përdorim ato",
   "essential-cookies-definition-text": "Cookies thelbësore janë vendimtare për përvojën tuaj me një faqe interneti, duke mundësuar veçori themelore si hyrja e përdoruesve, menaxhimi i llogarisë, shporta e blerjeve dhe përpunimi i pagesave.",
   "essential-cookies-usage-text": "Ne përdorim cookies thelbësore për të mundësuar funksione të caktuara në faqet tona të internetit.",
   "performance-cookies-title": "Cookies të performancës",
   "performance-cookies-definition-text": "Cookies e performancës gjurmojnë mënyrën se si e përdorni një faqe interneti gjatë vizitës suaj. Zakonisht, ky informacion është anonim dhe i agreguar, duke u gjurmuar në të gjithë përdoruesit e faqes. Ato ndihmojnë kompanitë të kuptojnë modelet e përdorimit të vizitorëve, të identifikojnë dhe diagnostikojnë problemet apo gabimet që mund të hasin përdoruesit e tyre, dhe të marrin vendime më të mira strategjike për të përmirësuar përvojën e përgjithshme të audiencës së tyre me faqen e internetit. Këto cookies mund të vendosen nga faqja që po vizitoni (palë e parë) ose nga shërbime të palëve të treta. Ato nuk mbledhin informacion personal rreth jush.",
   "performance-cookies-usage-text": "Ne përdorim cookies të performancës në faqet tona.",
   "functionality-cookies-title": "Cookies të funksionalitetit",
   "functionality-cookies-definition-text": "Cookies e funksionalitetit përdoren për të mbledhur informacion rreth pajisjes suaj dhe çdo cilësimi që mund të konfiguroni në faqen e internetit që po vizitoni (si cilësimet e gjuhës dhe zonës kohore). Me këtë informacion, faqet e internetit mund t'ju ofrojnë përmbajtje dhe shërbime të personalizuara, të përmirësuara ose të optimizuara. Këto cookies mund të vendosen nga faqja që po vizitoni (palë e parë) ose nga shërbime të palëve të treta.",
   "functionality-cookies-usage-text": "Ne përdorim cookies të funksionalitetit për veçori të caktuara në faqet tona.",
   "targeting-advertising-cookies-title": "Cookies të synimit/reklamimit",
   "targeting-advertising-cookies-definition-text": "Cookies e synimit/reklamimit ndihmojnë në përcaktimin e përmbajtjes promocionale që është më e rëndësishme dhe e përshtatshme për ju dhe interesat tuaja. Faqet e internetit mund t'i përdorin ato për të ofruar reklama të synuara ose për të kufizuar numrin e herëve që shihni një reklamë. Kjo ndihmon kompanitë të përmirësojnë efektivitetin e fushatave të tyre dhe cilësinë e përmbajtjes që ju paraqitet. Këto cookies mund të vendosen nga faqja që po vizitoni (palë e parë) ose nga shërbime të palëve të treta. Cookies e synimit/reklamimit të vendosura nga palët e treta mund të përdoren për t'ju gjurmuar në faqe të tjera interneti që përdorin të njëjtin shërbim të palës së tretë.",
   "targeting-advertising-cookies-usage-text": "Ne përdorim cookies të synimit/reklamimit në faqet tona.",
   "control-cookies-title": "Si Mund të Kontrolloni Përdorimin e Cookies nga Faqja Jonë e Internetit?",
   "cookie-consent-manager-description-text": "Ju keni të drejtë të vendosni nëse do të pranoni apo refuzoni cookies në faqet tona të internetit. Mund t'i menaxhoni preferencat tuaja për cookies në Cookie Consent Manager-in tonë. Cookie Consent Manager ju lejon të zgjidhni cilat kategori cookies pranoni apo refuzoni. Cookies thelbësore nuk mund të refuzohen pasi janë rreptësisht të nevojshme për t'ju ofruar shërbimet në faqet tona të internetit.",
   "browser-settings-cookie-control-text": "Ju gjithashtu mund të vendosni ose ndryshoni preferencat tuaja për cookies duke menaxhuar cilësimet e shfletuesit tuaj të internetit. Meqenëse çdo shfletues interneti është i ndryshëm, ju lutemi konsultoni udhëzimet e ofruara nga shfletuesi juaj (zakonisht në seksionin \"ndihmë\"). Nëse zgjidhni të refuzoni ose të çaktivizoni cookies, mund të vazhdoni të përdorni faqet tona të internetit, megjithëse disa nga funksionalitetet e tyre mund të mos jenë të disponueshme për ju.",
   "cookie-policy-update-frequency-title": "Sa Shpesh do ta Përditësojmë këtë Politikë të Cookies?",
   "cookie-policy-update-reason-text": "Ne mund ta përditësojmë këtë Politikë të Cookies herë pas here për të pasqyruar çdo ndryshim në cookies dhe teknologjitë e ngjashme që përdorim, ose për arsye të tjera operacionale, ligjore apo rregullatore.",
   "cookie-policy-version-notice-text": "Çdo herë që përdorni faqet tona të internetit, do të zbatohet versioni aktual i Politikës së Cookies. Kur përdorni faqet tona të internetit, duhet të kontrolloni datën e kësaj Politike të Cookies (e cila shfaqet në krye të këtij dokumenti) dhe të shqyrtoni çdo ndryshim që nga versioni i fundit.",
   "cookie-policy-further-info-title": "Ku Mund të Merrni Informacion të Mëtejshëm?",
   "cookie-policy-contact-us-description-text": "Për çdo pyetje apo shqetësim lidhur me Politikën tonë të Cookies, mund të na kontaktoni duke përdorur të dhënat e mëposhtme:",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "Këto Kushte të Shërbimit u përditësuan për herë të fundit më 4 mars 2024.",
   "privacy-intro-websites-prefix-text": "Privatësia juaj është e rëndësishme për ne. Është politikë e International Advisory, Products and Systems Ltd që të respektojë privatësinë tuaj dhe të jetë në përputhje me çdo ligj dhe rregullore të zbatueshme në lidhje me çdo informacion personal që mund të mbledhim rreth jush, duke përfshirë në faqet tona të internetit,",
   "privacy-intro-websites-suffix-text": ", dhe faqe të tjera që zotërojmë dhe operojmë.",
   "personal-information-definition-text": "Informacioni personal është çdo informacion rreth jush që mund të përdoret për t'ju identifikuar. Kjo përfshin informacion rreth jush si person (si emri, adresa dhe data e lindjes), pajisjet tuaja, detajet e pagesës, madje edhe informacion se si përdorni një faqe interneti ose shërbim online.",
   "third-party-sites-disclaimer-text": "Në rast se faqet tona përmbajnë lidhje drejt faqesh dhe shërbimesh të palëve të treta, ju lutemi kini parasysh se ato faqe dhe shërbime kanë politikat e tyre të privatësisë. Pas ndjekjes së një lidhjeje drejt çdo përmbajtjeje të palëve të treta, duhet të lexoni informacionin e publikuar mbi politikën e tyre të privatësisë në lidhje me mënyrën se si mbledhin dhe përdorin informacionin personal. Kjo Politikë e Privatësisë nuk zbatohet për asnjë nga aktivitetet tuaja pasi të largoheni nga një prej faqeve tona.",
   "information-we-collect-title": "Informacioni Që Mbledhim",
   "information-categories-intro-text": "Informacioni që mbledhim përfshihet në një nga dy kategoritë: informacion i \"dhënë vullnetarisht\" dhe informacion i \"mbledhur automatikisht\"",
   "voluntarily-provided-info-description-text": "Informacioni i \"dhënë vullnetarisht\" i referohet çdo informacioni që na jepni në mënyrë të vetëdijshme dhe aktive kur përdorni ose merrni pjesë në ndonjë nga shërbimet dhe promocionet tona.",
   "automatically-collected-info-description-text": "Informacioni i \"mbledhur automatikisht\" i referohet çdo informacioni që dërgohet automatikisht nga pajisjet tuaja gjatë qasjes suaj në produktet dhe shërbimet tona.",
   "log-data-title": "Të Dhënat e Regjistrit",
   "log-data-description-text": "Kur vizitoni një nga faqet tona të internetit, serverët tanë mund të regjistrojnë automatikisht të dhënat standarde të ofruara nga shfletuesi juaj i internetit. Këto mund të përfshijnë adresën e Protokollit të Internetit (IP) të pajisjes suaj, llojin dhe versionin e shfletuesit tuaj, faqet që vizitoni, orën dhe datën e vizitës suaj, kohën e kaluar në secilën faqe, si dhe detaje të tjera rreth vizitës suaj.",
   "log-data-errors-description-text": "Përveç kësaj, nëse hasni gabime të caktuara gjatë përdorimit të faqeve tona, ne mund të mbledhim automatikisht të dhëna rreth gabimit dhe rrethanave që shoqërojnë shfaqjen e tij. Këto të dhëna mund të përfshijnë detaje teknike rreth pajisjes suaj, çfarë po përpiqeshit të bënit kur ndodhi gabimi, si dhe informacione të tjera teknike që lidhen me problemin. Ju mund të merrni ose të mos merrni njoftim për gabime të tilla, qoftë në momentin kur ndodhin, se ato kanë ndodhur, apo cila është natyra e gabimit.",
   "device-data-intro-text": "Kur vizitoni faqet tona të internetit ose ndërveproni me shërbimet tona, ne mund të mbledhim automatikisht të dhëna rreth pajisjes suaj, si për shembull:",
   "device-data-title": "Të Dhënat e Pajisjes",
   "device-type-label": "Lloji i pajisjes",
   "log-data-combination-warning-text": "Ju lutemi kini parasysh se, edhe pse ky informacion mund të mos jetë identifikues personalisht në vetvete, është e mundur që të kombinohet me të dhëna të tjera për të identifikuar personalisht persona individualë.",
   "operating-system-label": "Sistemi operativ",
   "unique-device-identifiers-label": "Identifikuesit unikë të pajisjes",
   "geo-location-data-label": "Të dhëna të gjeolokacionit",
   "device-data-settings-note-text": "Të dhënat që mbledhim mund të varen nga cilësimet individuale të pajisjes dhe softuerit tuaj. Ju rekomandojmë të kontrolloni politikat e prodhuesit të pajisjes suaj ose ofruesit të softuerit për të mësuar se cilat informacione ata na vënë në dispozicion.",
   "personal-information-title": "Informacion Personal",
   "personal-information-intro-text": "Ne mund t'ju kërkojmë informacione personale — për shembull, kur abonoheni në buletinin tonë ose kur na kontaktoni — të cilat mund të përfshijnë një ose më shumë nga sa vijon:",
   "social-media-profiles-label": "Profile në rrjetet sociale",
   "date-of-birth-label": "Data e lindjes",
   "phone-mobile-number-label": "Numri i telefonit/celularit",
   "home-mailing-address-label": "Adresa e banimit/postare",
   "work-related-information-label": "Informacion në lidhje me punën",
   "company-name-label": "Emri i kompanisë",
   "title-field-label": "Titulli",
   "sensitive-information-title": "Informacione të Ndjeshme",
   "sensitive-information-definition-text": "„Informacioni i ndjeshëm” ose „kategoritë e veçanta të të dhënave” janë një nënbashkësi e informacionit personal të cilit i jepet një nivel më i lartë mbrojtjeje. Shembuj të informacionit të ndjeshëm përfshijnë informacionin që lidhet me origjinën tuaj racore ose etnike, opinionet politike, fenë, sindikatën ose shoqatat apo anëtarësimet e tjera profesionale, bindjet filozofike, orientimin seksual, praktikat seksuale ose jetën seksuale, dosjet penale, informacionin shëndetësor, ose informacionin biometrik.",
   "sensitive-information-types-intro-text": "Llojet e informacionit të ndjeshëm që mund të mbledhim rreth jush përfshijnë:",
   "sensitive-information-consent-text": "Ne nuk do të mbledhim informacion të ndjeshëm rreth jush pa marrë më parë pëlqimin tuaj, dhe do ta përdorim ose zbulojmë informacionin tuaj të ndjeshëm vetëm ashtu siç lejohet, kërkohet, ose autorizohet nga ligji.",
   "privacy-user-generated-content-description-text": "Ne e konsiderojmë „përmbajtjen e krijuar nga përdoruesi” si materiale (tekst, imazhe dhe/ose përmbajtje video) të dhëna vullnetarisht nga përdoruesit tanë me qëllim publikimin, përpunimin, ose përdorimin në platformën tonë. E gjithë përmbajtja e krijuar nga përdoruesi shoqërohet me llogarinë ose adresën e email-it të përdorur për dërgimin e materialeve.",
   "user-generated-content-publication-notice-text": "Ju lutemi të keni parasysh se çdo përmbajtje që dërgoni me qëllim publikimin do të jetë publike pas postimit (dhe procesit pasues të shqyrtimit ose verifikimit). Pas publikimit, ajo mund të jetë e aksesueshme për palë të treta që nuk mbulohen nga kjo politikë e privatësisë.",
   "transaction-data-title": "Të Dhënat e Transaksionit",
   "transaction-data-description-text": "Të dhënat e transaksionit i referohen të dhënave që grumbullohen gjatë ecurisë normale të funksionimit të platformës sonë. Këto mund të përfshijnë regjistrimet e transaksioneve, skedarët e ruajtur, profilet e përdoruesve, të dhënat analitike dhe metrika të tjera, si dhe lloje të tjera informacioni, të krijuara ose të gjeneruara, ndërsa përdoruesit ndërveprojnë me shërbimet tona.",
   "legitimate-reasons-title": "Arsyet e Ligjshme për Përpunimin e Informacionit Tuaj Personal",
   "legitimate-reasons-description-text": "Ne mbledhim dhe përdorim informacionin tuaj personal vetëm kur kemi një arsye të ligjshme për ta bërë këtë. Në këtë rast, ne mbledhim vetëm informacionin personal që është i nevojshëm në mënyrë të arsyeshme për t'ju ofruar shërbimet tona.",
   "collection-and-use-title": "Mbledhja dhe Përdorimi i Informacionit",
   "collection-and-use-intro-text": "Ne mund të mbledhim informacion personal nga ju kur ju kryeni ndonjë nga veprimet e mëposhtme në faqet tona të internetit:",
   "collect-register-account-text": "Regjistroheni për një llogari",
   "collect-purchase-subscription-text": "Blini një abonim",
   "collect-signup-updates-text": "Regjistroheni për të marrë përditësime nga ne përmes email-it ose kanaleve të mediave sociale",
   "collect-mobile-browser-text": "Përdorni një pajisje celulare ose shfletues në internet për të hyrë në përmbajtjen tonë",
   "collect-contact-us-text": "Na kontaktoni përmes email-it, mediave sociale, ose përmes çdo teknologjie tjetër të ngjashme",
   "collect-social-media-mention-text": "Kur na përmendni në mediat sociale",
   "collection-purposes-intro-text": "Ne mund të mbledhim, mbajmë, përdorim dhe zbulojmë informacion për qëllimet e mëposhtme, dhe informacioni personal nuk do të përpunohet më tej në një mënyrë që është e papajtueshme me këto qëllime:",
   "purpose-core-features-text": "për t'ju ofruar veçoritë dhe shërbimet kryesore të platformës sonë",
   "purpose-customize-experience-text": "për t'ju mundësuar të personalizoni ose të përshtatni përvojën tuaj në faqet tona të internetit",
   "purpose-deliver-products-text": "për t'ju dorëzuar produkte dhe/ose shërbime",
   "purpose-contact-communicate-text": "për t'ju kontaktuar dhe komunikuar me ju",
   "purpose-analytics-research-text": "për analitikë, kërkim tregu dhe zhvillim biznesi, përfshirë funksionimin dhe përmirësimin e faqeve tona të internetit, aplikacioneve të lidhura dhe platformave të lidhura të mediave sociale",
   "purpose-advertising-marketing-text": "për reklamim dhe marketing, përfshirë dërgimin e informacionit promocional në lidhje me produktet dhe shërbimet tona, si dhe informacionit në lidhje me palët e treta që ne konsiderojmë se mund të jenë me interes për ju",
   "purpose-enable-access-text": "për t'ju mundësuar aksesimin dhe përdorimin e faqeve tona të internetit, aplikacioneve përkatëse, dhe platformave përkatëse të mediave sociale",
   "purpose-record-keeping-text": "për mbajtjen e dokumentacionit të brendshëm dhe për qëllime administrative",
   "purpose-legal-compliance-text": "për të përmbushur detyrimet tona ligjore dhe për të zgjidhur çdo mosmarrëveshje që mund të kemi",
   "purpose-attribute-content-text": "për të atribuar çdo përmbajtje (p.sh. postime dhe komente) që ju dërgoni dhe që ne publikojmë në faqet tona të internetit",
   "purpose-security-fraud-text": "për siguri dhe parandalim të mashtrimit, si dhe për të siguruar që faqet dhe aplikacionet tona janë të sigurta, të mbrojtura, dhe përdoren në përputhje me kushtet tona të përdorimit",
   "purpose-technical-assessment-text": "për vlerësim teknik, përfshirë funksionimin dhe përmirësimin e aplikacionit tonë, aplikacioneve të lidhura dhe platformave të lidhura të mediave sociale",
   "collection-combine-sources-text": "Ne mund të kombinojmë informacionin personal të dhënë vullnetarisht dhe atë të mbledhur automatikisht me informacione të përgjithshme ose të dhëna kërkimore që marrim nga burime të tjera të besueshme. Për shembull, nëse na jepni vendndodhjen tuaj, ne mund ta kombinojmë këtë me informacione të përgjithshme rreth monedhës dhe gjuhës për t'ju ofruar një përvojë të përmirësuar të faqeve dhe shërbimit tonë.",
   "security-of-information-title": "Siguria e Informacionit Tuaj Personal",
   "security-measures-description-text": "Kur mbledhim dhe përpunojmë informacion personal, dhe përderisa e ruajmë këtë informacion, ne do ta mbrojmë atë brenda mjeteve tregtarisht të pranueshme për të parandaluar humbjen dhe vjedhjen, si dhe qasjen, zbulimin, kopjimin, përdorimin ose modifikimin e paautorizuar.",
   "security-no-guarantee-text": "Megjithëse ne do të bëjmë çmos për të mbrojtur informacionin personal që na jepni, ju këshillojmë se asnjë metodë e transmetimit ose ruajtjes elektronike nuk është 100% e sigurt dhe askush nuk mund të garantojë siguri absolute të të dhënave.",
   "security-password-responsibility-text": "Ju jeni përgjegjës për zgjedhjen e çdo fjalëkalimi dhe fuqinë e tij të përgjithshme të sigurisë, duke siguruar sigurinë e informacionit tuaj brenda kufijve të shërbimeve tona. Për shembull, duke siguruar që çdo fjalëkalim i lidhur me qasjen në informacionin tuaj personal dhe llogaritë tuaja të jetë i sigurt dhe konfidencial.",
   "retention-period-title": "Sa Kohë i Ruajmë të Dhënat Tuaja Personale",
   "retention-period-description-text": "Ne i ruajmë të dhënat tuaja personale vetëm për aq kohë sa na nevojitet. Ky afat kohor mund të varet nga qëllimi për të cilin po i përdorim të dhënat tuaja, në përputhje me këtë politikë të privatësisë. Për shembull, nëse na keni dhënë të dhëna personale si pjesë e krijimit të një llogarie pranë nesh, ne mund t'i ruajmë këto të dhëna për aq kohë sa llogaria juaj ekziston në sistemin tonë. Nëse të dhënat tuaja personale nuk janë më të nevojshme për këtë qëllim, ne do t'i fshijmë ose do t'i bëjmë anonime duke hequr të gjitha detajet që ju identifikojnë.",
   "retention-legal-obligation-text": "Megjithatë, nëse është e nevojshme, ne mund t'i ruajmë të dhënat tuaja personale për të përmbushur një detyrim ligjor, kontabël ose raportues, ose për qëllime arkivimi në interes publik, për qëllime kërkimi shkencor ose historik, apo për qëllime statistikore.",
   "childrens-privacy-title": "Privatësia e Fëmijëve",
   "childrens-privacy-description-text": "Ne nuk i drejtojmë asnjë nga produktet apo shërbimet tona drejtpërdrejt tek fëmijët nën moshën 13 vjeç dhe nuk mbledhim me vetëdije të dhëna personale për fëmijë nën 13 vjeç.",
   "disclosure-to-third-parties-title": "Zbulimi i të Dhënave Personale te Palët e Treta",
   "disclosure-intro-text": "Ne mund t'i zbulojmë të dhënat personale te:",
   "disclose-affiliate-text": "një shoqëri mëmë, filial ose të lidhur me kompaninë tonë",
   "disclose-service-providers-text": "ofrues shërbimesh të palëve të treta, me qëllim që t'u mundësohet atyre ofrimi i shërbimeve të tyre, duke përfshirë (pa kufizim) ofruesit e shërbimeve të TI-së, ofruesit e ruajtjes së të dhënave, hostimit dhe serverave, rrjetet e reklamave, ofruesit e analitikës, regjistruesit e gabimeve, agjencitë e arkëtimit të borxheve, ofruesit e mirëmbajtjes ose zgjidhjes së problemeve, ofruesit e marketingut ose reklamimit, këshilltarët profesionistë, dhe operatorët e sistemeve të pagesave",
   "disclose-employees-text": "punonjësit tanë, kontraktorët tanë, dhe/ose subjektet e lidhura me ne",
   "disclose-business-partners-text": "agjentët ose partnerët tanë të biznesit, ekzistues ose të mundshëm",
   "disclose-credit-agencies-text": "agjencitë e raportimit të kredisë, gjykatat, tribunalet, dhe autoritetet rregullatore, në rast se dështoni të paguani për mallrat ose shërbimet që ju kemi ofruar",
   "disclose-law-enforcement-text": "gjykata, tribunale, autoritete rregullatore dhe zyrtarë të zbatimit të ligjit, siç kërkohet nga ligji, në lidhje me çdo procedurë ligjore aktuale ose të mundshme, ose me qëllim të vendosjes, ushtrimit ose mbrojtjes së të drejtave tona ligjore",
   "disclose-agents-subcontractors-text": "palë të treta, përfshirë agjentë ose nënkontraktorë që na ndihmojnë në ofrimin e informacionit, produkteve, shërbimeve ose marketingut të drejtpërdrejtë për ju",
   "disclose-collect-process-text": "palë të treta për të mbledhur dhe përpunuar të dhëna",
   "disclose-business-transfer-text": "një subjekt që blen, ose të cilit i transferojmë të gjitha ose pothuajse të gjitha asetet dhe biznesin tonë",
   "third-parties-currently-used-text": "Palët e treta që përdorim aktualisht përfshijnë:",
   "international-transfers-title": "Transferimet Ndërkombëtare të Informacionit Personal",
   "international-transfers-description-text": "Informacioni personal që ne mbledhim ruhet dhe/ose përpunohet në Shtetet e Bashkuara, ose atje ku ne apo partnerët tanë, filialet dhe ofruesit e palëve të treta mbajnë objekte.",
   "international-transfers-legal-note-text": "Vendet në të cilat ne ruajmë, përpunojmë ose transferojmë informacionin tuaj personal mund të mos kenë të njëjtat ligje për mbrojtjen e të dhënave si vendi në të cilin ju e keni dhënë fillimisht këtë informacion. Nëse ne transferojmë informacionin tuaj personal tek palë të treta në vende të tjera: (i) ne do t'i kryejmë këto transferime në përputhje me kërkesat e ligjit në fuqi; dhe (ii) ne do ta mbrojmë informacionin personal të transferuar në përputhje me këtë politikë privatësie.",
   "your-rights-title": "Të Drejtat Tuaja dhe Kontrolli mbi Informacionin Tuaj Personal",
   "your-choice-description-text": "Zgjedhja juaj: Duke na dhënë informacion personal, ju kuptoni se ne do të mbledhim, mbajmë, përdorim dhe zbulojmë informacionin tuaj personal në përputhje me këtë politikë privatësie. Ju nuk jeni të detyruar të na jepni informacion personal, megjithatë, nëse nuk e bëni këtë, kjo mund të ndikojë në përdorimin tuaj të faqeve tona të internetit ose të produkteve dhe/ose shërbimeve që ofrohen në to ose nëpërmjet tyre.",
   "info-from-third-parties-text": "Informacion nga palët e treta: Nëse ne marrim informacion personal rreth jush nga një palë e tretë, ne do ta mbrojmë atë siç përcaktohet në këtë politikë privatësie. Nëse ju jeni një palë e tretë që jep informacion personal rreth dikujt tjetër, ju deklaroni dhe garantoni se keni pëlqimin e këtij personi për t'i dhënë ne informacionin e tij personal.",
   "marketing-permission-text": "Leja për marketing: Nëse më parë keni pranuar që ne të përdorim informacionin tuaj personal për qëllime marketingu të drejtpërdrejtë, ju mund ta ndryshoni mendimin tuaj në çdo kohë duke na kontaktuar duke përdorur të dhënat më poshtë.",
   "access-rights-text": "Qasja: Ju mund të kërkoni detaje mbi informacionin personal që ne mbajmë për ju.",
   "correction-rights-text": "Korrigjimi: Nëse besoni se ndonjë informacion që ne mbajmë për ju është i pasaktë, i vjetëruar, jo i plotë, i parëndësishëm ose mashtrues, ju lutemi na kontaktoni duke përdorur të dhënat e ofruara në këtë politikë të privatësisë. Ne do të ndërmarrim hapa të arsyeshëm për të korrigjuar çdo informacion që rezulton të jetë i pasaktë, jo i plotë, mashtrues ose i vjetëruar.",
   "non-discrimination-text": "Mosdiskriminimi: Ne nuk do t'ju diskriminojmë për ushtrimin e ndonjë prej të drejtave tuaja mbi informacionin tuaj personal. Përveç rastit kur informacioni juaj personal kërkohet për t'ju ofruar një shërbim ose ofertë të veçantë (për shembull, përpunimi i të dhënave të transaksionit), ne nuk do t'ju mohojmë mallra ose shërbime dhe/ose nuk do t'ju ngarkojmë çmime ose tarifa të ndryshme për mallra ose shërbime, duke përfshirë përmes dhënies së zbritjeve ose përfitimeve të tjera, ose vendosjes së penaliteteve, ose ofrimit të një niveli ose cilësie të ndryshme të mallrave ose shërbimeve.",
   "download-personal-info-text": "Shkarkimi i Informacionit Personal: Ne ofrojmë një mënyrë për ju që të shkarkoni informacionin personal që keni ndarë përmes faqeve tona. Ju lutemi na kontaktoni për më shumë informacion.",
   "data-breach-notification-text": "Njoftimi për shkeljet e të dhënave: Ne do të respektojmë ligjet e zbatueshme ndaj nesh në lidhje me çdo shkelje të të dhënave.",
   "complaints-rights-text": "Ankesat: Nëse besoni se ne kemi shkelur një ligj përkatës për mbrojtjen e të dhënave dhe dëshironi të bëni një ankesë, ju lutemi na kontaktoni duke përdorur të dhënat më poshtë dhe na ofroni detaje të plota për shkeljen e pretenduar. Ne do të hetojmë menjëherë ankesën tuaj dhe do t'ju përgjigjemi me shkrim, duke përcaktuar rezultatin e hetimit tonë dhe hapat që do të ndërmarrim për të trajtuar ankesën tuaj. Ju gjithashtu keni të drejtë të kontaktoni një organ rregullator ose autoritet për mbrojtjen e të dhënave në lidhje me ankesën tuaj.",
   "unsubscribe-rights-text": "Çregjistrimi: Për t'u çregjistruar nga baza jonë e të dhënave të email-it ose për të hequr dorë nga komunikimet (përfshirë komunikimet e marketingut), ju lutemi na kontaktoni duke përdorur të dhënat e ofruara në këtë politikë të privatësisë, ose hiqni dorë duke përdorur mundësitë e daljes (opt-out) të ofruara në vetë komunikimin. Mund të na duhet t'ju kërkojmë informacion specifik për të na ndihmuar të konfirmojmë identitetin tuaj.",
   "use-of-cookies-title": "Përdorimi i Cookies",
   "use-of-cookies-description-text": "Ne përdorim \"cookies\" për të mbledhur informacion rreth jush dhe aktivitetit tuaj në faqet tona. Një cookie është një pjesë e vogël të dhënash që faqet tona të internetit ruajnë në kompjuterin tuaj dhe i qasen çdo herë që ju vizitoni, në mënyrë që ne të kuptojmë se si i përdorni faqet tona. Kjo na ndihmon t'ju ofrojmë përmbajtje bazuar në preferencat që keni specifikuar.",
   "refer-to-cookie-policy-text": "Ju lutemi referojuni Politikës sonë të Cookies për më shumë informacion.",
   "business-transfers-title": "Transferimet e Biznesit",
   "business-transfers-description-text": "Nëse ne ose asetet tona blihen, ose në rastin e pak të mundshëm që ne të dalim nga biznesi ose të hyjmë në falimentim, ne do të përfshinim të dhënat, përfshirë informacionin tuaj personal, ndër asetet e transferuara tek çdo palë që na blen. Ju pranoni se transferime të tilla mund të ndodhin, dhe se çdo palë që na blen mund, në masën e lejuar nga ligji në fuqi, të vazhdojë të përdorë informacionin tuaj personal në përputhje me këtë politikë, të cilën do t'i duhet ta pranojë, pasi ajo është baza për çdo të drejtë pronësie ose përdorimi që ne kemi mbi informacionin e tillë.",
   "limits-of-policy-title": "Kufizimet e Politikës Sonë",
   "limits-of-policy-description-text": "Faqet tona të internetit mund të përmbajnë lidhje drejt faqeve të tjera të jashtme që nuk operohen nga ne. Ju lutemi kini parasysh se ne nuk kemi asnjë kontroll mbi përmbajtjen dhe politikat e këtyre faqeve dhe nuk mund të pranojmë asnjë përgjegjësi apo detyrim ligjor për praktikat përkatëse të privatësisë së tyre.",
   "changes-to-policy-title": "Ndryshimet në Këtë Politikë",
   "changes-to-policy-description-text": "Sipas gjykimit tonë, ne mund të ndryshojmë politikën tonë të privatësisë për të reflektuar përditësimet e proceseve tona të biznesit, praktikat aktuale të pranueshme, ose ndryshimet legjislative apo rregullatore. Nëse vendosim të ndryshojmë këtë politikë privatësie, ne do t'i publikojmë ndryshimet këtu, në të njëjtën lidhje përmes së cilës po e qaseni këtë politikë privatësie.",
   "changes-significant-notice-text": "Nëse ndryshimet janë të konsiderueshme, ose nëse kërkohet nga ligji në fuqi, ne do t'ju kontaktojmë (bazuar në preferencat tuaja të zgjedhura për komunikimet nga ne) dhe të gjithë përdoruesit tanë të regjistruar me detajet e reja dhe lidhjet drejt politikës së përditësuar apo të ndryshuar.",
   "changes-permission-text": "Nëse kërkohet nga ligji, ne do të marrim lejen tuaj ose do t'ju japim mundësinë të pranoni ose të refuzoni, sipas rastit, çdo përdorim të ri të informacionit tuaj personal.",
   "au-privacy-act-title": "Zbulime Shtesë për Përputhshmërinë me Aktin Australian të Privatësisë (AU)",
   "au-privacy-act-description-text": "Kur zbulimi i informacionit tuaj personal i nënshtrohet vetëm ligjeve australiane për privatësinë, ju pranoni se disa palë të treta mund të mos rregullohen nga Akti i Privatësisë dhe nga Parimet Australiane të Privatësisë të përfshira në Aktin e Privatësisë. Ju pranoni se, nëse ndonjë palë e tretë e tillë kryen ndonjë veprim ose praktikë që bie në kundërshtim me Parimet Australiane të Privatësisë, ajo nuk do të jetë përgjegjëse sipas Aktit të Privatësisë, dhe ju nuk do të keni mundësi të kërkoni zgjidhje (dëmshpërblim) sipas Aktit të Privatësisë.",
   "gdpr-compliance-title": "Zbulime Shtesë për Përputhshmërinë me Rregulloren e Përgjithshme për Mbrojtjen e të Dhënave (GDPR) (BE)",
   "data-controller-processor-title": "Kontrollues i të Dhënave / Përpunues i të Dhënave",
   "data-controller-processor-description-text": "GDPR bën dallimin midis organizatave që përpunojnë informacion personal për qëllimet e tyre (të njohura si \"kontrollues të të dhënave\") dhe organizatave që përpunojnë informacion personal në emër të organizatave të tjera (të njohura si \"përpunues të të dhënave\"). Ne, International Advisory, Products and Systems Ltd, që ndodhemi në adresën e dhënë në seksionin tonë \"Na Kontaktoni\", jemi Kontrollues dhe/ose Përpunues i të Dhënave në lidhje me informacionin personal që ju na ofroni.",
   "legal-bases-title": "Bazat Ligjore për Përpunimin e Informacionit Tuaj Personal",
   "legal-bases-description-text": "Ne do të mbledhim dhe përdorim informacionin tuaj personal vetëm kur kemi të drejtën ligjore për ta bërë këtë. Në këtë rast, ne do të mbledhim dhe përdorim informacionin tuaj personal në mënyrë të ligjshme, të drejtë dhe transparente. Nëse kërkojmë pëlqimin tuaj për të përpunuar informacionin tuaj personal, dhe ju jeni nën moshën 16 vjeç, ne do të kërkojmë pëlqimin e prindit tuaj ose kujdestarit ligjor për të përpunuar informacionin tuaj personal për atë qëllim specifik.",
   "legal-bases-grounds-text": "Bazat tona ligjore varen nga shërbimet që përdorni dhe mënyra se si i përdorni ato. Kjo do të thotë që ne mbledhim dhe përdorim informacionin tuaj vetëm mbi bazat e mëposhtme:",
   "consent-from-you-title": "Pëlqimi Juaj",
   "consent-from-you-description-text": "Kur na jepni pëlqimin për të mbledhur dhe përdorur informacionin tuaj personal për një qëllim specifik. Ju mund ta tërhiqni pëlqimin tuaj në çdo kohë duke përdorur mjetet që ne ofrojmë; megjithatë, kjo nuk do të ndikojë në asnjë përdorim të informacionit tuaj që ka ndodhur tashmë. Ju mund të jepni pëlqimin për të ofruar adresën tuaj të email-it me qëllim marrjen e email-eve marketingu nga ne. Ndërkohë që mund të çregjistroheni në çdo kohë, ne nuk mund ta tërheqim asnjë email që kemi dërguar tashmë. Nëse keni ndonjë pyetje të mëtejshme se si të tërhiqni pëlqimin tuaj, mos hezitoni të pyesni duke përdorur të dhënat e ofruara në seksionin Na Kontaktoni të kësaj politike të privatësisë.",
   "performance-of-contract-title": "Përmbushja e një Kontrate ose Transaksioni",
   "performance-of-contract-description-text": "Kur keni lidhur një kontratë ose transaksion me ne, ose me qëllim të ndërmarrjes së hapave përgatitorë përpara se ne të lidhim një kontratë ose transaksion me ju. Për shembull, nëse blini një produkt, shërbim ose abonim nga ne, mund të na duhet të përdorim informacionin tuaj personal dhe atë të pagesës për të përpunuar dhe dorëzuar porosinë tuaj.",
   "legitimate-interests-title": "Interesat Tona Legjitime",
   "legitimate-interests-description-text": "Kur vlerësojmë se është e nevojshme për interesat tona legjitime, si për shembull për të ofruar, operuar, përmirësuar dhe komunikuar shërbimet tona. Ne konsiderojmë se interesat tona legjitime përfshijnë kërkimin dhe zhvillimin, kuptimin e audiencës sonë, marketingun dhe promovimin e shërbimeve tona, masat e marra për të operuar shërbimet tona në mënyrë efikase, analizën e marketingut, si dhe masat e marra për të mbrojtur të drejtat dhe interesat tona ligjore.",
   "compliance-with-law-title": "Përputhshmëria me Ligjin",
   "compliance-with-law-description-text": "Në disa raste, ne mund të kemi një detyrim ligjor për të përdorur ose ruajtur informacionin tuaj personal. Raste të tilla mund të përfshijnë (por nuk kufizohen në) urdhra gjyqësorë, hetime penale, kërkesa qeveritare dhe detyrime rregullatore. Nëse keni ndonjë pyetje të mëtejshme lidhur me mënyrën se si ne ruajmë informacionin personal me qëllim përputhjen me ligjin, ju lutemi mos hezitoni të na kontaktoni duke përdorur të dhënat e ofruara në seksionin \"Na Kontaktoni\" të kësaj politike të privatësisë.",
   "eea-transfers-title": "Transferimet Ndërkombëtare Jashtë Zonës Ekonomike Evropiane (EEA)",
   "eea-transfers-description-text": "Ne do të sigurojmë që çdo transferim i informacionit personal nga vendet e Zonës Ekonomike Evropiane (EEA) drejt vendeve jashtë EEA-s të mbrohet nga masa mbrojtëse të përshtatshme, për shembull duke përdorur klauzola standarde të mbrojtjes së të dhënave të miratuara nga Komisioni Evropian, ose përdorimin e rregullave detyruese korporative apo mjeteve të tjera të pranuara ligjërisht.",
   "restrict-processing-rights-text": "Kufizimi: Ju keni të drejtën të kërkoni që ne të kufizojmë përpunimin e informacionit tuaj personal nëse (i) jeni të shqetësuar për saktësinë e informacionit tuaj personal; (ii) besoni se informacioni juaj personal është përpunuar në mënyrë të paligjshme; (iii) keni nevojë që ne ta mbajmë informacionin personal vetëm për qëllim të një pretendimi ligjor; ose (iv) ne jemi në proces të shqyrtimit të kundërshtimit tuaj në lidhje me përpunimin e bazuar në interesa legjitime.",
   "objecting-to-processing-text": "Kundërshtimi ndaj përpunimit: Ju keni të drejtën të kundërshtoni përpunimin e informacionit tuaj personal që bazohet në interesat tona legjitime ose në interesin publik. Nëse kjo ndodh, ne duhet të paraqesim arsye legjitime bindëse për përpunimin, të cilat mbizotërojnë mbi interesat, të drejtat dhe liritë tuaja, në mënyrë që të vazhdojmë me përpunimin e informacionit tuaj personal.",
   "data-portability-text": "Portabiliteti i të dhënave: Ju mund të keni të drejtën të kërkoni një kopje të informacionit personal që ne mbajmë për ju. Kur të jetë e mundur, ne do ta ofrojmë këtë informacion në format CSV ose në ndonjë format tjetër lehtësisht të lexueshëm nga makina. Ju mund të keni gjithashtu të drejtën të kërkoni që ne ta transferojmë këtë informacion personal tek një palë e tretë.",
   "deletion-rights-text": "Fshirja: Ju mund të keni të drejtën të kërkoni që ne të fshijmë informacionin personal që mbajmë për ju në çdo kohë, dhe ne do të ndërmarrim hapa të arsyeshëm për të fshirë informacionin tuaj personal nga regjistrimet tona aktuale. Nëse na kërkoni të fshijmë informacionin tuaj personal, ne do t'ju informojmë se si ndikon fshirja në përdorimin tuaj të faqeve tona të internetit apo produkteve dhe shërbimeve tona. Mund të ketë përjashtime nga kjo e drejtë për arsye ligjore specifike, të cilat, nëse janë të zbatueshme, do t'jua paraqesim në përgjigje të kërkesës suaj. Nëse ju ndërprisni ose fshini llogarinë tuaj, ne do të fshijmë informacionin tuaj personal brenda 45 ditëve nga fshirja e llogarisë suaj. Ju lutemi kini parasysh se motorët e kërkimit dhe palë të treta të ngjashme mund të ruajnë ende kopje të informacionit tuaj personal që është bërë publik të paktën një herë, si p.sh. disa informacione profili dhe komente publike, edhe pasi ta keni fshirë atë informacion nga shërbimet tona ose të keni çaktivizuar llogarinë tuaj.",
   "us-states-privacy-title": "Zbulime Shtesë për Përputhshmërinë me Ligjet e Privatësisë të Shteteve të SHBA-së.",
   "us-states-privacy-description-text": "Seksioni në vijim përfshin dispozita që përmbushin ligjet e privatësisë të këtyre shteteve (California, Colorado, Delaware, Florida, Virginia, dhe Utah) dhe zbatohet vetëm për banorët e atyre shteteve. Referencat specifike ndaj një shteti të caktuar (në një titull ose në tekst) janë vetëm një referencë ndaj ligjit të atij shteti dhe zbatohen vetëm për banorët e atij shteti. Gjuha që nuk është specifike për një shtet zbatohet për të gjitha shtetet e listuara më sipër.",
   "do-not-track-title": "Mos Gjurmo",
   "do-not-track-description-text": "Disa shfletues kanë një veçori \"Mos Gjurmo\" që ju lejon t'u tregoni faqeve të internetit se nuk dëshironi që aktivitetet tuaja në internet të gjurmohen. Aktualisht, ne nuk i përgjigjemi sinjaleve \"Mos Gjurmo\" të shfletuesit.",
   "do-not-track-standards-text": "Ne i përmbahemi standardeve të përcaktuara në këtë politikë privatësie, duke siguruar që të mbledhim dhe përpunojmë informacionin personal në mënyrë të ligjshme, të drejtë, transparente dhe me arsye legjitime e ligjore për ta bërë këtë.",
   "cookies-and-pixels-title": "Cookie-t dhe Pikselat",
   "cookies-and-pixels-description-text": "Në çdo kohë, ju mund të refuzoni cookie-t nga faqet tona nëse shfletuesi juaj e lejon këtë. Shumica e shfletuesve ju lejojnë të aktivizoni cilësime në shfletuesin tuaj për të refuzuar vendosjen e të gjitha ose disa cookie-ve. Rrjedhimisht, aftësia juaj për të kufizuar cookie-t bazohet vetëm në aftësitë e shfletuesit tuaj. Ju lutemi referojuni seksionit \"Cookie-t\" të kësaj politike privatësie për më shumë informacion.",
   "california-privacy-laws-title": "Ligjet e Privatësisë të California - CPPA",
   "california-privacy-financial-incentive-text": "Sipas Nenit 1798.83 të Kodit Civil të California-s, nëse jetoni në California dhe marrëdhënia juaj e biznesit me ne është kryesisht për qëllime personale, familjare ose shtëpiake, ju mund të na pyesni në lidhje me informacionin që ne ua zbulojmë organizatave të tjera për qëllimet e tyre të marketingut. Në përputhje me të drejtën tuaj për mosdiskriminim, ne mund t'ju ofrojmë disa stimuj financiarë të lejuar nga Ligji i California-s për Privatësinë e Konsumatorit dhe Ligji i California-s për të Drejtat e Privatësisë (së bashku, CCPA), të cilët mund të rezultojnë në çmime, tarifa ose nivele cilësie të ndryshme për mallrat ose shërbimet që ofrojmë. Çdo stimul financiar i lejuar nga CCPA që ne ofrojmë do të lidhet në mënyrë të arsyeshme me vlerën e informacionit tuaj personal, dhe ne do të sigurojmë kushte me shkrim që përshkruajnë qartë natyrën e një oferte të tillë. Pjesëmarrja në një program stimujsh financiarë kërkon pëlqimin tuaj paraprak (opt-in), të cilin mund ta revokoni në çdo kohë.",
   "california-privacy-request-info-text": "Sipas Nenit 1798.83 të Kodit Civil të California-s, nëse jetoni në California dhe marrëdhënia juaj e biznesit me ne është kryesisht për qëllime personale, familjare ose shtëpiake, ju mund të na pyesni në lidhje me informacionin që ne ua zbulojmë organizatave të tjera për qëllimet e tyre të marketingut. Për të bërë një kërkesë të tillë, ju lutemi na kontaktoni duke përdorur të dhënat e ofruara në këtë politikë privatësie, duke shënuar në rreshtin e subjektit \"Kërkesë për informacion privatësie për California\". Ju mund të bëni këtë lloj kërkese një herë në vit kalendarik. Ne do t'ju dërgojmë me email një listë të kategorive të informacionit personal që kemi zbuluar tek organizata të tjera për qëllimet e tyre të marketingut gjatë vitit të fundit kalendarik, së bashku me emrat dhe adresat e tyre. Jo i gjithë informacioni personal i ndarë në këtë mënyrë mbulohet nga Neni 1798.83 i Kodit Civil të California-s.",
   "california-notice-of-collection-title": "Njoftimi i California-s mbi Mbledhjen e të Dhënave",
   "california-notice-of-collection-intro-text": "Gjatë 12 muajve të fundit, ne kemi mbledhur kategoritë e mëposhtme të informacionit personal të përcaktuara në CCPA:",
   "ccpa-identifiers-text": "Identifikues, si emri, adresa e emailit, numri i telefonit, emri i llogarisë, adresa IP, dhe një ID ose numër i caktuar për llogarinë tuaj.",
   "ccpa-customer-records-text": "Të dhënat e klientit, si adresa e faturimit dhe e dërgesës, dhe të dhënat e kartës së kreditit ose debitit.",
   "ccpa-demographics-text": "Të dhëna demografike, si mosha ose gjinia juaj. Kjo kategori përfshin të dhëna që mund të kualifikohen si klasifikime të mbrojtura sipas ligjeve të tjera të California-s ose ligjeve federale.",
   "ccpa-commercial-info-text": "Informacion komercial, si historiku i produkteve ose shërbimeve dhe blerjet.",
   "ccpa-internet-activity-text": "Aktiviteti në internet, si ndërveprimet tuaja me shërbimin tonë.",
   "ccpa-audio-visual-text": "Të dhëna audio ose vizuale, si fotografi ose video që ndani me ne ose publikoni në shërbim.",
   "ccpa-geolocation-text": "Të dhëna gjeolokacioni.",
   "ccpa-employment-education-text": "Të dhëna punësimi dhe arsimimi, si të dhënat që jepni kur aplikoni për një vend pune pranë nesh.",
   "ccpa-inferences-text": "Konkluzione, si për shembull informacion mbi interesat, preferencat dhe gjërat tuaja të preferuara.",
   "california-notice-of-collection-outro-text": "Për më shumë informacion mbi informacionin që mbledhim, përfshirë burimet nga të cilat marrim informacion, shikoni seksionin \"Informacioni që Mbledhim\". Ne mbledhim dhe përdorim këto kategori të informacionit personal për qëllimet e biznesit të përshkruara në seksionin \"Mbledhja dhe Përdorimi i Informacionit\", përfshirë për të ofruar dhe menaxhuar Shërbimin tonë.",
   "right-to-know-delete-title": "E Drejta për të Ditur dhe për të Fshirë",
   "right-to-know-delete-intro-text": "Ju keni të drejtën të fshini informacionin tuaj personal që kemi mbledhur dhe të dini informacione të caktuara rreth praktikave tona të të dhënave gjatë 12 muajve të fundit. Në veçanti, ju keni të drejtën të kërkoni nga ne sa vijon:",
   "know-delete-categories-collected-text": "Kategoritë e informacionit personal që kemi mbledhur për ju;",
   "know-delete-categories-sources-text": "Kategoritë e burimeve nga të cilat u mblodh informacioni personal;",
   "know-delete-categories-disclosed-text": "Kategoritë e informacionit personal në lidhje me ju që kemi zbuluar për një qëllim afarist ose që kemi shitur;",
   "know-delete-third-parties-text": "Kategoritë e palëve të treta të cilave u është zbuluar informacioni personal për një qëllim afarist ose të cilave u është shitur;",
   "know-delete-business-purpose-text": "Qëllimi afarist ose tregtar për mbledhjen ose shitjen e informacionit personal; dhe",
   "know-delete-specific-pieces-text": "Pjesët specifike të informacionit personal që kemi mbledhur në lidhje me ju.",
   "right-to-know-delete-outro-text": "Për të ushtruar cilëndo nga këto të drejta, ju lutemi na kontaktoni duke përdorur të dhënat e kontaktit të ofruara në këtë politikë të privatësisë.",
   "shine-the-light-title": "Ndriço Dritën",
   "contact-us-title": "Na Kontaktoni",
   "customer-service-label": "Shërbimi i Klientit",
   "privacy-contact-us-description-text": "Për çdo pyetje ose shqetësim në lidhje me privatësinë tuaj, mund të na kontaktoni duke përdorur të dhënat e mëposhtme:",
   "shine-the-light-description-text": "Përveç të drejtave të diskutuara më sipër, ju keni të drejtë të na kërkoni informacion në lidhje me mënyrën se si ne ndajmë informacione të caktuara personale, siç përcaktohet nga ligji në fuqi, me palë të treta dhe filiale për qëllimet e tyre të marketingut të drejtpërdrejtë.",
   "shine-the-light-request-text": "Për të marrë këtë informacion, na dërgoni një kërkesë duke përdorur të dhënat e kontaktit të ofruara në këtë politikë privatësie. Kërkesat duhet të përfshijnë \"Privacy Rights Request\" në rreshtin e parë të përshkrimit, si dhe të përfshijnë emrin tuaj, adresën, qytetin, shtetin dhe kodin postar.",

   // My Performance (Staff)
   "loading-ellipsis-text": "Duke u ngarkuar...",
   "failed-to-load-modules-error": "Ngarkimi i moduleve dështoi",
   "failed-to-load-details-error": "Ngarkimi i detajeve dështoi",
   "my-assessments-title": "Vlerësimet e mia",
   "my-assessments-description-text":
      "Filloni duke zgjedhur një vlerësim për të parë modulet dhe të dhënat e performancës së tij.",
   "no-assessments-yet-title": "Duket se nuk ka ende vlerësime!",
   "no-assessments-yet-description-text":
      "Kur vlerësimet të kenë rezultate, ato do të shfaqen këtu për t'i eksploruar.",
   "modules-in-assessment-label": "Modulet në këtë vlerësim:",
   "choose-module-to-see-results-text": "Zgjidhni një modul për të parë rezultatet",
   "status-closed-label": "Mbyllur",
   "select-module-alt-text": "Zgjidh modulin",
   "select-module-results-text": "Zgjidhni një modul nga lista për të shfaqur rezultatet e tij",
   "target-label": "Objektivi",
   "action-plan-label": "Plani i veprimit",
   "assessment-preview-title": "Pamja paraprake e vlerësimit",
   "no-data-for-assessment-text": "Aktualisht nuk ka të dhëna të disponueshme për këtë vlerësim",
   "my-upcoming-tasks-title": "Detyrat e mia të ardhshme",
   "my-improvement-over-time-title": "Përmirësimi im me kalimin e kohës",
   "no-data-for-survey-text": "Aktualisht nuk ka të dhëna të disponueshme për këtë sondazh",
   "your-score-label": "Rezultati juaj",
   "target-score-label": "Rezultati objektiv",
   "previous-label": "E mëparshmja",
   "next-label": "Tjetra",

   // Task Management (Staff)
   "task-management-title": "Menaxhimi i detyrave",
   "tasks-tab-label": "Detyrat",
   "assigned-modules-title": "Modulet e caktuara",
   "collapse-all-button": "Mbyll të gjitha",
   "expand-all-button": "Zgjero të gjitha",
   "assigned-tasks-title": "Detyrat e Caktuara",
   "board-tab-label": "Tabela",
   "timeline-tab-label": "Kronologjia",
   "no-available-modules-text": "Nuk ka module të disponueshme për këtë vlerësim",
   "no-available-tasks-text": "Nuk ka detyra të disponueshme për këtë vlerësim",
   "go-alt-text": "Shko",
   "view-alt-text": "Shiko",
   "notes-alt-text": "Shënime",
   "change-status-to-label": "Ndrysho statusin në:",
   "priority-low-label": "E ulët",
   "priority-medium-label": "Mesatare",
   "priority-high-label": "E lartë",
   "priority-urgent-label": "Urgjente",
   "show-less-link": "Shfaq më pak",
   "monthly-toggle-label": "Mujore",
   "quarterly-toggle-label": "Tremujore",
   "week-prefix-text": "Java",
   "to-do-status": "Për të bërë",
   "tasks-column-header": "Detyrat",
   "linked-questions-prefix-text": "Pyetjet e lidhura:",
   "assigned-status": "Caktuar",
   "action-plan-dashboard-title": "Paneli i planit të veprimit",
   "action-plan-for-label": "Plani i veprimit për",

   "role-vendor-label": "Furnizues",
   "switch-role-label": "Ndrysho rolin",
   "current-role-label": "Roli aktual",
   "switch-role-error-description": "Nuk arritëm ta ndryshojmë rolin tuaj, ju lutemi provoni sërish.",
   "approver-role-added-to-existing-user-description":
      "Ky përdorues kishte tashmë një llogari, prandaj nuk u dërgua asnjë email ftese. Ai kyçet me fjalëkalimin ekzistues dhe kalon në rolin e Aprovuesit.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "Eksperti",
   "expert-role-enabled-success-title": "Roli i Ekspertit u shtua",
   "expert-role-enabled-success-description": "Ky aprovues tani mund të punojë edhe si ekspert.",
   "expert-role-disabled-success-title": "Roli i Ekspertit u hoq",
   "expert-role-disabled-success-description": "Ky aprovues nuk ka më rolin e ekspertit.",
   "expert-role-toggle-error-description": "Nuk mundëm të përditësojmë rolin e ekspertit, ju lutemi provoni sërish.",
   "expert-role-not-found-description": "Ky aprovues nuk ekziston më. Lista u rifreskua.",
   "approver-role-column": "Aprovuesi",
   "approver-role-enabled-success-title": "Roli i Aprovuesit u shtua",
   "approver-role-enabled-success-description": "Ky ekspert tani mund të punojë edhe si aprovues.",
   "approver-role-disabled-success-title": "Roli i Aprovuesit u hoq",
   "approver-role-disabled-success-description": "Ky ekspert nuk ka më rolin e aprovuesit.",
   "approver-role-toggle-error-description": "Nuk mundëm të përditësojmë rolin e aprovuesit, ju lutemi provoni sërish.",
   "approver-role-not-found-description": "Ky ekspert nuk ekziston më. Lista u rifreskua.",
   "expert-exists-redirect-title": "Tashmë Ekspert",
   "expert-exists-redirect-description":
      "Ky email i përket tashmë një Eksperti. Po ju çojmë te lista e Ekspertëve, ku mund t'i jepni rolin e Aprovuesit.",

   "linked-assessment-edit-notice":
      "Ky vlerësim është i lidhur me një tjetër, prandaj mund të shtohen vetëm raunde të reja. Çdo raund që shtoni këtu i shtohet edhe vlerësimit të lidhur.",
   "start-date-in-past-validation": "Data e fillimit nuk mund të jetë në të kaluarën.",
   "end-date-must-be-future-validation": "Data e mbarimit duhet të jetë në të ardhmen.",
   "round-overlaps-another-round-validation": "Ky raund mbivendoset me një raund tjetër.",
   "view-all-notifications-button": "Shiko të gjitha njoftimet",
   "notifications-page-title": "Njoftimet",
   "notifications-empty-title": "Ende nuk ka njoftime",
   "notifications-unread-empty-title": "Nuk ka njoftime të palexuara",
   "notifications-empty-text": "Jeni në rrjedhë të të gjithave. Njoftimet e reja do të shfaqen këtu.",
   "guided-assessment-completed-prefix-text": "Vlerësimi juaj i udhëzuar",
   "guided-assessment-completed-suffix-text": "është përfunduar.",
   "notification-title-org-signup": "Regjistrim i ri organizate",
   "notification-title-expert-signup": "Regjistrim i ri eksperti",
   "notification-title-workspace-join-request": "Kërkesë e organizatës për t'u bashkuar në hapësirën e punës",
   "notification-title-workspace-approved": "Kërkesa për hapësirën e punës u miratua",
   "notification-title-workspace-rejected": "Kërkesa për hapësirën e punës u refuzua",
   "notification-title-guided-request": "Kërkesë për vlerësim të udhëzuar",
   "notification-title-guided-approved": "Kërkesa për vlerësim të udhëzuar u miratua",
   "notification-title-guided-rejected": "Kërkesa për vlerësim të udhëzuar u refuzua",
   "notification-title-guided-completed": "Vlerësimi i udhëzuar u përfundua",
   "notification-title-self-assigned": "Vetëvlerësim i ri i caktuar",
   "notification-title-self-unassigned": "Vetëvlerësimi u hoq",
   "notification-title-expert-assigned": "Caktuar në vlerësim të udhëzuar",
   "notification-title-ticket-created": "Tiketë e re u krijua",
   "notification-title-ticket-updated": "Tiketa u përditësua",
   "notification-title-submission-review": "Dorëzimi gati për shqyrtim",
   "notification-title-submission-approved-by-approver": "Dorëzimi u miratua nga miratuesi",
   "notification-title-submission-rejected-by-approver": "Dorëzimi u refuzua nga miratuesi",
   "notification-title-module-assigned": "Modul i ri i caktuar",
   "notification-title-module-unassigned": "Moduli u hoq",
   "notification-title-submission-approved": "Dorëzimi u miratua",
   "notification-title-submission-rejected": "Dorëzimi u refuzua",
   "notification-title-submission-approval": "Dorëzimi gati për miratim",
   "mark-as-read-label": "Shëno si të lexuar",
   "notification-actions-label": "Veprimet e njoftimit"
};
